import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";

import {
  fetchGet,
  isInteger,
  getDateForSrch,
  get12to24hourtme,
  getDateFormatted2,
  getDateFormatted3
} from "../../common/common";

import store from "../../store";

import LineInp from "../common/lineinput";
import Radio from "../common/radio";
import RadioBlock from "../common/radioBlock";
import Check from "../common/checkbox";
import Header from "../header/header";
import Footer from "../header/footer";
import HeaderSTA from "../header/headerSTA";
import FooterSTA from "../header/footerSTA";
import { apiUrl, color } from "../common/constants";
// import { Couponinfo, CouponArrow, Securelogo, WarningIcon } from '../common/icons/svg';
// import {
//   GiftIcon,
//   LockIcon,
//   PickupIcon,
//   DropoffIcon,
//   Busicon,
//   Clock,
// } from "../common/icons/svg";
import PastInput from "../pasthistoryInput/pasthistoryinput";
import {
  updateCheckoutDet,
  updateUserInfo,
  couponListDetails,
  updateHeaderText,
  updateOnwardFare,
  updateLevyAndConcession,
} from "../../actions/search-actions";
import PgBlock from "../common/pgBlock";
import { renderImg } from "../common/icons/img";
import LineInpDrop from "../common/lineInpDrop";
import { PostRequest } from "../common/helper";
import HeaderNew from "../header/HeaderNew";

class Checkout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoad: true,
      queryData: "{}",
      mobile: window.customerProfile ? window.customerProfile.MobileNumber : "",
      email: window.customerProfile ? window.customerProfile.EmailID : "",
      payopt: "",
      pgname: "",
      insuranceVal: 0,
      insurance: "on",
      onwardFare: 0,
      onwardGst: 0,
      onwardSc: 0,
      returnFare: 0,
      returnGst: 0,
      returnSc: 0,
      onwardPickcharges: 0,
      onwardDropcharges: 0,
      returnPickcharges: 0,
      returnDropcharges: 0,
      onwardRoundTripDiscount: 0,
      returnRoundTripDiscount: 0,
      onwardConvenienceCharge: 0,
      returnConvenienceCharge: 0,
      onwardInsuranceAmt: 0,
      returnInsuranceAmt: 0,
      roundTripdiscount: 0,
      discount: 0,
      isMobile: 0,
      activeTnC: false,
      discountAmt: 0,
      redeemCoupon: false,
      OTP: 0,
      CouponID: 0,
      CouponID2: 0,
      CouponID3: 0,
      CouponDiscount: 0,
      CouponDiscountAmt: 0,
      CouponDiscountAmt2: 0,
      CouponDiscountAmt3: 0,
      CouponDiscountType: "",
      CouponDiscountType2: "",
      CouponDiscountType3: "",
      customerGSTN:
        window.customerProfile && window.customerProfile.GSTN ? "on" : "off",
      companyGSTNo: window.customerProfile ? window.customerProfile.GSTN : "",
      regCompanyName: window.customerProfile
        ? window.customerProfile.GSTCompany
        : "",
      validCouponName: "",
      buttonLabel: "APPLY",
      countryCode: window.country_code,
      countryCodeTYpe: window.msurl !== 'shwesanthu.com' ? "indian" : "myanmar",
      prepaidcoupon: "",
      loyaltyCoupon: "",
      marketingCoupon: "",
      updatedStax: 0,
      discountOnBase: 0,
      discountOnTotal: 0,
      bankChargesPer: 0,
      bankCharges: 0,
      showConfirm: false,
      showLoader: false,
      payBtnDisable: false,
      getCouponsDetails: false,
      showCouponblock: false,
      showPayeeBlock: true,
      activeCouponType: "prepaid",
      loyaltyCouponShow: 0,
      prepaidCouponShow: 1,
      discountCouponShow: 0,
      activeNavTab: "userdetail",
      activeRtTab: "farebreakup",
      amountToPay: 0,
      travellerlist: false,
      payeedetail: false,
      isRoundtrip: false,
      showonwardsec: false,
      showreturnsec: false,
      customerName: window.customerProfile
        ? window.customerProfile.CustomerName
        : "",
      customerAge: window.customerProfile ? window.customerProfile.Age : 0,
      customerGender: window.customerProfile
        ? window.customerProfile.Gender === "M"
          ? "Male"
          : "Female"
        : "",

      alerterror: "",
      totalcouponAmount: 0,
      removeCoupon: false,
      removeCouponName: "",
      redeemCouponsList: "",
      bookingType: "",
      showServiceCharge: window.showServiceCharge,
      onwardTripSrt: 0,
      returnTripSrt: 0,
      onwardTripSrtConcession: 0,
      returnTripSrtConcession: 0,
      checkTandC: true,
      alredaySelPg: '',
      orderTimestamp: '',
      loginType: 'guest',
      password: '',
      openDrop: {
        'onward': { gender: false, concessionType: false, idCardType: false, country: false }, 'return': { gender: false, concessionType: false, idCardType: false, country: false },
      },
      openDropSeatNo: '',
      genderData: ['Male', 'Female', 'Others'],
      concessionData: [{ index: 0, value: 'General Public' }],
      nationality: ['India'],
      idCardData: ['PAN', 'AADHAR'],
      updatedOnwardFare: 0,
      updatedReturnFare: 0,
      onwardLevyAmount: 0,
      returnLevyAmount: 0,
      onwardConAmt: 0,
      returnConAmt: 0,
      onwardLevyConcData: {},
      returnLevyConcData: {},
      onwardConcList: [],
      tempOnwardConcList: [],
      returnConcList: [],
      tempReturnConcList: [],
      onwardConcessionType: {},
      returnConcessionType: {},
      tempOnwardConcessionType: {},
      tempReturnConcessionType: {},
      levyConcDetailsO: {},
      levyConcDetailsR: {},
      conAmtSeatsO: [],
      selMaxCon: [],
      tempMaxCon: [],
      concessionFilterFor: { age: false, gender: false },
      onwardConcessionUsed: [],
      returnConcessionUsed: [],
    };
  }

  componentDidMount() {
    var urlParams = new URLSearchParams(window.location.search);
    var updatedOpDiscount = urlParams.get("opDiscount");
    if (updatedOpDiscount) {
      this.setState({ showConfirm: true });
    }
    if (this.props.search.order.length === 0 || updatedOpDiscount) {
      const url =
        window.url +
        apiUrl.orderDetails +
        "?token=" +
        this.props.match.params.token;
      const that = this;
      that.setState({ showLoader: true });
      fetchGet(url)
        .then(function (data) {
          that.setState({ showLoader: false });
          if (data.return && data.return.routeCode) {
            that.callLevyConc(data.return.routeCode, 'return');
          }
          that.callLevyConc(data.onward.routeCode);
          let onwardFare = that.state.onwardFare;
          let onwardGst = that.state.onwardGst;
          let onwardSc = that.state.onwardSc;
          let returnFare = that.state.returnFare;
          let returnGst = that.state.returnGst;
          let returnSc = that.state.returnSc;
          let discount = that.state.discount;
          let discountAmt = that.state.discountAmt;
          let onwardPickcharges = that.state.onwardPickcharges;
          let onwardDropcharges = that.state.onwardDropcharges;
          let returnPickcharges = that.state.returnPickcharges;
          let returnDropcharges = that.state.returnDropcharges;
          let onwardRoundTripDiscount = that.state.onwardRoundTripDiscount;
          let returnRoundTripDiscount = that.state.returnRoundTripDiscount;
          let onwardConvenienceCharge = that.state.onwardConvenienceCharge;
          let returnConvenienceCharge = that.state.returnConvenienceCharge;
          let isRoundtrip = false;
          let headertext1 = "";
          let headertext2 = "";
          let bookingType = that.state.bookingType;
          let showServiceCharge = that.state.showServiceCharge;
          let onwardTripSrt = 0;
          let onwardTripSrtConcession = 0;
          let returnTripSrt = 0;
          let returnTripSrtConcession = 0;
          let onwardLevyAmount = 0;
          let returnLevyAmount = 0;
          Object.keys(data.onward.seatDetails).forEach((el) => {
            //data.onward.seatDetails[el]["name"] = "";
            //data.onward.seatDetails[el]["age"] = "";
            data.onward.seatDetails[el]["age"] = '';
            data.onward.seatDetails[el].conAmt = 0;
            data.onward.seatDetails[el].concessionType =
              data.onward.seatDetails[el].concessionType || "";
            data.onward.seatDetails[el].idCardNo = data.onward.seatDetails[el].idCardNo || "";
            data.onward.seatDetails[el].idCardType = data.onward.seatDetails[el].idCardType || "";
            data.onward.seatDetails[el].nationality = data.onward.seatDetails[el].nationality || "India";
            data.onward.seatDetails[el]["isMale"] =
              data.onward.seatDetails[el].gender &&
              data.onward.seatDetails[el].gender.toLowerCase() === "m";
            data.onward.seatDetails[el]["isFemale"] =
              data.onward.seatDetails[el].gender &&
              data.onward.seatDetails[el].gender.toLowerCase() === "f";
            data.onward.seatDetails[el].gender = data.onward.seatDetails[el].gender === 'M' ? 'Male' : data.onward.seatDetails[el].gender === 'F' ? 'Female' : data.onward.seatDetails[el].gender;
            onwardFare += parseInt(data.onward.seatDetails[el].fare, 10);
            onwardGst += parseInt(data.onward.seatDetails[el].serviceTax, 10);
            // if (onwardConcList && onwardConcList.length > 0) {
            //   onwardConcessionType[el] = that.updateConcessionListO(onwardConcList, data.onward.seatDetails[el].gender);
            // }
          });
          onwardSc += data.onward.serviceCharge
            ? parseInt(data.onward.serviceCharge, 10)
            : 0;
          discount += parseInt(data.onward.discountAmount, 10);

          if (
            data.return.seatDetails &&
            Object.keys(data.return.seatDetails).length > 0
          ) {
            Object.keys(data.return.seatDetails).forEach((el) => {
              //data.return.seatDetails[el]["name"] = "";
              //data.return.seatDetails[el]["age"] = "";
              data.return.seatDetails[el]["age"] = '';
              data.return.seatDetails[el].conAmt = 0;
              data.return.seatDetails[el].concessionType =
                data.return.seatDetails[el].concessionType || "";
              data.return.seatDetails[el].idCardNo = data.return.seatDetails[el].idCardNo || "";
              data.return.seatDetails[el].idCardType = data.return.seatDetails[el].idCardType || "";
              data.return.seatDetails[el].nationality = data.return.seatDetails[el].nationality || "India";
              data.return.seatDetails[el]["isMale"] =
                data.return.seatDetails[el].gender &&
                data.return.seatDetails[el].gender.toLowerCase() === "m";
              data.return.seatDetails[el]["isFemale"] =
                data.return.seatDetails[el].gender &&
                data.return.seatDetails[el].gender.toLowerCase() === "f";
              data.return.seatDetails[el].gender = data.return.seatDetails[el].gender === 'M' ? 'Male' : data.return.seatDetails[el].gender === 'F' ? 'Female' : data.return.seatDetails[el].gender;
              returnFare += parseInt(data.return.seatDetails[el].fare, 10);
              returnGst += parseInt(data.return.seatDetails[el].serviceTax, 10);
            });
            returnSc += data.return.serviceCharge
              ? parseInt(data.return.serviceCharge, 10)
              : 0;
            discount += parseInt(data.return.discountAmount, 10);
            isRoundtrip = true;
          }

          onwardPickcharges = parseInt(data.onward.pickupcharge, 10);
          returnPickcharges = parseInt(data.return.pickupcharge2, 10);
          onwardDropcharges = parseInt(data.onward.dropoffcharge, 10);
          returnDropcharges = parseInt(data.return.dropoffcharge2, 10);
          onwardRoundTripDiscount = parseInt(
            data.onward.onwardRoundtripDiscont,
            10
          );
          returnRoundTripDiscount = parseInt(
            data.return.returnRoundtripDiscont,
            10
          );
          onwardConvenienceCharge = parseInt(data.onward.ConvenienceCharge);
          returnConvenienceCharge = parseInt(data.return.ConvenienceCharge2);
          const count =
            data.onward.seats.length +
            (data.return && data.return.seats ? data.return.seats.length : 0);
          const roundTripdiscount = (onwardRoundTripDiscount + returnRoundTripDiscount) > 0 ? (onwardRoundTripDiscount + returnRoundTripDiscount) : 0


          const insurance = data.showInsurance ? "on" : "off";
          const insuranceVal = data.showInsurance ? count * data.insuranceAmt : 0;
          const onwardInsuranceAmt = data.showInsurance ? data.onward.seats.length * data.insuranceAmt : 0;
          const returnInsuranceAmt = data.showInsurance ? (data.return && data.return.seats ? data.return.seats.length : 0) * data.insuranceAmt : 0;

          const queryData = JSON.stringify({
            hop: "direct",
            mode: returnFare ? "roundtrip" : "oneway",
            otaId: "0",
            FromCityId: "",
            ToCityId: "",
            fromCityName: data.onward.fromCity,
            toCityName: data.onward.toCity,
            JourneyDate: data.onward.journeyDate,
            NoOfSeats: false,
            SearchId: 0,
            returnDate: false,
          });
          discountAmt =
            parseInt(data.onward.discountAmount, 10) +
            parseInt(data.return.discountAmount, 10);

          bookingType = data.bookingType;
          showServiceCharge = data.showServiceCharge;

          that.setState({
            insurance,
            insuranceVal,
            onwardInsuranceAmt,
            returnInsuranceAmt,
            onwardFare,
            onwardGst,
            onwardSc,
            returnFare,
            returnGst,
            returnSc,
            queryData,
            discount,
            discountAmt,
            onwardPickcharges,
            onwardDropcharges,
            returnPickcharges,
            returnDropcharges,
            onwardRoundTripDiscount,
            returnRoundTripDiscount,
            onwardConvenienceCharge,
            returnConvenienceCharge,
            roundTripdiscount,
            isRoundtrip,
            bookingType,
            showServiceCharge,
            onwardTripSrt,
            onwardTripSrtConcession,
            returnTripSrt,
            returnTripSrtConcession,
            updatedOnwardFare: onwardFare,
            updatedReturnFare: returnFare,
            onwardLevyAmount,
            returnLevyAmount,
          });

          that.setDefaultpg(data.pgDetails);
          store.dispatch(updateCheckoutDet(data));
          that.deafultSelData(data);
          headertext1 += data.onward.fromCity + " ";
          headertext1 += "- " + data.onward.toCity;
          headertext2 += moment(data.onward.journeyDate + ' ' + data.onward.boardingTime).format("HH:mm") + ", ";
          headertext2 += getDateFormatted2(data.onward.journeyDate) + " - ";
          headertext2 += moment(data.onward.arrivalDate + ' ' + data.onward.arrivalTime).format("HH:mm") + ", ";
          headertext2 += getDateFormatted2(data.onward.arrivalDate);
          store.dispatch(
            updateHeaderText({ text1: headertext1, text2: headertext2 })
          );
          window.customerProfile && window.customerProfile.MobileNumber
            ? that.apiCouponListNew()
            : "";
          window.customerProfile ? that.storePassDetails() : "";
        })
        .catch(function (error) {
          that.setState({
            showLoader: false,
            alerterror:
              "Sorry we faced some issues processing your request. Please check if you are connected to a stable internet and retry.",
          });

          console.log(error);
        });
    } else {

      const ord = this.props.search.order;
      if (ord.return && ord.return.routeCode) {
        this.callLevyConc(ord.return.routeCode, 'return');
      }
      this.callLevyConc(ord.onward.routeCode);
      let onwardFare = this.state.onwardFare;
      let onwardGst = this.state.onwardGst;
      let onwardSc = this.state.onwardSc;
      let returnFare = this.state.returnFare;
      let returnGst = this.state.returnGst;
      let returnSc = this.state.returnSc;
      let discount = this.state.discount;
      let onwardPickcharges = this.state.onwardPickcharges;
      let onwardDropcharges = this.state.onwardDropcharges;
      let returnPickcharges = this.state.returnPickcharges;
      let returnDropcharges = this.state.returnDropcharges;
      let onwardRoundTripDiscount = this.state.onwardRoundTripDiscount;
      let returnRoundTripDiscount = this.state.returnRoundTripDiscount;
      let onwardConvenienceCharge = this.state.onwardConvenienceCharge;
      let returnConvenienceCharge = this.state.returnConvenienceCharge;
      let isRoundtrip = false;
      let headertext1 = "";
      let headertext2 = "";
      let onwardTripSrt = 0;
      let onwardTripSrtConcession = 0;
      let returnTripSrt = 0;
      let returnTripSrtConcession = 0;
      let onwardLevyAmount = 0;
      let returnLevyAmount = 0;
      headertext1 += ord.onward.fromCity + " ";
      headertext1 += "- " + ord.onward.toCity;
      headertext2 += moment(ord.onward.journeyDate + ' ' + ord.onward.boardingTime).format("HH:mm") + ", ";
      headertext2 += getDateFormatted2(ord.onward.journeyDate) + " - ";
      headertext2 += moment(ord.onward.arrivalDate + ' ' + ord.onward.arrivalTime).format("HH:mm") + ", ";
      headertext2 += getDateFormatted2(ord.onward.arrivalDate);
      store.dispatch(
        updateHeaderText({ text1: headertext1, text2: headertext2 })
      );
      Object.keys(ord.onward.seatDetails).forEach((el) => {
        //ord.onward.seatDetails[el]["name"] = "";
        //ord.onward.seatDetails[el]["age"] = "";
        ord.onward.seatDetails[el].age = '';
        ord.onward.seatDetails[el].conAmt = 0;
        ord.onward.seatDetails[el].concessionType =
          ord.onward.seatDetails[el].concessionType || "";
        ord.onward.seatDetails[el].idCardNo = ord.onward.seatDetails[el].idCardNo || "";
        ord.onward.seatDetails[el].idCardType = ord.onward.seatDetails[el].idCardType || "";
        ord.onward.seatDetails[el].nationality = ord.onward.seatDetails[el].nationality || "India";
        ord.onward.seatDetails[el]["isMale"] =
          ord.onward.seatDetails[el].gender &&
          ord.onward.seatDetails[el].gender.toLowerCase() === "m";
        ord.onward.seatDetails[el]["isFemale"] =
          ord.onward.seatDetails[el].gender &&
          ord.onward.seatDetails[el].gender.toLowerCase() === "f";
        ord.onward.seatDetails[el].gender = ord.onward.seatDetails[el].gender === 'M' ? 'Male' : ord.onward.seatDetails[el].gender === 'F' ? 'Female' : ord.onward.seatDetails[el].gender;
        onwardFare += ord.onward.seatDetails[el].fare;
        onwardGst += ord.onward.seatDetails[el].serviceTax
          ? parseInt(ord.onward.seatDetails[el].serviceTax, 10)
          : 0;
      });
      onwardSc += ord.onward.serviceCharge
        ? parseInt(ord.onward.serviceCharge, 10)
        : 0;
      discount += ord.onward.discountAmount
        ? parseInt(ord.onward.discountAmount, 10)
        : 0;
      if (
        ord.return &&
        ord.return.seatDetails &&
        Object.keys(ord.return.seatDetails).length > 0
      ) {

        Object.keys(ord.return.seatDetails).forEach((el) => {
          //ord.return.seatDetails[el]["name"] = "";
          //ord.return.seatDetails[el]["age"] = "";
          ord.return.seatDetails[el].age = '';
          ord.return.seatDetails[el].conAmt = 0;
          ord.return.seatDetails[el].concessionType =
            ord.return.seatDetails[el].concessionType || "";
          ord.return.seatDetails[el].idCardNo = ord.return.seatDetails[el].idCardNo || "";
          ord.return.seatDetails[el].idCardType = ord.return.seatDetails[el].idCardType || "";
          ord.return.seatDetails[el].nationality = ord.return.seatDetails[el].nationality || "India";
          ord.return.seatDetails[el]["isMale"] = +
            ord.return.seatDetails[el].gender &&
            ord.return.seatDetails[el].gender.toLowerCase() === "m";
          ord.return.seatDetails[el]["isFemale"] =
            ord.return.seatDetails[el].gender &&
            ord.return.seatDetails[el].gender.toLowerCase() === "f";
          ord.return.seatDetails[el].gender = ord.return.seatDetails[el].gender === 'M' ? 'Male' : ord.return.seatDetails[el].gender === 'F' ? 'Female' : ord.return.seatDetails[el].gender;

          returnFare += ord.return.seatDetails[el].fare;
          returnGst += ord.return.seatDetails[el].serviceTax
            ? parseInt(ord.return.seatDetails[el].serviceTax, 10)
            : 0;
        });
        returnSc += ord.return.serviceCharge
          ? parseInt(ord.return.serviceCharge, 10)
          : 0;
        discount += ord.return.discountAmount
          ? parseInt(ord.return.discountAmount, 10)
          : 0;
        isRoundtrip = true;
      }
      onwardPickcharges = parseInt(ord.onward.pickupcharge, 10);
      onwardDropcharges = parseInt(ord.onward.dropoffcharge, 10);
      onwardRoundTripDiscount = parseInt(ord.onward.onwardRoundtripDiscont, 10);
      onwardConvenienceCharge = parseInt(ord.onward.ConvenienceCharge, 10);

      if (ord.return) {
        returnPickcharges = parseInt(ord.return.pickupcharge2, 10);
        returnDropcharges = parseInt(ord.return.dropoffcharge2, 10);
        returnRoundTripDiscount = parseInt(
          ord.return.returnRoundtripDiscont,
          10
        );
        returnConvenienceCharge = parseInt(ord.return.ConvenienceCharge2, 10);
      }
      const roundTripdiscount = (onwardRoundTripDiscount + returnRoundTripDiscount > 0) ? (onwardRoundTripDiscount + returnRoundTripDiscount) : 0;
      const count =
        ord.onward.seats.length +
        (ord.return && ord.return.seats ? ord.return.seats.length : 0);
      const insurance = ord.showInsurance ? "on" : "off";
      const insuranceVal = ord.showInsurance ? count * ord.insuranceAmt : 0;
      const onwardInsuranceAmt = ord.showInsurance ? ord.onward.seats.length * ord.insuranceAmt : 0;
      const returnInsuranceAmt = (ord.showInsurance && ord.return && ord.return.seats) ? ord.return.seats.length * ord.insuranceAmt : 0;

      const queryData = JSON.stringify({
        hop: "direct",
        mode: returnFare ? "roundtrip" : "oneway",
        otaId: "0",
        FromCityId: "",
        ToCityId: "",
        fromCityName: ord.onward.fromCity,
        toCityName: ord.onward.toCity,
        JourneyDate: ord.onward.journeyDate,
        NoOfSeats: false,
        SearchId: 0,
        returnDate: false,
      });

      let discountAmt;
      if (ord.return && ord.return.discountAmount) {
        discountAmt =
          parseInt(ord.onward.discountAmount, 10) +
          parseInt(ord.return.discountAmount, 10);
      } else {
        discountAmt = ord.onward.discountAmount;
      }
      this.setDefaultpg(ord.pgDetails);
      this.setState({
        insurance,
        insuranceVal,
        onwardInsuranceAmt,
        returnInsuranceAmt,
        onwardFare,
        onwardGst,
        onwardSc,
        returnFare,
        returnGst,
        returnSc,
        queryData,
        discount,
        discountAmt,
        onwardPickcharges,
        onwardDropcharges,
        returnPickcharges,
        returnDropcharges,
        onwardRoundTripDiscount,
        returnRoundTripDiscount,
        onwardConvenienceCharge,
        returnConvenienceCharge,
        roundTripdiscount,
        isRoundtrip,
        onwardTripSrt,
        onwardTripSrtConcession,
        returnTripSrt,
        returnTripSrtConcession,
        updatedOnwardFare: onwardFare,
        updatedReturnFare: returnFare,
        onwardLevyAmount,
        returnLevyAmount,
      });
      window.customerProfile && window.customerProfile.MobileNumber
        ? this.apiCouponListNew()
        : "";
      window.customerProfile ? this.storePassDetails() : "";
    }
    window.addEventListener("click", (event) => {
      const target = event.target;
      if (target.tagName.toLowerCase() !== 'input') {
        this.toggleDrop("outside_click");
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.activeNavTab === "payment") {
      this.updateSeatDetails();
    }
    if (prevState.levyConcDetailsO !== this.state.levyConcDetailsO) {
      if (this.state.levyConcDetailsO && Object.keys(this.state.levyConcDetailsO).length > 0) {
        let onward = this.props.search.order.onward;
        let routeCode = onward.routeCode;
        let seatDetails = onward.seatDetails;
        let onwardLevyAmount = 0;
        let onwardLevyConcData = this.state.levyConcDetailsO[routeCode];
        let onwardConcList = onwardLevyConcData.ConcessionList;
        let tempOnwardConcList = onwardConcList;
        Object.keys(seatDetails).forEach((el) => {
          this.updateOnwardLevy(seatDetails[el], onwardLevyConcData);
          let levy = seatDetails[el].l
          if (levy && levy.length > 0) {
            levy.forEach((o) => {
              onwardLevyAmount += o.a;
            });
          }
        })

        this.setState({ onwardLevyAmount, onwardConcList, tempOnwardConcList, onwardLevyConcData })
      }
    }

    if (prevState.levyConcDetailsR !== this.state.levyConcDetailsR) {
      if (this.state.levyConcDetailsR && Object.keys(this.state.levyConcDetailsR).length > 0) {
        let ret = this.props.search.order.return;
        let routeCode = ret.routeCode;
        let seatDetails = ret.seatDetails;
        let returnLevyAmount = 0;
        let returnLevyConcData = this.state.levyConcDetailsR[routeCode];
        let returnConcList = returnLevyConcData.ConcessionList;
        let tempReturnConcList = returnConcList;
        Object.keys(seatDetails).forEach((el) => {
          this.updateReturnLevy(seatDetails[el], returnLevyConcData);
          let levy = seatDetails[el].l
          if (levy && levy.length > 0) {
            levy.forEach((o) => {
              returnLevyAmount += o.a;
            });
          }
        })
        this.setState({ returnLevyAmount, returnConcList, tempReturnConcList, returnLevyConcData })
      }
    }
  }

  callLevyConc = (routeCode, mode) => {
    this.setState({ showLoader: true });
    let levyConcDetailsO = {};
    let levyConcDetailsR = {};
    const api = window.cdnUrl + apiUrl.getLeavyAndConcession + "?routeCode=" + routeCode;
    fetchGet(api).then((data) => {
      // data = {
      //   "ConcessionList": [
      //     {
      //       "AppliedTo": 2,
      //       "ConcessionID": 17,
      //       "ConcessionPer": 0,
      //       "ConcessionTypeID": 4,
      //       "ConcessionTypeName": "GENERAL PUBLIC",
      //       "CorporationID": 1,
      //       "FromDate": "3\/4\/2024 12:00:00 AM",
      //       "Gender": "",
      //       "IsCardEntry": 0,
      //       "IsChild": 1,
      //       "MaxNoOfTicket": 0,
      //       "MaxPersonPerTicket": 2,
      //       "RoundOff": 1,
      //       "StateCodes": "KA,AP,TN,GA,MH,TS,PO",
      //       "ToDate": ""
      //     },
      //     {
      //       "AppliedTo": 2,
      //       "ConcessionID": 18,
      //       "ConcessionPer": 100,
      //       "ConcessionTypeID": 39,
      //       "ConcessionTypeName": "SHAKTI WOMEN CONCESSION",
      //       "CorporationID": 1,
      //       "FromDate": "3\/4\/2024 12:00:00 AM",
      //       "Gender": "F",
      //       "IsCardEntry": 0,
      //       "IsChild": 1,
      //       "MaxNoOfTicket": 24,
      //       "MaxPersonPerTicket": 2,
      //       "RoundOff": 3,
      //       "StateCodes": "KA",
      //       "ToDate": ""
      //     },
      //     // {
      //     //   "AppliedTo": 2,
      //     //   "ConcessionID": 20,
      //     //   "ConcessionPer": 100,
      //     //   "ConcessionTypeID": 40,
      //     //   "ConcessionTypeName": "SHAKTI WOMEN ADV",
      //     //   "CorporationID": 1,
      //     //   "FromDate": "3\/4\/2024 12:00:00 AM",
      //     //   "Gender": "F",
      //     //   "IsCardEntry": 0,
      //     //   "IsChild": 1,
      //     //   "MaxNoOfTicket": 24,
      //     //   "MaxPersonPerTicket": 1,
      //     //   "RoundOff": 3,
      //     //   "StateCodes": "KA",
      //     //   "ToDate": ""
      //     // }
      //   ],
      //   "LevyList": [
      //     {
      //       "AdultAmount": 20,
      //       "ChildAmount": 10,
      //       "CorporationID": 1,
      //       "CorporationLevyID": 7,
      //       "FromDate": "3\/4\/2024 12:00:00 AM",
      //       "IsActive": 1,
      //       "IsPercentage": 0,
      //       "IsRefundable": 1,
      //       "LevyID": 6,
      //       "LevyName": "RESERVATION FEE",
      //       "LevyTypeID": 2,
      //       "MaxBaseFare": 10000,
      //       "MinBaseFare": 0,
      //       "ToDate": "3\/4\/2030 12:00:00 AM"
      //     },
      //     {
      //       "AdultAmount": 2,
      //       "ChildAmount": 1,
      //       "CorporationID": 1,
      //       "CorporationLevyID": 9,
      //       "FromDate": "3\/4\/2024 12:00:00 AM",
      //       "IsActive": 1,
      //       "IsPercentage": 0,
      //       "IsRefundable": 1,
      //       "LevyID": 5,
      //       "LevyName": "ARF",
      //       "LevyTypeID": 2,
      //       "MaxBaseFare": 10000,
      //       "MinBaseFare": 50,
      //       "ToDate": "3\/4\/2030 12:00:00 AM"
      //     },
      //     {
      //       "AdultAmount": 14,
      //       "ChildAmount": 7,
      //       "CorporationID": 1,
      //       "CorporationLevyID": 11,
      //       "FromDate": "3\/4\/2024 12:00:00 AM",
      //       "IsActive": 1,
      //       "IsPercentage": 0,
      //       "IsRefundable": 1,
      //       "LevyID": 8,
      //       "LevyName": "USER FEE",
      //       "LevyTypeID": 2,
      //       "MaxBaseFare": 10000,
      //       "MinBaseFare": 0,
      //       "ToDate": "3\/4\/2030 12:00:00 AM"
      //     }
      //   ],
      //   "Message": "",
      //   "Status": true
      // };
      if (data.Status) {
        if (mode === 'return') {
          levyConcDetailsR[routeCode] = data;
          this.setState({ levyConcDetailsR })
        } else {
          levyConcDetailsO[routeCode] = data;
          this.setState({ levyConcDetailsO })
        }

        this.setState({ showLoader: false });
      }
    })
      .catch((err) => {
        console.log(err)
        this.setState({ showLoader: false });
      })
  }

  updateOnwardLevy = (onwardSeats, onwardConLevy, type) => {
    if (
      Object.keys(onwardConLevy).length > 0 &&
      onwardConLevy.LevyList.length > 0
    ) {
      onwardSeats.l = [];
      Object.entries(onwardConLevy.LevyList).forEach(([levyInd, levyObj]) => {
        let fare = 0;
        let levyAmt = 0;
        let calLevyAmt = 0;
        if (onwardSeats.age == "") {
          fare = onwardSeats.adultFare;
          levyAmt = levyObj.AdultAmount;
        } else if (onwardSeats.age !== '' && Number(onwardSeats.age) <= 12) {
          fare = onwardSeats.childFare;
          levyAmt = levyObj.ChildAmount;
        } else {
          fare = onwardSeats.adultFare;
          levyAmt = levyObj.AdultAmount;
        }
        if (fare >= levyObj.MinBaseFare && fare <= levyObj.MaxBaseFare) {
          if (levyObj.IsPercentage === 0) {
            calLevyAmt = levyAmt;
          } else {
            calLevyAmt = Math.round((fare * levyAmt) / 100);
          }
        }

        onwardSeats.l.push({
          id: levyObj.CorporationLevyID,
          n: levyObj.LevyName,
          a: calLevyAmt,
          ir: levyObj.IsRefundable,
        });
      });

      if (type === 'age') {
        let onwardLevyAmount = 0;
        // console.log("levy",)
        let seatDetails = this.props.search.order.onward.seatDetails;
        Object.keys(seatDetails).forEach((el) => {
          let s = seatDetails[el].l;
          if (s && s.length > 0) {
            s.forEach((o) => {
              onwardLevyAmount += o.a;
            })
          }
        })
        this.setState({ onwardLevyAmount })
      }

    }
  }

  updateReturnLevy = (returnSeats, returnConLevy, type) => {
    if (
      Object.keys(returnConLevy).length > 0 &&
      returnConLevy.LevyList.length > 0
    ) {
      returnSeats.l = [];

      Object.entries(returnConLevy.LevyList).forEach(([levyInd, levyObj]) => {
        let fare = 0;
        let levyAmt = 0;
        let calLevyAmt = 0;
        if (returnSeats.age == "") {
          fare = returnSeats.adultFare;
          levyAmt = levyObj.AdultAmount;
        } else if (returnSeats.age <= 12) {
          fare = returnSeats.childFare;
          levyAmt = levyObj.ChildAmount;
        } else {
          fare = returnSeats.adultFare;
          levyAmt = levyObj.AdultAmount;
        }

        if (fare >= levyObj.MinBaseFare && fare <= levyObj.MaxBaseFare) {
          if (levyObj.IsPercentage === 0) {
            calLevyAmt = levyAmt;
          } else {
            calLevyAmt = Math.round((fare * levyAmt) / 100);
          }
        }

        returnSeats.l.push({
          id: levyObj.CorporationLevyID,
          n: levyObj.LevyName,
          a: calLevyAmt,
          ir: levyObj.IsRefundable,
        });
      });

      if (type === 'age') {
        let returnLevyAmount = 0;
        let seatDetails = this.props.search.order.return.seatDetails;
        Object.keys(seatDetails).forEach((el) => {
          let s = seatDetails[el].l;
          if (s && s.length > 0) {
            s.forEach((o) => {
              returnLevyAmount += o.a;
            })
          }
        })
        this.setState({ returnLevyAmount })
      }
    }
  }

  updateOnwardConcessionInfo = (onwardSeats) => {
    onwardSeats.c = [];
    onwardSeats.conAmt = 0;
    // let onwardConAmt = this.state.onwardConAmt;
    // let onwardTempConAmt = onwardConAmt;
    let onwardConAmt = 0;
    if (onwardSeats.concessionType != "") {
      const selectedConType = this.state.tempOnwardConcList.filter(
        (el) =>
          el.ConcessionTypeName.toLowerCase().trim() ==
          onwardSeats.concessionType.toLowerCase().trim()
      );

      let conAmt = 0;
      let conPer = selectedConType[0].ConcessionPer;
      let roundOff = selectedConType[0].RoundOff;
      let conFare = 0;
      if (onwardSeats.age != "") {
        if (onwardSeats.age <= 12) {
          conFare = onwardSeats.childFare;
        } else {
          conFare = onwardSeats.adultFare;
        }
      }

      if (conFare > 0 && conPer > 0) {
        conAmt = (conFare * conPer) / 100;
      }

      if (conAmt > 0) {
        if (roundOff == 1) {
          conAmt = Math.floor(conAmt);
        } else if (roundOff == 2) {
          conAmt = Math.ceil(conAmt);
        } else if (roundOff == 3) {
          conAmt = Math.round(conAmt);
        }
      }

      onwardSeats.c.push({
        id: selectedConType[0].ConcessionID,
        n: selectedConType[0].ConcessionTypeName,
        a: conAmt,
        pt: onwardSeats.idCardType,
        pv: onwardSeats.idCardNo,
      });
    }
    if (onwardSeats.c.length > 0) {

      onwardSeats.c.forEach((c) => {
        onwardSeats.conAmt = c.a;
      })
    }

    // this.setState({ conAmtSeatsO: onwardSeats })

  };

  updateReturnConcessionInfo = (returnSeats) => {
    returnSeats.c = [];
    returnSeats.conAmt = 0;
    // let returnConAmt = 0;
    if (returnSeats.concessionType != "") {
      const selectedConType = this.state.returnConcList.filter(
        (el) =>
          el.ConcessionTypeName.toLowerCase().trim() ==
          returnSeats.concessionType.toLowerCase().trim()
      );

      let conAmt = 0;
      let conPer = selectedConType[0].ConcessionPer;
      let roundOff = selectedConType[0].RoundOff;
      let conFare = 0;
      if (returnSeats.age != "") {
        if (returnSeats.age <= 12) {
          conFare = returnSeats.childFare;
        } else {
          conFare = returnSeats.adultFare;
        }
      }

      if (conFare > 0 && conPer > 0) {
        conAmt = (conFare * conPer) / 100;
      }

      if (conAmt > 0) {
        if (roundOff == 1) {
          conAmt = Math.floor(conAmt);
        } else if (roundOff == 2) {
          conAmt = Math.ceil(conAmt);
        } else if (roundOff == 3) {
          conAmt = Math.round(conAmt);
        }
      }

      returnSeats.c.push({
        id: selectedConType[0].ConcessionID,
        n: selectedConType[0].ConcessionTypeName,
        a: conAmt,
        pt: returnSeats.idCardType,
        pv: returnSeats.idCardNo,
      });

      if (returnSeats.c.length > 0) {
        returnSeats.c.forEach((c) => {
          returnSeats.conAmt = c.a;
        })
      }
      // this.setState({ returnConAmt })
    }
  };

  updateSeatDetails() {
    const ord = this.props.search.order;
    if (Object.keys(ord).length) {
      const onwardSeats = ord.onward.seatDetails;
      if (Object.keys(onwardSeats).length) {
        let postData = {};
        postData['token'] = this.props.match.params.token;
        Object.keys(onwardSeats).map((el, index) => {
          postData[`paxName[${el}]`] = onwardSeats[el].name || '';
          postData[`paxGender[${el}]`] = onwardSeats[el].gender || '';
          postData[`paxAge[${el}]`] = onwardSeats[el].age || '';
          postData[`paxSeat[${el}]`] = el;
          postData[`paxConcessionType[${el}]`] =
            onwardSeats[el].concessionType || "";
          postData[`paxIDCardNo[${el}]`] = onwardSeats[el].idCardNo || "";
          postData[`paxIDCardType[${el}]`] = onwardSeats[el].idCardType || "";
          postData[`paxNationality[${el}]`] = onwardSeats[el].nationality || "";
          postData[`paxLevy[${el}]`] = onwardSeats[el].l || "";
          postData[`paxConcession[${el}]`] = onwardSeats[el].c || "";
        });
        if (ord.return) {
          const returnSeats = ord.return.seatDetails;
          returnSeats && Object.keys(returnSeats).map((el, index) => {
            postData[`paxName2[${el}]`] = returnSeats[el].name || '';
            postData[`paxAge2[${el}]`] = returnSeats[el].age || '';
            postData[`paxGender2[${el}]`] = returnSeats[el].gender || '';
            postData[`paxSeat2[${el}]`] = el;
            postData[`paxConcessionType2[${el}]`] =
              returnSeats[el].concessionType || "";
            postData[`paxIDCardNo2[${el}]`] = returnSeats[el].idCardNo || "";
            postData[`paxIDCardType2[${el}]`] = returnSeats[el].idCardType || "";
            postData[`paxNationality2[${el}]`] =
              returnSeats[el].nationality || "";
            postData[`paxLevy2[${el}]`] = returnSeats[el].l || "";
            postData[`paxConcession2[${el}]`] = returnSeats[el].c || "";
          });
        }
        PostRequest('/api/expco/updateBookingSeatDetails', postData).then(response => {
          if (response.success) {
            // console.log(response.message);
          } else {
            // console.log(response.error.message);
          }
        }).catch((error) => {
          console.log(error);
        });
      }
    }
  }


  setGender = (value) => {
    if (value === 'M' || value === 'Male') {
      return 'Male';
    } else if (value === 'F' || value === 'Female') {
      return 'Female';
    } else if (value === 'Others' || value === 'o') {
      return 'Others';
    }
  }

  storePassDetails = () => {
    const ord = this.props.search.order;
    const loop = ord.length !== 0 ? ord.onward.seats : false;
    const seats = ord.onward.seatDetails;
    if (loop) {
      loop.map((el, index) => {
        if (index === 0) {
          window.customerProfile.CustomerName !== ""
            ? store.dispatch(
              updateUserInfo(
                "name",
                "onward",
                el,
                window.customerProfile.CustomerName
              )
            )
            : store.dispatch(
              updateUserInfo("name", "onward", el, seats[el].name)
            );
          // window.customerProfile.Gender !== ""
          //   ? store.dispatch(
          //     updateUserInfo(
          //       "gender",
          //       "onward",
          //       el,
          //       // window.customerProfile.Gender === "M" ? "Male" : "Female"
          //       seats[el].gender !== "" ? seats[el].gender : (window.customerProfile.Gender === "M" ? "Male" : "Female")
          //     )
          //   )
          //   : 
          store.dispatch(
            updateUserInfo("gender", "onward", el, seats[el].gender)
          );
          window.customerProfile.Age !== 0
            ? store.dispatch(
              updateUserInfo("age", "onward", el, window.customerProfile.Age)
            )
            : store.dispatch(
              updateUserInfo("age", "onward", el, seats[el].age)
            );
        }
        return true;
      });
    }
  };

  deafultSelData = (data) => {
    let that = this;
    const ord = that.props.search.order;
    const onwardloop = ord.length !== 0 ? ord.onward.seats : false;
    const returnloop = ord.length !== 0 ? ord.onward.seats && ord.return && ord.return.seats : false;
    if (data && data.pgSelected) {
      const savedPassData = that.getSavedData();
      const seats = savedPassData && savedPassData.onward && savedPassData.onward.seatDetails;
      const returnSeats = savedPassData && savedPassData.return && savedPassData.return.seatDetails;
      const alredaySelPg = data.pgSelected;
      const orderTimestamp = data.timestamp;
      const mobile = savedPassData.mobile;
      const email = savedPassData.email;
      if (onwardloop && seats) {
        onwardloop.map((el) => {
          store.dispatch(updateUserInfo("name", "onward", el, seats[el].name)),
            store.dispatch(updateUserInfo("age", "onward", el, seats[el].age)),
            store.dispatch(updateUserInfo("gender", "onward", el, seats[el].gender)),
            store.dispatch(updateUserInfo("concessionType", "onward", el, seats[el].concessionType)),
            store.dispatch(updateUserInfo("idCardType", "onward", el, seats[el].idCardType)),
            store.dispatch(updateUserInfo("idCardNo", "onward", el, seats[el].idCardNo)),
            store.dispatch(updateUserInfo("nationality", "onward", el, seats[el].nationality))
        })
      }

      if (returnloop) {
        returnloop.map((el) => {
          store.dispatch(updateUserInfo("name", "return", el, returnSeats[el].name)),
            store.dispatch(updateUserInfo("age", "return", el, returnSeats[el].age)),
            store.dispatch(updateUserInfo("gender", "return", el, returnSeats[el].gender)),
            store.dispatch(updateUserInfo("concessionType", "onward", el, returnSeats[el].concessionType)),
            store.dispatch(updateUserInfo("idCardType", "onward", el, returnSeats[el].idCardType)),
            store.dispatch(updateUserInfo("idCardNo", "onward", el, returnSeats[el].idCardNo)),
            store.dispatch(updateUserInfo("nationality", "onward", el, returnSeats[el].nationality))
        })
      }

      this.setState({ mobile, email, alredaySelPg, orderTimestamp, travellerlist: true, payeedetail: true, activeNavTab: "payment", payopt: alredaySelPg });
    }
  }

  setDefaultpg = (val) => {
    val.map((el, index) => {
      if (el.IsDefault) {
        this.setState({
          payopt: el.pg,
          bankChargesPer: el.BankCharges,
          pgname: el.DisplayText,
        });
      }
    });
    return true;
  };
  handlepastlist = (entry, seatno, triptype = "onward") => {
    store.dispatch(updateUserInfo("name", triptype, seatno, entry[0]));
    store.dispatch(
      updateUserInfo("age", triptype, seatno, parseInt(entry[1], 10))
    );
    store.dispatch(updateUserInfo("gender", triptype, seatno, entry[2]));
    // store.dispatch(updateUserInfo("concessionType", triptype, seatno, entry[3]));
    // store.dispatch(updateUserInfo("idCardType", triptype, seatno, entry[4]));
    // store.dispatch(updateUserInfo("idCardNo", triptype, seatno, entry[5]));
    // store.dispatch(updateUserInfo("nationality", triptype, seatno, entry[6]));
    this.checkConcessionTypeList(entry[2], "gender", triptype);
    this.checkConcessionTypeList(parseInt(entry[1], 10), "age", triptype)
  };
  handleListInput = (filedname, triptype, seatno, val) => {
    if (filedname === "name") {
      /^[a-zA-Z .]+$/.test(val) || val === ""
        ? store.dispatch(updateUserInfo(filedname, triptype, seatno, val))
        : "";
    } else {
      store.dispatch(updateUserInfo(filedname, triptype, seatno, val));
    }
  };

  clickHandler = (type, mode, val, seatNo) => {
    let openDrop = this.state.openDrop;
    let openDropSeatNo = seatNo;
    if (mode === 'onward') {
      let onward = this.state.openDrop.onward;
      for (let key in onward) {
        if (key === type) {
          openDrop[mode][key] = true;
        } else {
          openDrop[mode][key] = false;
        }
      }
    }
    if (mode === 'return') {
      let openDrop = this.state.openDrop;
      let r = openDrop.return;
      for (let key in r) {
        if (key === type) {
          openDrop[mode][key] = true;
        } else {
          openDrop[mode][key] = false;
        }
      }
    }
    this.setState({ openDrop: openDrop, openDropSeatNo })
  }

  reCalculateFare = (type, seatNo, val) => {
    if (type === 'onward') {
      let order = this.props.search.order;
      let seatDetails = order && order.onward && order.onward.seatDetails;;
      let onwardFare = this.state.onwardFare;
      let updatedOnwardFare = this.state.updatedOnwardFare;
      Object.keys(seatDetails).forEach((el) => {
        if (seatDetails[el].age == "") {
          // updatedOnwardFare += seatDetails[el].fare;
          // updatedOnwardFare += seatDetails[el].serviceTax;
          updatedOnwardFare = onwardFare;
        }
        if (seatDetails[el].age && seatDetails[el].age <= 12 && seatDetails[el].childFare > 0) {
          onwardFare -= seatDetails[el].childFare;
          updatedOnwardFare = onwardFare;
        }
        if (seatDetails[el].age && seatDetails[el].age > 12) {
          updatedOnwardFare = onwardFare
        }
      })

      this.setState({ updatedOnwardFare })
    }
    if (type === 'return') {
      let order = this.props.search.order;
      let seatDetails = order && order.return && order.return.seatDetails;;
      let returnFare = this.state.returnFare;
      let updatedReturnFare = this.state.updatedReturnFare;
      // console.log("updatedReturnFare", updatedReturnFare)
      Object.keys(seatDetails).forEach((el) => {
        if (seatDetails[el].age == "") {
          // updatedReturnFare += seatDetails[el].fare;
          // updatedReturnFare += seatDetails[el].serviceTax;
          updatedReturnFare = returnFare;
        }
        if (seatDetails[el].age && seatDetails[el].age <= 12 && seatDetails[el].childFare > 0) {
          returnFare -= seatDetails[el].childFare;
          updatedReturnFare = returnFare;
        }
        if (seatDetails[el].age && seatDetails[el].age > 12) {
          updatedReturnFare = returnFare
        }
      })

      this.setState({ updatedReturnFare })
    }
  }

  updateConcessionUsed = (type) => {
    const onwardSeats = this.props.search.order.onward.seatDetails;
    if (type === "onward") {
      let tempConcessionUsed = [...this.state.onwardConcessionUsed];
      Object.keys(onwardSeats).forEach((el, index) => {
        if (index <= Object.keys(onwardSeats).length - 1) {
          if (
            onwardSeats[el].concessionType != "" &&
            onwardSeats[el].c &&
            onwardSeats[el].c.length > 0
          ) {
            onwardSeats[el].c.map((el) => {
              if (tempConcessionUsed[el.n] != undefined) {
                tempConcessionUsed[el.n] += 1;
              } else {
                tempConcessionUsed[el.n] = 1;
              }
            });
          }
        }
      });

      // console.log("tempConcessionUsed", tempConcessionUsed);

      this.setState({ onwardConcessionUsed: tempConcessionUsed });
    }

    if (type === 'return') {
      let returnSeats = this.props.search.order.return.seatDetails;
      let tempConcessionUsed = [...this.state.returnConcessionUsed];

      Object.keys(returnSeats).forEach((el, index) => {
        if (index <= Object.keys(returnSeats).length - 1) {
          if (
            returnSeats[el].concessionType != "" &&
            returnSeats[el].c &&
            returnSeats[el].c.length > 0
          ) {
            returnSeats[el].c.map((el) => {
              if (tempConcessionUsed[el.n] != undefined) {
                tempConcessionUsed[el.n] += 1;
              } else {
                tempConcessionUsed[el.n] = 1;
              }
            });
          }
        }
      });

      this.setState({ returnConcessionUsed: tempConcessionUsed });
    }
  };


  checkConcessionTypeList = (value, param, type) => {

    // console.log({ value, param, type })

    let usedConcession;

    if (type == "onward") {
      usedConcession = this.state.onwardConcessionUsed;
    } else {
      usedConcession = this.state.returnConcessionUsed;
    }

    let tempFilter = { ...this.state.concessionFilterFor };
    tempFilter[param] = value;
    let filterData = [];
    if (type === 'onward') {
      filterData = this.state.tempOnwardConcList;
    } else {
      filterData = this.state.tempReturnConcList;
    }

    if (tempFilter.age && tempFilter.age != "") {
      if (tempFilter.age <= 12) {
        filterData = filterData.filter((el) => {
          return el.IsChild === 1;
        });
      } else {
        filterData = filterData.filter((el) => {
          return el.IsChild === 0 || el.IsChild === 1;
        });
      }

      if (tempFilter.age <= 60) {
        filterData = filterData.filter((el) => {
          return (
            el.ConcessionTypeName != 'SENIOR CITIZEN'
          );
        });
      }
    }

    if (tempFilter.gender && tempFilter.gender != "") {
      filterData = filterData.filter((el) => {
        return (
          el.Gender.toLowerCase().trim() == "" ||
          el.Gender.toLowerCase()
            .trim()
            .includes(tempFilter.gender.charAt(0).toLowerCase())
        );
      });
    }

    if (Object.entries(usedConcession).length > 0) {
      Object.entries(usedConcession).forEach(([conTitle, conCount]) => {
        filterData = filterData.filter((el) => {
          return (
            (el.ConcessionTypeName == conTitle &&
              el.MaxPersonPerTicket > conCount) ||
            el.ConcessionTypeName != conTitle
          );
        });
      });
    }
    // console.log("filterData", filterData);
    if (type === 'onward') {
      this.setState({
        onwardConcList: filterData,
        concessionFilterFor: tempFilter,
      });
    } else {
      this.setState({
        returnConcList: filterData,
        concessionFilterFor: tempFilter,
      });
    }
  };

  getConcessionData = (type, seats, seatNo) => {
    if (type === 'onward') {
      let data = {}
      let onwardConcList = this.state.onwardConcList;
      data[seatNo] = onwardConcList.map(el => el.ConcessionTypeName)

      if (seats.concessionType !== '') {
        data[seatNo] = [...new Set([...data[seatNo], seats.concessionType])]

      }
      return data;
    }
    if (type === 'return') {
      let data = {};
      let returnConcList = this.state.returnConcList;
      data[seatNo] = returnConcList.map(el => el.ConcessionTypeName)

      if (seats.concessionType !== '') {
        data[seatNo] = [...new Set([...data[seatNo], seats.concessionType])]
      }
      return data;
    }
  }



  toggleDrop = (mode) => {
    let openDrop = this.state.openDrop;
    if (mode === 'onward') {
      let onward = this.state.openDrop.onward;
      for (let key in onward) {
        openDrop[mode][key] = false;
      }
      this.setState({ openDrop: openDrop })
    }
    if (mode === 'return') {
      let openDrop = this.state.openDrop;
      let r = openDrop.return;
      for (let key in r) {
        openDrop[mode][key] = false;
      }
      this.setState({ openDrop: openDrop })
    }
    if (mode === 'outside_click') {
      let onward = this.state.openDrop.onward;
      for (let key in onward) {
        openDrop['onward'][key] = false;
      }
      let returnMode = this.state.openDrop.return;
      for (let key in returnMode) {
        openDrop['return'][key] = false;
      }
      this.setState({ openDrop: openDrop })
    }

  }

  handleDropData = (index, type, seatNo, seatsData, selval) => {
    // console.log({ index, type, seatNo, seatsData })
    if (type === 'onward_gender') {
      let gender = this.setGender(selval)
      store.dispatch(
        updateUserInfo(
          "gender",
          "onward",
          seatNo,
          gender
        )
      );
      this.checkConcessionTypeList(gender, "gender", 'onward');
      store.dispatch(updateUserInfo("concessionType", "onward", seatNo, ""));
      this.updateOnwardConcessionInfo(seatsData);
      this.updateConcessionUsed('onward');
      this.updateConcessionAmount('onward');
      this.toggleDrop('onward');
      setTimeout(() => {
        this.checkConcessionTypeList(gender, "gender", 'onward');
      }, 100)
    }
    if (type === 'onward_concession') {
      store.dispatch(
        updateUserInfo(
          "concessionType",
          "onward",
          seatNo,
          selval
        )
      );
      this.updateOnwardConcessionInfo(seatsData);
      this.updateConcessionAmount('onward');
      this.updateConcessionUsed('onward');
      this.toggleDrop('onward')
    }
    if (type === 'onward_idCardType') {
      // let countryData = this.state.idCardData
      // let selIdCrad = countryData.filter(el => index === el.index)[0];
      store.dispatch(
        updateUserInfo(
          "idCardType",
          "onward",
          seatNo,
          selval
        )
      );
      this.toggleDrop('onward')
    }
    if (type === 'onward_country') {

      store.dispatch(
        updateUserInfo(
          "nationality",
          "onward",
          seatNo,
          selval
        )
      );
      this.toggleDrop('onward')
    }

    if (type === 'return_gender') {
      let gender = this.setGender(selval)
      store.dispatch(
        updateUserInfo(
          "gender",
          "return",
          seatNo,
          gender,
        )
      );
      this.checkConcessionTypeList(gender, "gender", 'return');
      store.dispatch(updateUserInfo("concessionType", "return", seatNo, ""));
      this.updateReturnConcessionInfo(seatsData);
      this.updateConcessionUsed('return');
      this.updateConcessionAmount('return');
      this.toggleDrop('return')
      setTimeout(() => {
        this.checkConcessionTypeList(gender, "gender", 'return');
      }, 0)
    }
    if (type === 'return_concession') {
      store.dispatch(
        updateUserInfo(
          "concessionType",
          "return",
          seatNo,
          selval
        )
      );
      this.updateReturnConcessionInfo(seatsData);
      this.updateConcessionAmount('return');
      this.updateConcessionUsed('return');
      this.toggleDrop('return')
    }
    if (type === 'return_idCardType') {
      store.dispatch(
        updateUserInfo(
          "idCardType",
          "return",
          seatNo,
          selval
        )
      );
      this.toggleDrop('return')
    }
    if (type === 'return_country') {
      store.dispatch(
        updateUserInfo(
          "nationality",
          "return",
          seatNo,
          selval
        )
      );
      this.toggleDrop('return')
    }
  }


  updateConcessionAmount = (type) => {
    if (type === 'onward') {
      let conAmt = 0;
      let seatDetails = this.props.search.order.onward.seatDetails;
      Object.keys(seatDetails).forEach(el => {
        conAmt += seatDetails[el].conAmt;
      })
      this.setState({ onwardConAmt: conAmt })
    }
    if (type === 'return') {
      let conAmt = 0;
      let seatDetails = this.props.search.order.return.seatDetails;
      Object.keys(seatDetails).forEach(el => {
        conAmt += seatDetails[el].conAmt;
      })
      this.setState({ returnConAmt: conAmt })
    }
  }

  enterPassDetailsOnwards = () => {
    const ord = this.props.search.order;
    const loop = ord.length !== 0 ? ord.onward.seats : false;
    const urlParams = new URLSearchParams(window.location.search);
    const linkfromstoptocity = urlParams.get("linkfromstoptocity");
    if (loop) {
      const seats = ord.onward.seatDetails;
      return (
        <React.Fragment>
          <div className="passenger--trip--head">{`Onward Trip Passenger${loop.length > 1 ? 's' : ''}`}</div>
          {loop.map((el, index) => {
            return (
              <div className="pass-info" key={el}>
                <div
                  style={{
                    position: "relative",
                    width: "45px",
                    height: "45px",
                    fontSize: "14px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "2px solid",
                    borderColor: seats[el].isMale
                      ? color.male
                      : seats[el].isFemale
                        ? color.female
                        : color.grey,
                    borderRadius: color.borderRadius,
                  }}
                >
                  {el}
                  <span
                    style={{
                      position: "absolute",
                      bottom: 0,
                      left: "9px",
                      width: "23px",
                      height: "4px",
                      background: seats[el].isMale
                        ? color.male
                        : seats[el].isFemale
                          ? color.female
                          : color.grey,
                      borderRadius: color.borderRadius,
                    }}
                  ></span>
                </div>
                <PastInput
                  value={seats[el].name || ""}
                  handleSelect={this.handlepastlist}
                  handleChange={this.handleListInput}
                  name={"paxName[" + index + "]"}
                  placeholder="Name"
                  style={{ width: "18%" }}
                  filedname="name"
                  triptype="onward"
                  seatno={el}
                  tab={index * 4 + 3}
                  autoFocus={
                    this.state.activeNavTab === "passengerlist" && index === 0
                  }
                />
                <LineInpDrop
                  type="text"
                  value={this.setGender(seats[el].gender) || ""}
                  // handleChange={(e) => {
                  //   index === 0
                  //     ? this.setState({ customerAge: e.target.value })
                  //     : "";
                  //   const val = isInteger(parseInt(e.target.value, 10))
                  //     ? parseInt(e.target.value, 10)
                  //     : !e.target.value
                  //       ? ""
                  //       : seats[el].age;
                  //   store.dispatch(updateUserInfo("age", "onward", el, val));
                  // }}
                  onClick={() => {
                    this.clickHandler('gender', 'onward', seats[el], el)
                    this.checkConcessionTypeList(seats[el].gender, 'gender', 'onward')
                    this.checkConcessionTypeList(seats[el].age, 'age', 'onward')
                  }
                  }
                  placeholder="Gender"
                  name={"paxGender[" + index + "]"}
                  style={{ width: "10%" }}
                  tab={index * 4 + 4}
                  seatNo={el}
                  readOnly={true}
                  disabled={(seats[el].isFemale || seats[el].isMale) ? true : false}
                  dropType={'onward_gender'}
                  data={this.state.genderData}
                  openDrop={this.state.openDrop['onward']['gender'] && this.state.openDropSeatNo === el}
                  handleDropData={this.handleDropData}
                  seatsData={seats[el]}
                />
                <LineInp
                  type="tel"
                  value={seats[el].age || ""}
                  handleChange={(e) => {
                    index === 0
                      ? this.setState({ customerAge: e.target.value })
                      : "";
                    const val = isInteger(parseInt(e.target.value, 10))
                      ? parseInt(e.target.value, 10)
                      : !e.target.value
                        ? ""
                        : seats[el].age;
                    store.dispatch(updateUserInfo("age", "onward", el, val));
                    this.checkConcessionTypeList(seats[el].age, "age", 'onward');
                    this.reCalculateFare('onward', el, seats[el].age + '');
                    this.updateOnwardLevy(seats[el], this.state.onwardLevyConcData, 'age');
                    this.updateOnwardConcessionInfo(seats[el]);
                    this.updateConcessionAmount('onward');
                  }}
                  placeholder="Age"
                  name={"paxAge[" + index + "]"}
                  style={{ width: "8%" }}
                  tab={index * 4 + 5}
                  max={2}
                />
                <LineInpDrop
                  type="text"
                  value={seats[el].concessionType || ""}
                  onClick={() => {
                    this.clickHandler('concessionType', 'onward', seats[el], el)
                    this.checkConcessionTypeList(seats[el].gender, 'gender', 'onward')
                  }}
                  placeholder="Concession"
                  name={"paxConcessionType[" + index + "]"}
                  style={{ width: "18%" }}
                  tab={index * 4 + 6}
                  readOnly={true}
                  seatNo={el}
                  dropType={'onward_concession'}
                  // data={this.getConcessionData('onward', el)[el]}
                  // data={this.state.onwardConcessionType[el]}
                  data={this.getConcessionData('onward', seats[el], el)[el] || []}
                  handleDropData={this.handleDropData}
                  openDrop={this.state.openDrop['onward']['concessionType'] && this.state.openDropSeatNo === el}
                  seatsData={seats[el]}
                />

                <LineInpDrop
                  type="text"
                  value={seats[el].idCardType || ""}
                  onClick={() => this.clickHandler('idCardType', 'onward', seats[el], el)}
                  placeholder="Id Card "
                  name={"paxIDCardType[" + index + "]"}
                  style={{ width: "14%" }}
                  tab={index * 4 + 7}
                  readOnly={true}
                  seatNo={el}
                  data={this.state.idCardData}
                  dropType={'onward_idCardType'}
                  handleDropData={this.handleDropData}
                  openDrop={this.state.openDrop['onward']['idCardType'] && this.state.openDropSeatNo === el}
                  seatsData={seats[el]}
                />

                <LineInp
                  type="tel"
                  value={seats[el].idCardNo || ""}
                  handleChange={(e) => {
                    const val = e.target.value;
                    store.dispatch(updateUserInfo("idCardNo", "onward", el, val));
                  }}
                  placeholder="ID Card No"
                  max={12}
                  name={"paxIDCardNo[" + index + "]"}
                  style={{ width: "14%" }}
                  tab={index * 4 + 8}
                />

                <LineInpDrop
                  type="text"
                  value={seats[el].nationality || ""}
                  onClick={() => this.clickHandler('country', 'onward', seats[el], el)}
                  placeholder="Country"
                  name={"paxNationality[" + index + "]"}
                  style={{ width: "10%" }}
                  tab={index * 4 + 9}
                  readOnly={true}
                  seatNo={el}
                  data={this.state.nationality}
                  dropType={'onward_country'}
                  handleDropData={this.handleDropData}
                  openDrop={this.state.openDrop['onward']['country'] && this.state.openDropSeatNo === el}
                  seatsData={seats[el]}
                />
              </div>
            );
          })}
        </React.Fragment>
      );
    } else {
      return <div className="card">Loading...</div>;
    }
  };

  enterPassDetailsReturn = () => {
    const loop = this.props.search.order.return.seats;
    const seats = this.props.search.order.return.seatDetails;
    const onwardCount = this.props.search.order.onward.seats.length * 4;
    const urlParams = new URLSearchParams(window.location.search);
    const linkfromstoptocity = urlParams.get("linkfromstoptocity");
    return (
      <React.Fragment>
        <div className="passenger--trip--head">{`Return Trip Passenger${loop.length > 1 ? 's' : ''}`}</div>
        {loop.map((el, index) => {
          return (
            <div className="pass-info" key={{ index }}>
              <div
                style={{
                  position: "relative",
                  width: "45px",
                  height: "45px",
                  fontSize: "14px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border: "2px solid",
                  borderColor: seats[el].isMale
                    ? color.male
                    : seats[el].isFemale
                      ? color.female
                      : color.grey,
                  borderRadius: color.borderRadius,
                }}
              >
                {el}
                <span
                  style={{
                    position: "absolute",
                    bottom: 0,
                    left: "5px",
                    width: "23px",
                    height: "4px",
                    background: seats[el].isMale
                      ? color.male
                      : seats[el].isFemale
                        ? color.female
                        : color.grey,
                    borderRadius: color.borderRadius,
                  }}
                ></span>
              </div>
              <PastInput
                value={seats[el].name}
                handleSelect={this.handlepastlist}
                handleChange={this.handleListInput}
                name={"paxName2[" + index + "]"}
                placeholder="Name"
                style={{ width: "18%" }}
                filedname="name"
                triptype="return"
                seatno={el}
                tab={index * 4 + 3 + onwardCount}
              />
              <LineInpDrop
                type="text"
                value={this.setGender(seats[el].gender) || ""}
                // handleChange={(e) => {
                //   index === 0
                //     ? this.setState({ customerAge: e.target.value })
                //     : "";
                //   const val = isInteger(parseInt(e.target.value, 10))
                //     ? parseInt(e.target.value, 10)
                //     : !e.target.value
                //       ? ""
                //       : seats[el].age;
                //   store.dispatch(updateUserInfo("age", "onward", el, val));
                // }}
                onClick={() => {
                  this.clickHandler('gender', 'return', seats[el], el);
                  this.checkConcessionTypeList(seats[el].gender, 'gender', 'return')
                  this.checkConcessionTypeList(seats[el].age, 'age', 'return')
                }
                }
                placeholder="Gender"
                name={"paxGender2[" + index + "]"}
                style={{ width: "10%" }}
                tab={index * 4 + 4}
                seatNo={el}
                readOnly={true}
                disabled={(seats[el].isFemale || seats[el].isMale) ? true : false}
                dropType={'return_gender'}
                data={this.state.genderData}
                openDrop={this.state.openDrop['return']['gender'] && this.state.openDropSeatNo === el}
                handleDropData={this.handleDropData}
                seatsData={seats[el]}
              />
              <LineInp
                type="tel"
                value={seats[el].age || ""}
                handleChange={(e) => {
                  index === 0
                    ? this.setState({ customerAge: e.target.value })
                    : "";
                  const val = isInteger(parseInt(e.target.value, 10))
                    ? parseInt(e.target.value, 10)
                    : !e.target.value
                      ? ""
                      : seats[el].age;
                  store.dispatch(updateUserInfo("age", "return", el, val));
                  this.checkConcessionTypeList(seats[el].age, "age", 'return');
                  this.reCalculateFare('return', el, seats[el].age + '');
                  this.updateReturnLevy(seats[el], this.state.returnLevyConcData, 'age');
                  this.updateReturnConcessionInfo(seats[el]);
                  this.updateConcessionAmount('return');
                }}
                placeholder="Age"
                name={"paxAge2[" + index + "]"}
                style={{ width: "8%" }}
                tab={index * 4 + 5}
                max={2}
              />
              <LineInpDrop
                type="text"
                value={seats[el].concessionType || ""}
                onClick={() => {
                  this.clickHandler('concessionType', 'return', seats[el], el)
                  this.checkConcessionTypeList(seats[el].gender, 'gender', 'return')
                }}
                placeholder="Concession"
                name={"paxConcessionType2[" + index + "]"}
                style={{ width: "18%" }}
                tab={index * 4 + 6}
                readOnly={true}
                seatNo={el}
                dropType={'return_concession'}
                // data={this.state.returnConcessionType[el]}
                data={this.getConcessionData('return', seats[el], el)[el] || []}
                handleDropData={this.handleDropData}
                openDrop={this.state.openDrop['return']['concessionType'] && this.state.openDropSeatNo === el}
                seatsData={seats[el]}
              />

              <LineInpDrop
                type="text"
                value={seats[el].idCardType || ""}
                onClick={() => this.clickHandler('idCardType', 'return', seats[el], el)}
                placeholder="Id Card "
                name={"paxIDCardType2[" + index + "]"}
                style={{ width: "14%" }}
                tab={index * 4 + 7}
                readOnly={true}
                seatNo={el}
                data={this.state.idCardData}
                dropType={'return_idCardType'}
                handleDropData={this.handleDropData}
                openDrop={this.state.openDrop['return']['idCardType'] && this.state.openDropSeatNo === el}
                seatsData={seats[el]}
              />

              <LineInp
                type="tel"
                value={seats[el].idCardNo || ""}
                handleChange={(e) => {
                  const val = e.target.value;
                  store.dispatch(updateUserInfo("idCardNo", "return", el, val));
                }}
                placeholder="ID Card No"
                max={12}
                name={"paxIDCardNo2[" + index + "]"}
                style={{ width: "14%" }}
                tab={index * 4 + 8}
              />

              <LineInpDrop
                type="text"
                value={seats[el].nationality || ""}
                onClick={() => this.clickHandler('country', 'return', seats[el], el)}
                placeholder="Country"
                name={"paxNationality2[" + index + "]"}
                style={{ width: "10%" }}
                tab={index * 4 + 9}
                readOnly={true}
                seatNo={el}
                data={this.state.nationality}
                dropType={'return_country'}
                handleDropData={this.handleDropData}
                openDrop={this.state.openDrop['return']['country'] && this.state.openDropSeatNo === el}
                seatsData={seats[el]}
              />

            </div>
          );
        })}
      </React.Fragment>
    );
  };
  handleCountryCode = (e) => {
    if (this.state.countryCodeTYpe !== "indian" && this.state.countryCodeTYpe !== "myanmar") {
      /^[0-9\-\+]+$/.test(e.target.value) &&
        this.setState({ countryCode: e.target.value });
    }
  };
  handleMobileNumber = (e) => {
    if (this.state.countryCodeTYpe === "indian" && e.target.value.length < 11) {
      /^[0-9]*$/.test(e.target.value) &&
        this.setState({ mobile: e.target.value });
    }
    if (this.state.countryCodeTYpe === "myanmar" && e.target.value.length < 11) {
      /^[0-9]*$/.test(e.target.value) &&
        this.setState({ mobile: e.target.value });
    }
    if (
      this.state.countryCodeTYpe === "international" &&
      e.target.value.length < 16
    ) {
      /^[0-9]*$/.test(e.target.value) &&
        this.setState({ mobile: e.target.value });
    }

    if (!this.state.getCouponsDetails && this.state.countryCodeTYpe === "indian" && e.target.value.length === 10) {
      let mobileno = /^[0-9]*$/.test(e.target.value) && e.target.value;
      // this.fetchCouponTotlalPrice(mobileno);
    }

    if (!this.state.getCouponsDetails && this.state.countryCodeTYpe === "myanmar" && (e.target.value.length === 7 || e.target.value.length === 10)) {
      let mobileno = /^[0-9]*$/.test(e.target.value) && e.target.value;
      // this.fetchCouponTotlalPrice(mobileno);
    }
  };

  fetchCouponTotlalPrice = (mobileno) => {
    let that = this;
    let routeCode = that.props.search.order.onward.routeCode;
    let mobile = mobileno
    let url =
      window.url +
      apiUrl.couponList +
      "?RouteCode=" +
      routeCode +
      "&MobileNumber=" +
      mobile +
      "&EmailID=&CouponName";
    that.setState({ showLoader: true });
    fetchGet(url)
      .then(function (data) {
        that.setState({ showLoader: false });
        // console.log(data);
        let loop = data.CouponsWithBalance;
        let totalcouponAmount = 0;
        loop.length > 0 && loop.forEach(el => totalcouponAmount += el.Balance)
        // console.log(totalcouponAmount) 
        that.setState({ totalcouponAmount: totalcouponAmount })
      })
      .catch(function (error) {
        that.setState({ showLoader: false });
        console.log(error);
      });
  }
  enterContactDetails = () => {

    const couponDetails = this.props.search.couponDetails;
    const loop = couponDetails.CouponsWithBalance;
    const ip_address = this.props.search.order && this.props.search.order.ip_address ? this.props.search.order.ip_address : null;

    let prepaidCard = [];
    let loyaltyCoupon = [];
    let marketingCoupon = [];

    if (loop != undefined) {
      if (Object.keys(loop).length !== 0) {
        loop.map((el, index) => {
          if (el.CouponType === "Prepaid Card") {
            prepaidCard.push(el);
          } else if (
            el.CouponType === "Loyalty" ||
            el.CouponType === "Loyalty Wallet"
          ) {
            loyaltyCoupon.push(el);
          } else {
            marketingCoupon.push(el);
          }
        });
      }
    }

    return (
      <div className="card customerinfo flexed-justify flex-coloumn">
        <div className="payee-section">
          {/* <h6
            className="flex-vc"
            style={{
              borderBottom: !this.state.showPayeeBlock
                ? "1px solid" + color.alto
                : "",
            }}
          >
            <span className="payee-heading">i. Payee Details</span>
            {!this.state.showPayeeBlock ? (
              <span className="onelinepaydet flex flexed-justify">
                <span className="fixedpos">:</span>
                <div className="onelineinfo">
                  <span className="onelinemobile">
                    Mobile: {this.state.mobile}
                  </span>
                  <span className="onelineemail">
                    Email: {this.state.email}
                  </span>
                </div>
                <div
                  className="onelineedit crsrpointer"
                  onClick={() => {
                    this.setState({
                      showCouponBlock: false,
                      showPayeeBlock: true,
                    });
                  }}
                >
                  Edit
                </div>
              </span>
            ) : (
              ""
            )}
          </h6> */}
          <div>
            <div style={{ paddingTop: '15px' }}>
              <Radio
                value="indian"
                checked={this.state.loginType === "guest"}
                handleChange={() => {
                  this.setState({
                    loginType: "guest",
                    countryCode: "+91",
                    mobile: this.state.mobile.substring(0, 10),
                  });
                }}
                showValue="Continue As Guest"
                name={""}
                tab={""}
                labelStyle={{ cursor: "pointer" }}
                labelMargin="0 20px 0 0"
              />

              <Radio
                value="Login"
                checked={this.state.loginType === "login"}
                handleChange={() => {
                  this.setState({ loginType: "login", countryCode: "+91", mobile: this.state.mobile.substring(0, 10) });
                }}
                showValue="Login"
                name={""}
                tab={""}
                labelStyle={{ cursor: "pointer" }}
              />
              {/* {!this.state.getCouponsDetails && <a href="/prepaid_use" target="_blank" style={{ position: 'absolute', right: '30px', textDecoration: 'none' }}>How to use coupons ?</a>} */}
            </div>
            <div className="pass-info">
              {this.state.loginType === 'guest' &&
                <React.Fragment>
                  <LineInp
                    type="text"
                    pattern={"[0-9]*"}
                    value={this.state.countryCode}
                    handleChange={(event) => this.handleCountryCode(event)}
                    name="countrycode"
                    max={8}
                    validation="countrycode"
                    style={{
                      width: "60px",
                      marginRight: "10px",
                      flexShrink: "0",
                    }}
                    readOnly={this.state.countryCodeTYpe === ("indian" || "myanmar")}
                  />
                  <LineInp
                    type="number"
                    value={this.state.mobile}
                    handleChange={(event) => this.handleMobileNumber(event)}
                    placeholder="Mobile No"
                    name="mobileNo"
                    tab={1}
                    validation="mobile"
                    style={{ width: "calc(50% - 70px)", marginRight: "10px" }}
                    max={this.state.countryCodeTYpe === ("indian" || "myanmar") ? "10" : "15"}
                  />
                  <LineInp
                    type="text"
                    value={this.state.email}
                    handleChange={(e) => this.setState({ email: e.target.value })}
                    placeholder="Email ID"
                    name="email"
                    tab={2}
                    validation="email"
                    style={{ width: "50%" }}

                  />
                </React.Fragment>
              }
              {
                this.state.loginType === 'login' &&
                <React.Fragment>
                  <LineInp
                    type="text"
                    value={this.state.email}
                    handleChange={(e) => this.setState({ email: e.target.value })}
                    placeholder="Email ID"
                    name="email"
                    tab={1}
                    validation="email"
                    style={{ width: "50%", marginRight: "10px" }}
                  />
                  <LineInp
                    type="password"
                    value={this.state.password}
                    handleChange={(e) => this.setState({ password: e.target.value })}
                    placeholder="Password"
                    name="password"
                    tab={2}
                    validation="password"
                    style={{ width: "50%" }}
                    imgType={'eyeclose'}
                  />
                </React.Fragment>

              }
            </div>
            {this.showCouponAmountSec()}
            {this.state.totalcouponAmount > 0 && <div className="login--info--arrow">{renderImg('CouponArrow')}</div>}
            {/* {this.customerGSTN()} */}
          </div>
          {/* <div className="discount section">
            <h6
              onClick={() => {
                this.setState({ showCouponBlock: true, showPayeeBlock: false });
              }}
              style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
            >
              ii. Discount Details

              {this.state.prepaidCouponShow && prepaidCard && prepaidCard.length > 0 ?
                <div style={{ display: 'flex', alignItems: 'center', fontStyle: 'italic', fontWeight: 'normal', fontSize: '0.8rem' }}>
                  <div style={{ display: "flex", alignItems: "center" }}>{renderImg('CouponInfo')}</div>
                  <div style={{ paddingLeft: '10px' }}>Choose radio button and click on redeem to apply coupon</div>
                </div>
                : ''
              }

              {this.state.loyaltyCouponShow && loyaltyCoupon && loyaltyCoupon.length > 0 ?
                <div style={{ display: 'flex', alignItems: 'center', fontStyle: 'italic', fontWeight: 'normal', fontSize: '0.8rem' }}>
                  <div style={{ display: "flex", alignItems: "center" }}>{renderImg('CouponInfo')}</div>
                  <div style={{ paddingLeft: '10px' }}>Choose radio button and click on redeem to apply coupon</div>
                </div>
                : ''
              }

              {this.state.discountCouponShow && marketingCoupon && marketingCoupon.length > 0 ?
                <div style={{ display: 'flex', alignItems: 'center', fontStyle: 'italic', fontWeight: 'normal', fontSize: '0.8rem' }}>
                  <div style={{ display: "flex", alignItems: "center" }}>{renderImg('CouponInfo')}</div>
                  <div style={{ paddingLeft: '10px' }}>Choose radio button and click on redeem to apply coupon</div>
                </div>
                : ''
              }


            </h6>
            {this.state.getCouponsDetails === true
              ? this.state.showCouponBlock
                ? this.showCouponSection()
                : this.showCouponBlock()
              : this.showLoginButton()}
          </div> */}
          <div className="payee--msg" >
            ಕ.ರಾ.ರ.ಸಾ.ನಿಗಮದ  ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳನ್ನು ಒಪ್ಪಿಕೊಳ್ಳುತ್ತೇನೆ./ <br />
            By proceeding further you agree to KSRTC's <a href="##" target="_blank" style={{ textDecoration: 'none', color: '#004F9E' }}>Terms & Conditions</a>{/*   and <a href="##" target="_blank" style={{ textDecoration: 'none', color: '#004F9E' }}>Privacy Policy</a> */}<br />
            ನಿಮ್ಮ ಐಪಿ ವಿಳಾಸ/Your IP Address: {ip_address}
          </div>
        </div>
      </div>
    );
  };

  /* enterContactDetailsForLoggedOut = () => {
    const tabCount =
      this.props.search.order.length !== 0
        ? (this.props.search.order.onward.seats.length +
            (this.props.search.order.return &&
            this.props.search.order.return.seats
              ? this.props.search.order.return.seats.length
              : 0)) *
          4
        : 0;
    return (
      <div className="card customerinfo">
        <h6>Enter Contact Details</h6>
        <div>
          Your booking details will be sent to your email address and contact
          no.
        </div>
        <div>
          <div className="pass-info-wrap">
            <div className="pass-info">
              <div className="mob-info">
                <LineInp
                  type="text"
                  value={this.state.countryCode}
                  handleChange={(e) => {
                    this.setState({ countryCode: e.target.value });
                  }}
                  name="countrycode"
                  max={8}
                  validation="countrycode"
                />
              </div>
              <LineInp
                type="number"
                value={this.state.mobile}
                handleChange={(e) => {
                  !e.target.value ? "" : this.state.mobile;
                  this.setState({ mobile: e.target.value });
                }}
                placeholder="Mobile No"
                name="mobileNo"
                style={{ width: "calc(100% - 110px)" }}
                tab={1}
                validation="mobile"
              />
            </div>
            <div className="pass-info">
              <LineInp
                type="text"
                value={this.state.email}
                handleChange={(e) => this.setState({ email: e.target.value })}
                placeholder="Email ID"
                name="email"
                style={{ width: "100%" }}
                tab={2}
                validation="email"
              />
            </div>
          </div>
          <div className="login-wrap">
            <div className="coupon-text">
              TO AVAIL DISCOUNTS SUCH AS LOYALTY, PREPAID CARD & DISCOUNT COUPON
            </div>
            <div style={{ background: color.primary }} className="login-text">
              VERIFY MOBILE NUMBER OR <br />
              <p>LOGIN / SIGNUP</p>
            </div>
          </div>
        </div>
      </div>
    );
  };
  */
  handleClick = (divName) => {
    this.state.activeTnC === false
      ? this.setState({
        activeTnC: divName,
      })
      : this.setState({
        activeTnC: false,
      });
  };

  checkCustomerGSTN = (e, i) => {
    const customerGSTN = this.state.customerGSTN === "on" ? "off" : "on";
    this.setState({ customerGSTN });
  };

  customerGSTN = () => {
    return (
      <div className="gst-sec">
        <div className="flex">
          <Check
            value={this.state.customerGSTN}
            checked={this.state.customerGSTN === "on"}
            handleChange={this.checkCustomerGSTN}
            name="customerGSTN"
            style={{ marginRight: "10px", cursor: "pointer" }}
          />
          I have a GST number (optional)
        </div>
        {this.state.customerGSTN === "on" ? (
          <div className="flexed-justify">
            <LineInp
              type="text"
              value={this.state.companyGSTNo}
              handleChange={(e) => {
                this.setState({ companyGSTNo: e.target.value });
              }}
              placeholder="Registration Number"
              name="GSTN"
              validation="gstno"
              style={{ width: "100%", margin: "20px 10px 0 0" }}
              max={15}
            />
            <LineInp
              type="text"
              value={this.state.regCompanyName}
              handleChange={(e) => {
                this.setState({ regCompanyName: e.target.value });
              }}
              placeholder="Company Name"
              name="GSTNCompany"
              style={{ width: "100%", marginTop: "20px" }}
            />
          </div>
        ) : (
          ""
        )}
      </div>
    );
  };


  showCouponAmountSec = () => {
    if (this.state.totalcouponAmount > 0) {
      return (
        <div style={{ marginTop: '10px', background: '#1db24c', padding: '10px', borderRadius: '4px', color: '#fff', textAlign: 'center', fontWeight: '500' }}>
          You have coupon in this mobile number worth {this.props.search.currency}{this.state.totalcouponAmount}. Login to unlock.
        </div>
      )
    } else {
      return null;
    }
  }

  couponDiscount = () => {
    return (
      <div className="card" style={{ padding: "0" }}>
        <div className="couponInputBox">
          <input
            className="coupon-input"
            type="text"
            name="coupon"
            placeholder="Enter coupon code"
            value={this.state.validCouponName}
          />
          <span
            className="coupon-button"
            style={{
              backgroundColor: color.secondary,
              display:
                this.state.buttonLabel === "Remove All" ? "block" : "none",
            }}
            onClick={() => {
              this.setState({
                validCouponName: "",
                loyaltyCoupon: "",
                marketingCoupon: "",
                prepaidcoupon: "",
                CouponID: 0,
                CouponID2: 0,
                CouponID3: 0,
                CouponDiscountAmt: 0,
                CouponDiscountAmt2: 0,
                CouponDiscountAmt3: 0,
                buttonLabel: "",
                CouponName: "",
                CouponDiscount: 0,
                alerterror: "All coupons removed.",
              });
            }}
          >
            {this.state.buttonLabel}
          </span>
        </div>
      </div>
    );
  };

  checkIsLoggedIn = () => {
    let mobNo = this.state.mobile;
    window.customerProfile && window.customerProfile.MobileNumber
      ? this.apiCouponList()
      : mobNo
        ? this.apiCouponList()
        : this.setState({ alerterror: "Please enter mobile no." });
  };

  apiCouponList = () => {
    let that = this;
    let routeCode = that.props.search.order.onward.routeCode;
    let mobile =
      window.customerProfile && window.customerProfile.MobileNumber
        ? window.customerProfile.MobileNumber
        : that.state.mobile;
    let url =
      window.url +
      apiUrl.couponList +
      "?RouteCode=" +
      routeCode +
      "&MobileNumber=" +
      mobile +
      "&EmailID=&CouponName";
    that.setState({ showLoader: true });
    fetchGet(url)
      .then(function (data) {
        store.dispatch(couponListDetails(data));
        that.setState({ isMobile: 1, showLoader: false });
      })
      .catch(function (error) {
        that.setState({
          showLoader: false,
          alerterror: "No coupons available on this no",
        });
      });
  };

  showCoupon = () => {
    const couponDetails = this.props.search.couponDetails;
    const loop = couponDetails.CouponsWithBalance;
    let prepaidCard = [];
    let loyaltyCoupon = [];
    let marketingCoupon = [];
    let AllowPrepaidCard = couponDetails.AllowMultipleCoupon
      ? couponDetails.AllowPrepaidCard
        ? true
        : false
      : true;
    let AllowAnyOtherCoupon = couponDetails.AllowMultipleCoupon
      ? couponDetails.AllowAnyOtherCoupon
        ? true
        : false
      : true;
    let AllowLoyalty = couponDetails.AllowMultipleCoupon
      ? couponDetails.AllowLoyalty
        ? true
        : false
      : true;

    if (Object.keys(loop).length !== 0) {
      loop.map((el, index) => {
        if (el.CouponType === "Prepaid Card") {
          prepaidCard.push(el);
        } else if (
          el.CouponType === "Loyalty" ||
          el.CouponType === "Loyalty Wallet"
        ) {
          loyaltyCoupon.push(el);
        } else {
          marketingCoupon.push(el);
        }
      });
      return (
        <div className="coupon-wrapper">
          <div className="coupon-container">
            <div
              className="coupon-header"
              style={{ background: color.primary }}
            >
              Coupons
              <span
                className="close-button"
                onClick={() => {
                  this.setState({ isMobile: 0 });
                }}
              >
                X
              </span>
            </div>
            <div
              className="redeemCoupon"
              style={{ backgroundColor: color.secondary }}
              onClick={() => {
                this.sendOTP();
                this.setState({
                  couponDiscount: 0,
                  CouponDiscountAmt: 0,
                  CouponDiscountAmt2: 0,
                  CouponDiscountAmt3: 0,
                  CouponID: "",
                  CouponID2: "",
                  CouponID3: "",
                  validCouponName: "",
                });
              }}
            >
              REDEEM COUPONS
            </div>
            <div className="coupon-types">
              <div
                style={{
                  color: color.secondary,
                  padding: "10px 0px",
                }}
              >
                To apply coupons, click on redeem coupons below. If you click on
                cancel, no changes will be applied.
              </div>
              {marketingCoupon.length !== 0 && AllowAnyOtherCoupon ? (
                <div style={{ marginTop: "30px" }}>
                  <div
                    className="coupon-header"
                    style={{ background: color.primary }}
                  >
                    Marketing or Paid Coupons
                    <span
                      className="close-button"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        this.setState({ marketingCoupon: "", CouponName: "" });
                      }}
                    >
                      Remove
                    </span>
                  </div>
                  <div className="box-container">
                    {marketingCoupon.map((el, index) => {
                      let MaxDiscountAmount =
                        el.MaxDiscountAmount !== 0
                          ? " upto  " +
                          this.props.search.currency +
                          el.MaxDiscountAmount
                          : "";
                      return (
                        <div key={{ index }} className="couponBox">
                          <div className="coupon-details flex-vc flexed-justify">
                            <span className="flex-vc">
                              <Radio
                                checked={
                                  couponDetails.AllowMultipleCoupon
                                    ? this.state.marketingCoupon ===
                                    el.CouponName
                                    : this.state.CouponName === el.CouponName
                                }
                                value={el.CouponName}
                                name={
                                  couponDetails.AllowMultipleCoupon
                                    ? "marketingCoupon"
                                    : "coupon"
                                }
                                handleChange={(event) =>
                                  this.setState({
                                    marketingCoupon: event.target.value,
                                    CouponName: event.target.value,
                                  })
                                }
                                labelStyle={{
                                  height: "15px",
                                  width: "15px",
                                  cursor: "pointer",
                                }}
                              />
                              <span className="coupon-name flex-vc">
                                {el.CouponName}
                              </span>
                            </span>
                            <span className="coupon-balance">
                              {el.DiscountPct
                                ? el.DiscountPct + "% off"
                                : this.props.search.currency +
                                el.Balance +
                                " off"}
                            </span>
                          </div>
                          <div className="couponType flexed-justify">
                            <span>{el.CouponType}</span>
                            <span
                              className="arrow-icon"
                              onClick={() =>
                                this.handleClick("marketingtnc" + index)
                              }
                            >
                              T&C
                              <span
                                className={
                                  this.state.activeTnC ===
                                    "marketingtnc" + index
                                    ? "arrow up"
                                    : "arrow down"
                                }
                              ></span>
                            </span>
                          </div>
                          <div
                            className={
                              this.state.activeTnC === "marketingtnc" + index
                                ? "show"
                                : "hide"
                            }
                          >
                            <ul>
                              <li>
                                {el.DiscountPct !== 0
                                  ? "Discount of " +
                                  el.DiscountPct +
                                  "%" +
                                  MaxDiscountAmount
                                  : "Discount upto " +
                                  this.props.search.currency +
                                  el.Balance +
                                  " on ticket amount."}
                              </li>
                              <li>
                                Minimum booking amount:{" "}
                                {el.MinimumBkgAmount !== 0
                                  ? el.MinimumBkgAmount
                                  : "NA"}
                              </li>
                              <li>
                                Valid upto {el.EndDate ? el.EndDate : "NA"}{" "}
                              </li>
                            </ul>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              ) : (
                ""
              )}
              {window.customerProfile &&
                window.customerProfile.MobileNumber &&
                loyaltyCoupon.length !== 0 &&
                AllowLoyalty ? (
                <div style={{ marginTop: "30px" }}>
                  <div
                    className="coupon-header"
                    style={{ background: color.primary }}
                  >
                    Loyality Discount Points
                    <span
                      className="close-button"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        this.setState({ loyaltyCoupon: "", CouponName: "" });
                      }}
                    >
                      Remove
                    </span>
                  </div>
                  <div className="box-container">
                    {loyaltyCoupon.map((el, index) => {
                      let MaxDiscountAmount =
                        el.MaxDiscountAmount !== 0
                          ? " upto  " +
                          this.props.search.currency +
                          el.MaxDiscountAmount
                          : "";
                      return (
                        <div key={{ index }} className="couponBox">
                          <div className="coupon-details flex-vc flexed-justify">
                            <span className="flex-vc">
                              <Radio
                                checked={
                                  couponDetails.AllowMultipleCoupon
                                    ? this.state.loyaltyCoupon === el.CouponName
                                    : this.state.CouponName === el.CouponName
                                }
                                value={el.CouponName}
                                name={
                                  couponDetails.AllowMultipleCoupon
                                    ? "loyaltyCoupon"
                                    : "coupon"
                                }
                                handleChange={(event) =>
                                  this.setState({
                                    loyaltyCoupon: event.target.value,
                                    CouponName: event.target.value,
                                  })
                                }
                                labelStyle={{
                                  height: "15px",
                                  width: "15px",
                                  cursor: "pointer",
                                }}
                              />
                              <span className="coupon-name flex-vc">
                                {el.CouponName}
                              </span>
                            </span>
                            <span className="coupon-balance">
                              {el.DiscountPct
                                ? el.DiscountPct + "% off"
                                : this.props.search.currency +
                                el.Balance +
                                " off"}
                            </span>
                          </div>
                          <div className="couponType flexed-justify">
                            <span>{el.CouponType}</span>
                            <span
                              className="arrow-icon"
                              onClick={() =>
                                this.handleClick("loyaltytnc" + index)
                              }
                            >
                              T&C
                              <span
                                className={
                                  this.state.activeTnC === "loyaltytnc" + index
                                    ? "arrow up"
                                    : "arrow down"
                                }
                              ></span>
                            </span>
                          </div>
                          <div
                            className={
                              this.state.activeTnC === "loyaltytnc" + index
                                ? "show"
                                : "hide"
                            }
                          >
                            <ul>
                              <li>
                                {el.DiscountPct !== 0
                                  ? "Discount of " +
                                  el.DiscountPct +
                                  "%" +
                                  MaxDiscountAmount
                                  : "Discount upto " +
                                  this.props.search.currency +
                                  el.Balance +
                                  " on ticket amount."}
                              </li>
                              <li>
                                Minimum booking amount:{" "}
                                {el.MinimumBkgAmount !== 0
                                  ? el.MinimumBkgAmount
                                  : "NA"}
                              </li>
                              <li>
                                Valid upto {el.EndDate ? el.EndDate : "NA"}{" "}
                              </li>
                            </ul>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              ) : (
                ""
              )}
              {prepaidCard.length !== 0 && AllowPrepaidCard ? (
                <div>
                  <div
                    className="coupon-header"
                    style={{ background: color.primary }}
                  >
                    Prepaid Card
                    <span
                      className="close-button"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        this.setState({ prepaidcoupon: "", CouponName: "" });
                      }}
                    >
                      Remove
                    </span>
                  </div>
                  <div className="box-container">
                    {prepaidCard.map((el, index) => {
                      return (
                        <div key={el.CouponName} className="couponBox">
                          <div className="coupon-details flex-vc flexed-justify">
                            <span className="flex-vc">
                              <Radio
                                checked={
                                  couponDetails.AllowMultipleCoupon
                                    ? this.state.prepaidcoupon === el.CouponName
                                    : this.state.CouponName === el.CouponName
                                }
                                value={el.CouponName}
                                name={
                                  couponDetails.AllowMultipleCoupon
                                    ? "prepaidcoupon"
                                    : "coupon"
                                }
                                handleChange={(event) =>
                                  this.setState({
                                    prepaidcoupon: event.target.value,
                                    CouponName: event.target.value,
                                  })
                                }
                                labelStyle={{
                                  height: "15px",
                                  width: "15px",
                                  cursor: "pointer",
                                }}
                              />
                              <span className="coupon-name flex-vc">
                                {el.CouponName}
                              </span>
                            </span>
                            <span className="coupon-balance">
                              {this.props.search.currency}
                              {el.Balance} off
                            </span>
                          </div>
                          <div className="couponType flexed-justify">
                            <span>{el.CouponType}</span>
                            <span
                              className="arrow-icon"
                              onClick={() =>
                                this.handleClick("prepaidtnc" + index)
                              }
                            >
                              T&C
                              <span
                                className={
                                  this.state.activeTnC === "prepaidtnc" + index
                                    ? "arrow up"
                                    : "arrow down"
                                }
                              ></span>
                            </span>
                          </div>
                          <div
                            className={
                              this.state.activeTnC === "prepaidtnc" + index
                                ? "show"
                                : "hide"
                            }
                          >
                            <ul>
                              <li>
                                Discount upto {this.props.search.currency}
                                {el.Balance} on ticket amount.
                              </li>
                              <li>
                                Minimum booking amount:{" "}
                                {el.MinimumBkgAmount !== 0
                                  ? el.MinimumBkgAmount
                                  : "NA"}
                              </li>
                              <li>Valid upto {el.EndDate} </li>
                            </ul>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="coupon-wrapper">
          <div
            className="coupon-container"
            style={{ textAlign: "center", color: "#ff1f70" }}
          >
            <div
              className="coupon-header"
              style={{ background: "rgb(85, 77, 161)" }}
            >
              Coupons
              <span
                className="close-button"
                onClick={() => {
                  this.setState({ isMobile: 0 });
                }}
              >
                X
              </span>
            </div>
            <div style={{ paddingTop: "15px" }}>
              Sorry! There is no any coupon for this mobile no
            </div>
          </div>
        </div>
      );
    }
  };

  sendOTP = () => {
    let that = this;
    let routeCode = that.props.search.order.onward.routeCode;
    let MobileNumber = window.customerProfile
      ? window.customerProfile.MobileNumber
      : that.state.mobile;
    let Email = that.state.email;
    let CouponName = that.state.marketingCoupon;
    let CouponName2 = that.state.loyaltyCoupon;
    let CouponName3 = that.state.prepaidcoupon;
    let OpDiscount = that.state.discountAmt;
    let TotalFare = that.state.updatedOnwardFare - that.state.onwardGst;
    let onwardSTax = that.state.onwardGst;
    let loggedin = window.customerProfile ? true : false;
    let CouponID2 = that.state.CouponID2;
    let CouponID3 = that.state.CouponID3;
    let CouponDiscountAmt = 0;
    let CouponDiscountAmt2 = 0;
    let CouponDiscountAmt3 = 0;
    let CouponDiscountType = "";
    let CouponDiscountType2 = "";
    let CouponDiscountType3 = "";
    let discountOnBase = that.state.discountOnBase;
    let discountOnTotal = that.state.discountOnTotal;
    let updatedStax = that.state.updatedStax;
    let isInsured = that.state.insurance === 'on' ? 1 : 0;

    let removeCoupon = that.state.removeCoupon;
    let removeCouponName = that.state.removeCouponName;
    let redeemCouponsList = that.state.redeemCouponsList;
    let redeemCouponsArray = redeemCouponsList.split("@");
    let selectedCouponName = that.state.CouponName;

    if (that.state.insurance === "on") {
      TotalFare += that.state.insuranceVal;
    }

    let errorMsg = "";
    let duplicateCoupon = false;
    if (selectedCouponName != "" && redeemCouponsArray.length && redeemCouponsArray.indexOf(selectedCouponName) > -1) {
      errorMsg = selectedCouponName + " Coupon Has Already Been Applied !";
      duplicateCoupon = true;
    }

    that.setState({ showLoader: true });

    /*let url =
      window.url +
      apiUrl.couponRedeem +
      "?RouteCode=" +
      routeCode +
      "&MobileNumber=" +
      MobileNumber +
      "&Email=" +
      Email +
      "&CouponName=" +
      CouponName +
      "&OpDiscount=" +
      OpDiscount +
      "&TotalFare=" +
      TotalFare +
      "&CouponName2=" +
      CouponName2 +
      "&CouponName3=" +
      CouponName3 +
      "&IsLoggedin=" +
      loggedin +
      "&ServiceCharge=" +
      that.state.onwardSc +
      "&Stax=" +
      onwardSTax;*/

    let url = window.url + apiUrl.couponRedeem +
      "?token=" + this.props.match.params.token +
      "&MobileNumber=" + MobileNumber +
      "&Email=" + Email +
      "&CouponName=" + CouponName +
      "&CouponName2=" + CouponName2 +
      "&CouponName3=" + CouponName3 +
      "&IsLoggedin=" + loggedin +
      "&isInsured=" + isInsured;

    fetch(url)
      .then(function (response) {
        return response.text().then(function (text) {
          that.setState({ showLoader: false });
          let result = JSON.parse(text);
          if (result.ErrorMessage) {
            // console.log(result.ErrorMessage);
            if (result.ErrorMessage !== "Error: No result found") {
              that.setState({ alerterror: result.ErrorMessage });
            } else {

              if (removeCoupon === true && removeCouponName != "") {
                errorMsg = "Coupon Removed Successfully !";
              }

              that.setState({
                CouponDiscountAmt: 0,
                CouponDiscountAmt2: 0,
                CouponDiscountAmt3: 0,
                CouponDiscountType: "",
                CouponDiscountType2: "",
                CouponDiscountType3: "",
                CouponName: "",
                removeCoupon: false,
                removeCouponName: "",
                redeemCouponsList: "",
              });

              errorMsg != "" ? that.setState({ alerterror: errorMsg }) : "";

            }
          } else {
            let updatedFare = result.UpdatedFare;
            discountOnBase =
              updatedFare && updatedFare[0].DiscountOnBase
                ? updatedFare[0].DiscountOnBase
                : 0;
            discountOnTotal =
              updatedFare && updatedFare[0].DiscountOnTotal
                ? updatedFare[0].DiscountOnTotal
                : 0;
            updatedStax =
              updatedFare && updatedFare[0].UpdatedStax
                ? updatedFare[0].UpdatedStax
                : 0;
            let CouponResponse = result.cs;
            if (CouponResponse) {
              let validCouponName = CouponResponse[0].CouponName;
              CouponDiscountType = CouponResponse[0].CouponType;
              CouponDiscountAmt = CouponResponse[0].DiscAmount;
              redeemCouponsList = CouponResponse[0].CouponName;

              if (CouponResponse[1]) {
                CouponID2 = CouponResponse[1].CouponID;
                CouponDiscountAmt2 = CouponResponse[1].DiscAmount;
                CouponDiscountType2 = CouponResponse[1].CouponType;
                if (CouponDiscountAmt2 !== 0) {
                  validCouponName =
                    validCouponName + "|" + CouponResponse[1].CouponName;
                  redeemCouponsList += "@" + CouponResponse[1].CouponName;
                }
              }
              if (CouponResponse[2]) {
                CouponID3 = CouponResponse[2].CouponID;
                CouponDiscountAmt3 = CouponResponse[2].DiscAmount;
                CouponDiscountType3 = CouponResponse[2].CouponType;
                if (CouponDiscountAmt3 !== 0) {
                  validCouponName =
                    validCouponName + "|" + CouponResponse[2].CouponName;
                  redeemCouponsList += "@" + CouponResponse[2].CouponName;
                }
              }

              if (removeCoupon === true && removeCouponName != "") {
                errorMsg = "Coupon Removed Successfully !";
              } else if (duplicateCoupon === false) {
                errorMsg = "Coupon Applied Successfully !";
              }


              that.setState({
                redeemCoupon: false,
                CouponDiscountAmt,
                buttonLabel: "Remove All",
                CouponID: CouponResponse[0].CouponID,
                CouponID2,
                CouponID3,
                CouponDiscountAmt2,
                CouponDiscountAmt3,
                validCouponName,
                CouponDiscountType,
                CouponDiscountType2,
                CouponDiscountType3,
                redeemCouponsList,
                removeCoupon: false,
                removeCouponName: "",
              });

              errorMsg != "" ? that.setState({ alerterror: errorMsg }) : "";

            } else {
              that.setState({
                alerterror: "OTP sent successfully to " + that.state.mobile,
              });
            }
            that.setState({
              showLoader: false,
              redeemCoupon: true,
              isMobile: 0,
              discountOnBase,
              discountOnTotal,
              updatedStax,
            });
          }
        });
      })
      .catch(function (error) {
        that.setState({
          showLoader: false,
          alerterror:
            "Sorry we faced some issues processing your request. Please check if you are connected to a stable internet and retry.",
        });
        console.log(error);
      });
  };

  showOTP = () => {
    return (
      <div className="OTP-container">
        <div className="successOTP-text">
          OTP sent successfully to {this.state.mobile}
          <span
            style={{ color: color.primary }}
            className="resentOTP"
            onClick={() => {
              this.setState({
                alerterror: "OTP sent successfully to " + this.state.mobile,
              }),
                this.sendOTP();
            }}
          >
            Resend OTP
          </span>
        </div>
        <div
          className="OTP-wrapper"
          style={{ border: "2px solid " + color.primary }}
        >
          <input
            className="OTP-input"
            type="text"
            name="OTP"
            placeholder="Enter OTP"
            onChange={(e) => this.setState({ OTP: e.target.value })}
          />
          <span
            className="OTP-button"
            style={{ backgroundColor: color.secondary }}
            onClick={() => {
              this.validateOTP();
            }}
          >
            SUBMIT
          </span>
        </div>
        <div className="bottom-text">
          Kindly validate your mobile no. in order to redeem coupons against
          your order
        </div>
      </div>
    );
  };

  validateOTP = () => {
    let routeCode = this.props.search.order.onward.routeCode;
    let OTP = this.state.OTP;
    let MobileNumber = window.customerProfile
      ? window.customerProfile.MobileNumber
      : this.state.mobile;
    let TotalFare = this.state.updatedOnwardFare - this.state.onwardGst;
    let onwardSTax = this.state.onwardGst;
    let OpDiscount = this.state.discountAmt;
    let prepaidcoupon = this.state.prepaidcoupon;
    let loyaltyCoupon = this.state.loyaltyCoupon;
    let marketingCoupon = this.state.marketingCoupon;
    let CouponID2 = this.state.CouponID2;
    let CouponID3 = this.state.CouponID3;
    let CouponDiscountAmt = 0;
    let CouponDiscountAmt2 = 0;
    let CouponDiscountAmt3 = 0;
    let CouponDiscountType = "";
    let CouponDiscountType2 = "";
    let CouponDiscountType3 = "";
    let discountOnBase = this.state.discountOnBase;
    let discountOnTotal = this.state.discountOnTotal;
    let updatedStax = this.state.updatedStax;
    let url =
      window.url +
      apiUrl.couponValidate +
      "?RouteCode=" +
      routeCode +
      "&MobileNumber=" +
      MobileNumber +
      "&OTP=" +
      OTP +
      "&CouponName=" +
      marketingCoupon +
      "&OpDiscount=" +
      OpDiscount +
      "&TotalFare=" +
      TotalFare +
      "&CouponName2=" +
      loyaltyCoupon +
      "&CouponName3=" +
      prepaidcoupon +
      "&ServiceCharge=" +
      this.state.onwardSc +
      "&Stax=" +
      onwardSTax;
    let that = this;
    fetch(url)
      .then(function (response) {
        return response.text().then(function (text) {
          let textObj = JSON.parse(text);
          if (textObj.ErrorMessage) {
            this.setState({ alerterror: textObj.ErrorMessage });
          } else {
            this.setState({ alerterror: "coupon applied successfully" });

            let updatedFare = textObj.UpdatedFare;
            discountOnBase =
              updatedFare && updatedFare[0].DiscountOnBase
                ? updatedFare[0].DiscountOnBase
                : 0;
            discountOnTotal =
              updatedFare && updatedFare[0].DiscountOnTotal
                ? updatedFare[0].DiscountOnTotal
                : 0;
            updatedStax =
              updatedFare && updatedFare[0].UpdatedStax
                ? updatedFare[0].UpdatedStax
                : 0;

            let CouponResponse = textObj.cs;
            let validCouponName = CouponResponse[0].CouponName;
            CouponDiscountType = CouponResponse[0].CouponType;
            CouponDiscountAmt = CouponResponse[0].DiscAmount;
            if (CouponResponse[1]) {
              CouponID2 = CouponResponse[1].CouponID;
              CouponDiscountAmt2 = CouponResponse[1].DiscAmount;
              CouponDiscountType2 = CouponResponse[1].CouponType;
              if (CouponDiscountAmt2 !== 0)
                validCouponName =
                  validCouponName + "|" + CouponResponse[1].CouponName;
            }
            if (CouponResponse[2]) {
              CouponID3 = CouponResponse[2].CouponID;
              CouponDiscountAmt3 = CouponResponse[2].DiscAmount;
              CouponDiscountType3 = CouponResponse[2].CouponType;
              if (CouponDiscountAmt3 !== 0)
                validCouponName =
                  validCouponName + "|" + CouponResponse[2].CouponName;
            }
            that.setState({
              redeemCoupon: false,
              CouponDiscountAmt,
              buttonLabel: "Remove All",
              CouponID: CouponResponse[0].CouponID,
              CouponID2,
              CouponID3,
              CouponDiscountAmt2,
              CouponDiscountAmt3,
              validCouponName,
              CouponDiscountType,
              CouponDiscountType2,
              CouponDiscountType3,
              discountOnBase,
              discountOnTotal,
              updatedStax,
            });
          }
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  showTime = (time) => {
    const d = new Date(time);
    const d1 = new Date(d.setMinutes(d.getMinutes() + 20));
    let hour = d1.getHours();
    let mins = d1.getMinutes();
    let AMPM = hour >= 12 ? `PM` : 'AM';
    hour = hour > 12 ? hour - 12 : hour;
    const timeFormat = (hour > 10 ? hour : `0${hour}`) + ':' + (mins > 10 ? mins : `0${mins}`) + ` ${AMPM}`
    return timeFormat;
  }

  selPaymentOption = () => {

    const TotalFare =
      this.state.updatedOnwardFare +
      this.state.updatedReturnFare +
      this.state.onwardSc +
      this.state.returnSc +
      this.state.insuranceVal +
      this.state.onwardPickcharges +
      this.state.onwardDropcharges +
      this.state.returnPickcharges +
      this.state.returnDropcharges;

    let couponDiscount = parseInt(
      this.state.CouponDiscountAmt +
      this.state.CouponDiscountAmt2 +
      this.state.CouponDiscountAmt3 +
      this.state.roundTripdiscount +
      this.state.discount,
      10
    );

    const alredaySelPg = this.state.alredaySelPg;
    const orderTimestamp = this.state.orderTimestamp;

    if (this.state.isRoundtrip) {

      let otDisAmt = 0;

      if (this.state.CouponDiscountAmt > 0 && this.state.CouponDiscountType === "OT") {
        otDisAmt = this.state.CouponDiscountAmt;
      }

      if (this.state.CouponDiscountAmt2 > 0 && this.state.CouponDiscountType2 === "OT") {
        otDisAmt = this.state.CouponDiscountAmt2;
      }

      if (this.state.CouponDiscountAmt3 > 0 && this.state.CouponDiscountType3 === "OT") {
        otDisAmt = this.state.CouponDiscountAmt3;
      }

      let onwardTripFare = this.state.updatedOnwardFare + this.state.onwardPickcharges + this.state.onwardDropcharges + this.state.onwardInsuranceAmt - this.state.discountAmt - this.state.onwardRoundTripDiscount;

      if (otDisAmt > onwardTripFare) {
        //first remove open ticket discount amount from total discount given 
        couponDiscount = couponDiscount - otDisAmt;
        otDisAmt = onwardTripFare;
        //now add new open ticket discount amount in total discount given
        couponDiscount = couponDiscount + otDisAmt;
      }
    }

    if (TotalFare !== couponDiscount) {
      if (
        this.props.search.order &&
        this.props.search.order.pgDetails &&
        this.props.search.order.pgDetails.length > 0
      ) {
        const loop = this.props.search.order.pgDetails;
        const items = [];
        /* const tablerow = Math.ceil(loop.length / 3);
        const lastrowcoloum = loop.length % 3;
        let table = [];
        for (let i = 0; i < tablerow; i++) {
          let children = [];
          for (let j = 0; j < 3; j++) {
            if (!(i === tablerow - 1 && lastrowcoloum <= j)) {
              children.push(<td>{`Column ${j + 1}`}</td>);
            }
          }
          table.push(<tr>{children}</tr>);
        } */

        for (const [index, value] of loop.entries()) {
          items.push(
            <div key={index} className="pay-opts-item">
              {/* <RadioBlock
                style={{ height: "70px" }}
                value={value.pg}
                checked={this.state.payopt === value.pg ? true : false}
                handleChange={(event) => {
                  this.setState({
                    payopt: event.target.value,
                    bankChargesPer: value.BankCharges,
                    payBtnDisable: false,
                    pgname: event.target.parentNode.textContent,
                  });
                }}
                showValue={value.DisplayText}
                name="PGType"
                bgColor={color.primary}
              /> */}
              <PgBlock
                value={value.pg}
                selected={this.state.payopt === value.pg ? true : false}
                onClick={(event) => {
                  this.setState({
                    payopt: value.pg,
                    bankChargesPer: value.BankCharges,
                    payBtnDisable: false,
                    pgname: value.pg,
                    checkTandC: true,
                  });
                }}
                name="PGType"
              />
            </div>
          );
        }
        return (
          <React.Fragment>
            <div className="card">
              <div className="pay-opts">{items}</div>
              <div className="flex-all-c secure-msg">
                {/* <Securelogo /> */}
                {renderImg('Securelogo')}
              </div>
            </div>
            {alredaySelPg && orderTimestamp &&
              <div>
                {/* <div className="warning--wrapper">
                  <div style={{ display: 'flex', justifyContent: 'center', paddingRight: '6px' }}>{renderImg('paymentMsg')}</div>
                  <div
                    style={{
                      fontSize: '14px',
                      fontWeight: '600',
                      lineHeight: '20px',
                      color: '#1EB24B'
                    }}
                  >Please wait till {this.showTime(orderTimestamp)} to get the payment confirmation</div>
                </div> */}

                <div className="warning--wrapper">
                  <div style={{ display: 'flex', justifyContent: 'center', paddingRight: '6px' }}>{renderImg('paymentMsg')}</div>
                  <div
                    style={{
                      fontSize: '14px',
                      fontWeight: '600',
                      lineHeight: '20px',
                      color: '#1EB24B'
                    }}
                  >We can take up to 20 minutes to get payment confirmation</div>
                </div>
              </div>
            }
            {this.showPayBtn()}
            {/* <table>{table}</table> */}
          </React.Fragment>
        );
      } else {
        return (
          <React.Fragment>
            <div className="card">
              <div className="flex-all-c secure-msg">
                {/* <Securelogo /> */}
                {renderImg('Securelogo')}
              </div>
            </div>
            {this.showPayBtn()}
          </React.Fragment>
        );
      }
    } else {
      return (
        <div className="card">
          <div>
            By clicking on "Proceed" below, I agree to the{" "}
            <a
              href="/terms_and_conditions"
              target="_blank"
              style={{ color: color.primary }}
            >
              Terms and Conditions
            </a>
          </div>
          {this.showPayBtn()}
        </div>
      );
    }
  };

  checkGst = () => {
    if (this.state.customerGSTN === "on") {
      if (
        /^([0-9]){2}([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}([0-9]){1}([Zz]){1}([a-zA-Z0-9]){1}?$/.test(
          this.state.companyGSTNo
        )
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };

  validation = () => {
    var validationError = [];
    var temp = true;
    const ord =
      this.props.search.order.length !== 0 ? this.props.search.order : false;
    if (ord) {
      if (this.state.countryCode === "") {
        validationError.push(" country code");
        temp = false;
      }

      if (this.state.mobile === "") {
        validationError.push(" mobile no");
        temp = false;
      }

      if (this.state.email === "") {
        validationError.push(" email id");
        temp = false;
      }
      const onwards = ord.onward.seatDetails;
      Object.keys(onwards).forEach((el) => {
        if (!onwards[el].name) {
          validationError.push(" passenger name");
          temp = false;
        }
        if (!onwards[el].age) {
          validationError.push(" passenger age");
          temp = false;
        }
        if (!onwards[el].gender) {
          validationError.push(" passenger gender");
          temp = false;
        }
        if (onwards[el].concessionType) {

          if (!onwards[el].idCardType) {
            validationError.push(" passenger id card");
            temp = false;
          }

          if (!onwards[el].idCardNo) {
            validationError.push(" passenger id card no");
            temp = false;
          }
          if (onwards[el].idCardNo && onwards[el].idCardType === 'PAN' && onwards[el].idCardNo.toString().length < 10) {
            validationError.push("valid PAN");
            temp = false;
          }
          if (onwards[el].idCardNo && onwards[el].idCardType === 'AADHAR' && onwards[el].idCardNo.toString().length < 12) {
            validationError.push("valid AADHAR");
            temp = false;
          }
        }
      });

      if (ord.return && ord.return.seats) {
        const returns = ord.return.seatDetails;
        Object.keys(returns).forEach((el) => {
          if (!returns[el].name) {
            validationError.push(" passenger name for return trip");
            temp = false;
          }
          if (!returns[el].age) {
            validationError.push("passenger age for return trip");
            temp = false;
          }
          if (!returns[el].gender) {
            validationError.push(" passenger gender for return trip");
            temp = false;
          }
          if (returns[el].concessionType) {

            if (!returns[el].idCardType) {
              validationError.push(" passenger id card for return trip");
              temp = false;
            }

            if (!returns[el].idCardNo) {
              validationError.push(" passenger id card no for return trip");
              temp = false;
            }
            if (returns[el].idCardNo && returns[el].idCardType === 'PAN' && returns[el].idCardNo.toString().length < 10) {
              validationError.push("valid PAN for return trip");
              temp = false;
            }
            if (returns[el].idCardNo && returns[el].idCardType === 'AADHAR' && returns[el].idCardNo.toString().length < 12) {
              validationError.push("valid AADHAR for return trip");
              temp = false;
            }
          }
        });
      }

      if (this.state.payopt === "") {
        validationError.push(" payment gateway details");
        temp = false;
      }

      if (temp === false) {
        this.setState({ alerterror: "Kindly enter " + validationError });
      } else {
        let countryCode = /^[0-9\-\+]+$/.test(this.state.countryCode);
        let indianMobNo =
          (this.state.mobile + "").length === 10 &&
          /^[0]?[6789]\d{9}$/.test(this.state.mobile);
        let internationalNo =
          (this.state.mobile + "").length < 20 &&
          /^[0-9\-]+$/.test(this.state.mobile);
        let mobile =
          countryCode && this.state.countryCode === "+91"
            ? indianMobNo
            : internationalNo;
        let email = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
          this.state.email
        );
        if (!mobile) {
          this.setState({ alerterror: "Kindly enter valid mobile no" });
        } else if (!email) {
          this.setState({ alerterror: "Kindly enter valid email id" });
        } else {
          var gstValidation = this.checkGst();
          if (gstValidation === false) {
            this.setState({ alerterror: "Kindly enter valid GSTN" });
          }
        }
      }
    }
  };
  validatepassngerlist = (alertflag = false) => {
    const ord =
      this.props.search.order.length !== 0 ? this.props.search.order : false;
    const onwards = ord.onward.seatDetails;
    let validationError = [];
    let temp = true;
    // console.log("jjj", onwards[ord.onward.seats[0]].age);
    // console.log("ord", ord);
    if (ord) {
      Object.keys(onwards).forEach((el) => {
        if (!onwards[el].name) {
          !validationError.includes(" passenger name") &&
            validationError.push(" passenger name");
          temp = false;
        }
        if (!onwards[el].age) {
          !validationError.includes(" passenger age") &&
            validationError.push(" passenger age");
          temp = false;
        }
        if (!onwards[el].gender) {
          !validationError.includes(" passenger gender") &&
            validationError.push(" passenger gender");
          temp = false;
        }
        if (onwards[el].concessionType) {

          if (!onwards[el].idCardType) {
            !validationError.includes(" passenger id card") &&
              validationError.push("passenger id card");
            temp = false;
          }

          if (!onwards[el].idCardNo) {
            !validationError.includes(" passenger id card no") &&
              validationError.push("passenger id card no");
            temp = false;
          }
          if (onwards[el].idCardType === 'PAN' && onwards[el].idCardNo && onwards[el].idCardNo.toString().length < 10) {
            !validationError.includes("valid  PAN") &&
              validationError.push("valid  PAN");
            temp = false;
          }

          if (onwards[el].idCardType === 'AADHAR' && onwards[el].idCardNo && onwards[el].idCardNo.toString().length < 12) {
            !validationError.includes("valid  AADHAR") &&
              validationError.push("valid  AADHAR");
            temp = false;
          }

        }
      });
      if (ord.return && ord.return.seats) {
        const returns = ord.return.seatDetails;
        Object.keys(returns).forEach((el) => {
          if (!returns[el].name) {
            validationError.push(" passenger name for return trip");
            temp = false;
          }
          if (!returns[el].age) {
            validationError.push("passenger age for return trip");
            temp = false;
          }
          if (!returns[el].gender) {
            validationError.push(" passenger gender for return trip");
            temp = false;
          }

          if (returns[el].concessionType) {

            if (!returns[el].idCardType) {
              !validationError.includes(" passenger id card") &&
                validationError.push("passenger id card");
              temp = false;
            }

            if (!returns[el].idCardNo) {
              !validationError.includes(" passenger id card no") &&
                validationError.push("passenger id card no");
              temp = false;
            }

            if (returns[el].idCardType === 'PAN' && returns[el].idCardNo && returns[el].idCardNo.toString().length < 10) {
              !validationError.includes("valid  PAN") &&
                validationError.push("valid  PAN");
              temp = false;
            }

            if (returns[el].idCardType === 'AADHAR' && returns[el].idCardNo && returns[el].idCardNo.toString().length < 12) {
              !validationError.includes("valid  AADHAR") &&
                validationError.push("valid  AADHAR");
              temp = false;
            }

          }
        });
      }

      if (temp === false && alertflag) {
        this.setState({ alerterror: "Kindly enter " + validationError });
        return false;
      } else if (onwards[ord.onward.seats[0]].age < 13) {
        this.setState({ alerterror: "1st passenger age should be greater than 12" });
      } else if (ord.return && ord.return.seats && ord.return.seatDetails && ord.return.seatDetails[ord.return.seats[0]].age < 13) {
        this.setState({ alerterror: "1st Return passenger age should be greater than 12" });
      } else {
        return temp;
      }
    }
  };
  validatePayeeDetail = () => {
    let loginType = this.state.loginType;
    let validationError = [];
    let temp = true;
    let countryCode = /^[0-9\-\+]+$/.test(this.state.countryCode);
    let indianMobNo =
      (this.state.mobile + "").length === 10 &&
      /^[0]?[6789]\d{9}$/.test(this.state.mobile);
    let internationalNo =
      (this.state.mobile + "").length < 20 &&
      /^[0-9\-]+$/.test(this.state.mobile);
    let mobile =
      countryCode && this.state.countryCode === "+91"
        ? indianMobNo
        : internationalNo;
    let email = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
      this.state.email
    );
    if (this.state.countryCode === "" && loginType === 'guest') {
      validationError.push(" country code");
      temp = false;
    }
    if (this.state.mobile === "" && loginType === 'guest') {
      validationError.push(" mobile no");
      temp = false;
    }
    if (this.state.email === "") {
      validationError.push(" email id");
      temp = false;
    }
    if (this.state.password === "" && loginType === 'login') {
      validationError.push("password");
      temp = false;
    }
    if (!mobile && this.state.mobile !== "" && loginType === 'guest') {
      validationError.push(" valid mobile no");
      temp = false;
    } else if (!email && this.state.email !== "") {
      validationError.push(" valid email id");
      temp = false;
    } else {
      var gstValidation = this.checkGst();
      if (gstValidation === false) {
        validationError.push(" valid GSTN");
        temp = false;
      }
    }
    if (temp === false) {
      this.setState({ alerterror: "Kindly enter " + validationError });
      return false;
    } else {
      return temp;
    }
  };
  isInLocalList(passengerentry) {
    let LocalList = JSON.parse(localStorage.getItem("userinfotable")) || [];
    LocalList.map((el) => { });
    for (var i = 0; i < LocalList.length; i++) {
      if (this.checkequality(passengerentry, LocalList[i])) {
        return true;
      }
    }
    return false;
  }

  loggedinCouponDetails = () => {
    if (this.state.getCouponsDetails) {
      this.setState({ showCouponBlock: true, showPayeeBlock: false })
    }
  }

  storeInLocal = () => {
    let userprops = this.props.search.order;
    let onwarduserinfo = userprops.onward.seatDetails;
    let userinfotable = JSON.parse(localStorage.getItem("userinfotable"));
    userinfotable = userinfotable ? userinfotable : [];

    Object.keys(onwarduserinfo).map((el) => {
      if (
        !this.isInLocalList([
          onwarduserinfo[el].name,
          onwarduserinfo[el].age,
          onwarduserinfo[el].gender,
          onwarduserinfo[el].concessionType,
          onwarduserinfo[el].idCardType,
          onwarduserinfo[el].idCardNo,
          onwarduserinfo[el].nationality
        ])
      ) {
        userinfotable.push([
          onwarduserinfo[el].name,
          onwarduserinfo[el].age,
          onwarduserinfo[el].gender,
          onwarduserinfo[el].concessionType,
          onwarduserinfo[el].idCardType,
          onwarduserinfo[el].idCardNo,
          onwarduserinfo[el].nationality
        ]);
      }
    });
    if (this.state.isRoundtrip) {
      let returnUserInfo = userprops.return.seatDetails;
      Object.keys(returnUserInfo).map((el) => {
        if (
          !this.isInLocalList([
            returnUserInfo[el].name,
            returnUserInfo[el].age,
            returnUserInfo[el].gender,
            returnUserInfo[el].concessionType,
            returnUserInfo[el].idCardType,
            returnUserInfo[el].idCardNo,
            returnUserInfo[el].nationality
          ])
        ) {
          userinfotable.push([
            returnUserInfo[el].name,
            returnUserInfo[el].age,
            returnUserInfo[el].gender,
            returnUserInfo[el].concessionType,
            returnUserInfo[el].idCardType,
            returnUserInfo[el].idCardNo,
            returnUserInfo[el].nationality
          ]);
        }
      });
    }
    userinfotable = userinfotable.slice(Math.max(userinfotable.length - 6, 0));
    window.localStorage.setItem("userinfotable", JSON.stringify(userinfotable));
  };
  checkequality(a, b) {
    var aProps = Object.getOwnPropertyNames(a);
    var bProps = Object.getOwnPropertyNames(b);
    if (aProps.length !== bProps.length) {
      return false;
    }
    for (var i = 0; i < aProps.length; i++) {
      var propName = aProps[i];
      if (a[propName] !== b[propName]) {
        return false;
      }
    }
    if (a != []) {
      return true;
    } else {
      return false;
    }
  }
  showPayBtn = () => {

    const TotalFare = this.state.updatedOnwardFare + this.state.updatedReturnFare + this.state.onwardSc + this.state.returnSc + this.state.insuranceVal;
    let couponDiscount = parseInt(this.state.CouponDiscountAmt + this.state.CouponDiscountAmt2 + this.state.CouponDiscountAmt3 + this.state.roundTripdiscount + this.state.discount, 10);

    if (this.state.isRoundtrip) {

      let otDisAmt = 0;

      if (this.state.CouponDiscountAmt > 0 && this.state.CouponDiscountType === "OT") {
        otDisAmt = this.state.CouponDiscountAmt;
      }

      if (this.state.CouponDiscountAmt2 > 0 && this.state.CouponDiscountType2 === "OT") {
        otDisAmt = this.state.CouponDiscountAmt2;
      }

      if (this.state.CouponDiscountAmt3 > 0 && this.state.CouponDiscountType3 === "OT") {
        otDisAmt = this.state.CouponDiscountAmt3;
      }

      let onwardTripFare = this.state.updatedOnwardFare + this.state.onwardPickcharges + this.state.onwardDropcharges + this.state.onwardInsuranceAmt - this.state.discountAmt - this.state.onwardRoundTripDiscount;

      if (otDisAmt > onwardTripFare) {
        //first remove open ticket discount amount from total discount given 
        couponDiscount = couponDiscount - otDisAmt;
        otDisAmt = onwardTripFare;
        //now add new open ticket discount amount in total discount given
        couponDiscount = couponDiscount + otDisAmt;
      }
    }

    let isActive = false;
    const ord =
      this.props.search.order.length !== 0 ? this.props.search.order : false;
    const currency = this.props.search.currency;
    const amountToPay = this.amountToPayBlock();
    const bankCharges = this.bankChargesCalculationBlock();
    if (ord) {
      let temp = true;
      let conc = true;
      const onwards = ord.onward.seatDetails;
      Object.keys(onwards).forEach((el) => {
        if (!onwards[el].name || !onwards[el].age || !onwards[el].gender) {
          temp = false;
        }
      });

      Object.keys(onwards).forEach((el) => {
        if (onwards[el].concessionType && !onwards[el].idCardType && !onwards[el].idCardType) {
          temp = false;
        }
      });

      if (temp && ord.return && ord.return.seats) {
        const returns = ord.return.seatDetails;
        Object.keys(returns).forEach((el) => {
          if (!returns[el].name || !returns[el].age || !returns[el].gender) {
            temp = false;
          }
        });
        Object.keys(returns).forEach((el) => {
          if (returns[el].concessionType && !returns[el].idCardType && !returns[el].idCardType) {
            temp = false;
          }
        });
      }
      let email = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
        this.state.email
      );
      let countryCode = /^[0-9\-\+]+$/.test(this.state.countryCode);
      let indianMobNo =
        (this.state.mobile + "").length === 10 &&
        /^[0]?[6789]\d{9}$/.test(this.state.mobile);
      let internationalNo =
        (this.state.mobile + "").length < 20 &&
        /^[0-9\-]+$/.test(this.state.mobile);
      let mobile =
        countryCode && this.state.countryCode === "+91"
          ? indianMobNo
          : internationalNo;

      if (
        temp &&
        email &&
        this.state.email.length > 0 &&
        mobile &&
        this.checkGst() &&
        countryCode
      ) {
        isActive = true;
      }
    }

    if (ord && TotalFare === couponDiscount) {
      return (
        <div
          className="flex-all-c navswitchbtn"
          style={{
            color: !isActive ? "#666" : "#fff",
            background: !isActive ? "#ddd" : color.secondary,
            boxShadow: "0 0 5px rgba(0, 0, 0, 0.2)",
            fontWeight: 500,
            cursor: "pointer",
            userSelect: "none",
            left: 0,
            bottom: 0,
            position: "absolute",
          }}
          onClick={!isActive ? this.validation : this.checkPayment}
        >
          Confirm Booking
        </div>
      );
    } else if (TotalFare === couponDiscount) {
      return (
        <div
          className="flex-all-c navswitchbtn"
          style={{
            color: !isActive ? "#666" : "#fff",
            background: !isActive ? "#ddd" : color.secondary,
            boxShadow: "0 0 5px rgba(0, 0, 0, 0.2)",
            fontWeight: 500,
            cursor: "pointer",
            userSelect: "none",
            left: 0,
            bottom: 0,
            position: "absolute",
          }}
          onClick={!isActive ? this.validation : this.checkPayment}
        >
          Confirm Booking
        </div>
      );
    } else if (this.state.payopt || (ord && ord.pgDetails.length === 0)) {
      return (
        <div
          className="flex-all-c navswitchbtn"
          style={{
            color: !isActive ? "#666" : "#fff",
            background: !isActive ? "#ddd" : color.secondary,
            boxShadow: "0 0 5px rgba(0, 0, 0, 0.2)",
            fontWeight: 500,
            cursor: "pointer",
            userSelect: "none",
            left: 0,
          }}
          onClick={!isActive ? this.validation : this.checkPayment}
        >
          PAY NOW {currency + " " + (amountToPay + bankCharges)} THROUGH{" "}
          {this.state.pgname}
        </div>
      );
    } else {
      return (
        <div
          className="flex-all-c navswitchbtn"
          style={{
            color: !isActive ? "#666" : "#fff",
            background: !isActive ? "#ddd" : color.secondary,
            boxShadow: "0 0 5px rgba(0, 0, 0, 0.2)",
            fontWeight: 500,
            cursor: "pointer",
            userSelect: "none",
            left: 0,
          }}
        >
          MAKE PAYMENT
        </div>
      );
    }
  };

  showOnwardTripDetails = () => {
    const info =
      this.props.search.order.length !== 0
        ? this.props.search.order.onward
        : false;
    const urlParams = new URLSearchParams(window.location.search);
    const linkfromstoptocity = urlParams.get("linkfromstoptocity");
    if (info) {
      return (
        <div>
          <div className="">
            <div className="loc-info pick" style={{ paddingTop: '16px' }}>
              <div style={{ marginBottom: '12px', color: '#202020' }}>{`${linkfromstoptocity ? 'Start' : 'Onward'}`} Trip Details</div>
              <div className="flex pick-up-label">
                <div className="pickdecor">
                  <div className="circleshape"></div>
                </div>
                Pickup at {info.fromCity} on {moment(info.journeyDate + ' ' + info.boardingTime).format("HH:mm")}
                {", "}
                {getDateFormatted3(info.journeyDate)}
              </div>
              <div className="loc-box flex">
                <div className="pickdecor">
                  <div className="verticle-line"></div>
                </div>
                <div style={{ marginTop: '4px' }}>
                  <div className="pickdropaddress">{info.boardingPoint}</div>
                </div>
              </div>
            </div>
            <div className="loc-info drop" style={{ paddingBottom: 0 }}>
              <div className="flex drop-off-label">
                <div className="pickdecor">
                  <div className="squareshape"></div>
                </div>
                Dropoff at {info.toCity} on {moment(info.arrivalDate + ' ' + info.arrivalTime).format("HH:mm")}
                {", "}
                {getDateFormatted3(info.arrivalDate)}
              </div>
              <div className="loc-box flex">
                <div className="pickdecor"></div>
                <div style={{ marginTop: '4px' }}>
                  <div className="pickdropaddress">{info.dropPoint}</div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="flex">
              {/* <Busicon className="mspacerite" /> */}
              {renderImg('Busicon')}
              {info.companyName}
              {/* {info.suffix ? ' - ' + info.suffix.toUpperCase() : ''} */}
            </div>
          </div>
        </div>
      );
    } else {
      return <div className="side-info">Loading...</div>;
    }
  };

  showReturnTripDetails = () => {
    const info = this.props.search.order.return;
    const urlParams = new URLSearchParams(window.location.search);
    const linkfromstoptocity = urlParams.get("linkfromstoptocity");
    return (
      <div>
        <div className="" style={{ borderTop: "1px solid #ddd", marginTop: "24px" }}>
          <div className="loc-info pick" style={{ marginTop: '24px', paddingTop: 0 }}>
            <div style={{ marginBottom: '12px', color: '#202020' }}>{`${linkfromstoptocity ? 'Connect' : 'Return'}`} Trip Details</div>
            <div className="flex pick-up-label">
              <div className="pickdecor">
                <div className="circleshape"></div>
              </div>
              Pickup at {info.fromCity} on {moment(info.journeyDate + ' ' + info.boardingTime).format("HH:mm")}
              {", "}
              {getDateFormatted3(info.journeyDate)}
            </div>
            <div className="loc-box flex">
              <div className="pickdecor">
                <div className="verticle-line"></div>
              </div>
              <div style={{ marginTop: '4px' }}>
                <div className="pickdropaddress">{info.boardingPoint}</div>
              </div>
            </div>
          </div>
          <div className="loc-info drop" style={{ paddingBottom: 0 }}>
            <div className="flex drop-off-label">
              <div className="pickdecor">
                <div className="squareshape"></div>
              </div>
              Dropoff at {info.toCity} on {moment(info.arrivalDate + ' ' + info.arrivalTime).format("HH:mm")}
              {", "}
              {getDateFormatted3(info.arrivalDate)}
            </div>
            <div className="loc-box flex">
              <div className="pickdecor"></div>
              <div style={{ marginTop: '4px' }}>
                <div className="pickdropaddress">{info.dropPoint}</div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="flex">
            {/* <Busicon className="mspacerite" /> */}
            {renderImg('Busicon')}
            {info.companyName}
          </div>
        </div>
      </div>
    );
  };

  showKsrtcOnwardPassDetails = () => {
    const loop =
      this.props.search.order.length !== 0
        ? this.props.search.order.onward.seatDetails
        : false;
    const urlParams = new URLSearchParams(window.location.search);
    const linkfromstoptocity = urlParams.get("linkfromstoptocity");
    if (loop) {
      return (
        <React.Fragment>
          {(
            <div className="roundtripshort onwrad--trip-bg flexed-justify">
              <div className="item-desc">
                {`${linkfromstoptocity ? 'Start' : 'Onward'}`} Trip ({Object.keys(loop).length > 1 ? Object.keys(loop).length + ' Berths' : Object.keys(loop).length + ' Berth'})
              </div>
              <div className="basefare">
                {this.props.search.currency}
                {this.state.updatedOnwardFare - this.state.onwardGst}
              </div>
              <div className="gst">
                {this.props.search.currency}
                {this.state.onwardGst}
              </div>
              <div className="total">
                {this.props.search.currency}
                {
                  this.state.updatedOnwardFare
                  //+ this.state.onwardPickcharges +
                  //this.state.onwardDropcharges +
                  //this.state.insuranceVal +
                  // this.state.onwardGst +
                  //this.state.onwardSc -
                  //this.state.roundTripdiscount -
                  //this.state.discount -
                  // this.state.CouponDiscountAmt -
                  // this.state.CouponDiscountAmt2 -
                  // this.state.CouponDiscountAmt3 -
                  //this.bankChargesCalculationBlock()
                }
              </div>
              <div
                className={`togglebutton ${this.state.showonwardsec ? "" : "plus"
                  }`}
                onClick={() => {
                  this.setState({ showonwardsec: !this.state.showonwardsec });
                }}
              ></div>
            </div>
          )}
          <div
            className={`side-info pass seat-dtls-bg ${this.state.showonwardsec ? "" : "hide"
              }`}
          >
            {Object.keys(loop).map((el) => {
              return (
                <div className="flexed-justify" key={el}>
                  <div className="item-desc">Seat/Berth :{el}</div>
                  <div className="basefare">
                    {this.props.search.currency}
                    {loop[el].fare - loop[el].serviceTax}
                  </div>
                  <div className="gst">
                    {this.props.search.currency}
                    {loop[el].serviceTax}
                  </div>
                  <div className="total">
                    {this.props.search.currency}
                    {loop[el].fare}
                  </div>
                </div>
              );
            })}
          </div>
        </React.Fragment>
      );
    } else {
      return <div className="side-info">Loading...</div>;
    }
  }

  showKASRTConwardFaredetails = (order) => {
    let levyFare = {};
    if (order && order.onward && order.onward.seatDetails) {
      Object.keys(order.onward.seatDetails).forEach((el) => {
        let levyList = order.onward.seatDetails[el].l || [];
        if (levyList.length > 0) {
          levyList.forEach((el) => {
            if (levyFare[el.n] != undefined) {
              levyFare[el.n] += el.a;
            } else {
              levyFare[el.n] = el.a;
            }
          })
        }
      })
    }

    return (
      <React.Fragment>
        <div className="checkout--fare">
          <div>ಹೋಗುವ ಪ್ರಯಾಣದ ದರಡ ವಿಂಗಡಣೆ / Onward Trip Fare Breakup</div>
        </div>
        <div className="checkout--fare">
          <div>ಮೂಲ ದರ / Original Basic Fare</div>
          <div>{this.props.search.currency}{this.state.updatedOnwardFare - this.state.onwardGst}</div>
        </div>
        {/* <div className="checkout--fare">
          <div>ಸ.ಸೇ.ಶು / GST</div>
          <div>{this.props.search.currency}{this.state.onwardGst}</div>
        </div> */}
        <div className="checkout--fare">
          <div>ಇತರೆ ಶುಲ್ಕಗಳು / Levies</div>
          <div>{this.props.search.currency}{this.state.onwardLevyAmount}</div>
        </div>
        <div className="checkout--fare">
          <div>ರಿಯಾಯಿತಿ ಮೊತ್ತ / Concession Amount</div>
          <div>
            {"-"}{this.props.search.currency}{this.state.onwardConAmt}
          </div>
        </div>
        <div className="checkout--fare">
          <div>ಒಟ್ಟು ಪ್ರಯಾಣದ ದರ / Total Fare</div>
          <div>
            {this.props.search.currency}{this.state.updatedOnwardFare - this.state.onwardGst + this.state.onwardLevyAmount - this.state.onwardConAmt}
          </div>
        </div>

        { }
        {
          Object.keys(levyFare).length > 0 &&
          <div className="checkout--fare">
            <span style={{ fontSize: '12px', color: '#444' }}>{`(`}
              {
                Object.keys(levyFare).map((val, index) => (
                  <span style={{ fontSize: '12px', color: '#444', fontWeight: '400' }} key={index}>
                    <span style={{ margin: '0 2px', color: '#444', fontWeight: '400' }}>{val}{":"}</span>
                    <span style={{ margin: '0 2px', color: '#444', fontWeight: '400' }}>{levyFare[val]}{Object.keys(levyFare).length - 1 < index ? ";" : ''}</span>
                  </span>
                ))
              }
              {`)`}</span>
          </div>

        }

      </React.Fragment>
    )
  }

  showKASRTCreturnFaredetails = (order) => {
    let levyFare = {};
    if (order && order.return && order.return.seatDetails) {
      Object.keys(order.return.seatDetails).forEach((el) => {
        let levyList = order.return.seatDetails[el].l || [];
        if (levyList.length > 0) {
          levyList.forEach((el) => {
            if (levyFare[el.n] != undefined) {
              levyFare[el.n] += el.a;
            } else {
              levyFare[el.n] = el.a;
            }
          })
        }
      })
    }
    return (
      <React.Fragment>
        <div className="checkout--fare" style={{ borderTop: '1px solid rgba(0,0,0,0.2)' }}>
          <div>ಮುಂದಿನ ಪ್ರಯಾಣ ದರದ ವಿರಾಮ / Return Trip Fare Breakup</div>
        </div>
        <div className="checkout--fare">
          <div>ಮೂಲ ದರ / Original Basic Fare</div>
          <div>{this.props.search.currency}{this.state.updatedReturnFare - this.state.returnGst}</div>
        </div>
        {/* <div className="checkout--fare">
          <div>ಸ.ಸೇ.ಶು / GST</div>
          <div>{this.props.search.currency}{this.state.returnGst}</div>
        </div> */}
        <div className="checkout--fare">
          <div>ಇತರೆ ಶುಲ್ಕಗಳು / Levies</div>
          <div>{this.props.search.currency}{this.state.returnLevyAmount}</div>
        </div>
        <div className="checkout--fare">
          <div>ರಿಯಾಯಿತಿ ಮೊತ್ತ / Concession Amount</div>
          <div>
            {"-"}{this.props.search.currency}{this.state.returnConAmt}
          </div>
        </div>
        <div className="checkout--fare">
          <div>ಒಟ್ಟು ಪ್ರಯಾಣದ ದರ / Total Fare</div>
          <div>
            {this.props.search.currency}{this.state.updatedReturnFare - this.state.returnGst + this.state.returnLevyAmount - this.state.returnConAmt}
          </div>
        </div>
        {
          Object.keys(levyFare).length > 0 &&
          <div className="checkout--fare">
            <span style={{ fontSize: '12px', color: '#444' }}>{`(`}
              {
                Object.keys(levyFare).map((val, index) => (
                  <span style={{ fontSize: '12px', color: '#444', fontWeight: '400' }} key={index}>
                    <span style={{ margin: '0 2px', color: '#444', fontWeight: '400' }}>{val}{":"}</span>
                    <span style={{ margin: '0 2px', color: '#444', fontWeight: '400' }}>{levyFare[val]}{Object.keys(levyFare).length - 1 < index ? ";" : ''}</span>
                  </span>
                ))
              }
              {`)`}</span>
          </div>

        }

      </React.Fragment>
    )
  }

  showOnwardPassDetails = () => {
    const loop =
      this.props.search.order.length !== 0
        ? this.props.search.order.onward.seatDetails
        : false;

    if (loop) {
      return (
        <React.Fragment>
          <div className="roundtripshort flexed-justify">
            <div className="item-desc">
              Onward Trip Fare ({Object.keys(loop).length > 1 ? Object.keys(loop).length + ' Berths' : Object.keys(loop).length + ' Berth'})
            </div>
            <div className="basefare">
              {this.props.search.currency}
              {this.state.updatedOnwardFare - this.state.onwardGst}
            </div>
            <div className="gst">
              {this.props.search.currency}
              {this.state.onwardGst}
            </div>
            <div className="total">
              {this.props.search.currency}
              {this.state.updatedOnwardFare
                /*+this.state.onwardPickcharges +
                this.state.onwardDropcharges +
                this.state.insuranceVal +
                this.state.onwardGst +
                this.state.onwardSc -
                this.state.roundTripdiscount -
                this.state.discount -
                this.state.CouponDiscountAmt -
                this.state.CouponDiscountAmt2 -
                this.state.CouponDiscountAmt3 -
              this.bankChargesCalculationBlock()*/}
            </div>
            <div
              className={`togglebutton ${this.state.showonwardsec ? "" : "plus"
                }`}
              onClick={() => {
                this.setState({ showonwardsec: !this.state.showonwardsec });
              }}
            ></div>
          </div>

          <div
            className={`side-info pass ${this.state.showonwardsec ? "" : "hide"
              }`}
          >
            {Object.keys(loop).map((el) => {
              return (
                <div className="flexed-justify" key={el}>
                  <div className="item-desc">Seat/Berth :{el}</div>
                  <div className="basefare">
                    {this.props.search.currency}
                    {loop[el].fare - loop[el].serviceTax}
                  </div>
                  <div className="gst">
                    {this.props.search.currency}
                    {loop[el].serviceTax}
                  </div>
                  <div className="total">
                    {this.props.search.currency}
                    {loop[el].fare}
                  </div>
                </div>
              );
            })}
          </div>
        </React.Fragment>
      );
    } else {
      return <div className="side-info">Loading...</div>;
    }
  };

  showReturnPassDetails = () => {
    const loop = this.props.search.order.return.seatDetails;
    const urlParams = new URLSearchParams(window.location.search);
    const linkfromstoptocity = urlParams.get("linkfromstoptocity");
    return (
      <React.Fragment>
        {this.state.isRoundtrip ? (
          <div className="roundtripshort return-trip-bg flexed-justify">
            <div className="item-desc">
              {`${linkfromstoptocity ? 'Connect' : 'Return'}`} Trip  ({Object.keys(loop).length > 1 ? Object.keys(loop).length + ' Berths' : Object.keys(loop).length + ' Berth'})
            </div>
            <div className="basefare">
              {this.props.search.currency}
              {this.state.updatedReturnFare - this.state.returnGst}
            </div>
            <div className="gst">
              {this.props.search.currency}
              {this.state.returnGst}
            </div>
            <div className="total">
              {this.props.search.currency}
              {this.state.updatedReturnFare
                /*+ this.state.returnGst +
                this.state.returnSc +
                this.state.returnDropcharges +
                this.state.returnPickcharges +
              this.state.returnRoundTripDiscount*/}
            </div>
            <div
              className={`togglebutton ${this.state.showreturnsec ? "" : "plus"
                }`}
              onClick={() => {
                this.setState({ showreturnsec: !this.state.showreturnsec });
              }}
            ></div>
          </div>
        ) : (
          ""
        )}
        <div
          className={`side-info pass seat-dtls-bg ${this.state.showreturnsec ? "" : "hide"}`}
          key="returndetail"
        >
          {Object.keys(loop).map((el) => {
            return (
              <div className="flexed-justify" key={el}>
                <div className="item-desc">Seat/Berth :{el}</div>
                <div className="basefare">
                  {this.props.search.currency}
                  {loop[el].fare - loop[el].serviceTax}
                </div>
                <div className="gst">
                  {this.props.search.currency}
                  {loop[el].serviceTax}
                </div>
                <div className="total">
                  {this.props.search.currency}
                  {loop[el].fare}
                </div>
              </div>
            );
          })}
        </div>
      </React.Fragment>
    );
  };
  /*showOnwardFareDetails = () => {
    return (
      <div
        className={`side-info fare ${this.state.showonwardsec || !this.state.isRoundtrip ? "" : "hide"
          }`}
        key="faredetail"
      >
        {this.state.onwardPickcharges + this.state.onwardDropcharges !== 0 ? (
          <div className="side-det">
            <div style={{ width: "80%", display: "inline-block" }}>
              Link Ticket Service Charge&nbsp;
            </div>
            <div
              style={{
                width: "20%",
                display: "inline-block",
                textAlign: "right",
              }}
            >
              {this.props.search.currency}
              {this.state.onwardPickcharges + this.state.onwardDropcharges}
            </div>
          </div>
        ) : (
          ""
        )}
        {this.props.search.order.showInsurance ? (
          <div className="side-det">
            <div>Insurance Fees*</div>
            <div>
              {this.props.search.currency}
              {this.state.insuranceVal}
            </div>
          </div>
        ) : (
          ""
        )}
        {this.state.onwardSc !== 0 ? (
          <div className="side-det">
            <div>Service Charge</div>
            <div>
              {this.props.search.currency}
              {this.state.onwardSc}
            </div>
          </div>
        ) : null}
        {this.state.roundTripdiscount !== 0 ? this.roundtripdiscount() : ""}
  
        {this.state.discount > 0 && (
          <div className="side-det discountsec">
            <div>Discount</div>
            <div>
              {"- " + this.props.search.currency}
              {this.state.discount}
            </div>
          </div>
        )}
        {this.state.CouponDiscountAmt !== 0 ? (
          <div className="side-det discountsec">
            <div>
              {this.state.CouponDiscountType !== "PC"
                ? `Coupon Discount(${this.state.CouponDiscountType})`
                : "Prepaid card deduction"}
            </div>
            <div>
              {"- " + this.props.search.currency}
              {parseInt(this.state.CouponDiscountAmt, 10)}
            </div>
          </div>
        ) : (
          ""
        )}
        {this.state.CouponDiscountAmt2 !== 0 ? (
          <div className="side-det discountsec">
            <div>
              {this.state.CouponDiscountType2 !== "PC"
                ? `Coupon Discount(${this.state.CouponDiscountType2})`
                : "Prepaid card deduction"}
            </div>
            <div>
              {"- " + this.props.search.currency}
              {parseInt(this.state.CouponDiscountAmt2, 10)}
            </div>
          </div>
        ) : (
          ""
        )}
        {this.state.CouponDiscountAmt3 !== 0 ? (
          <div className="side-det discountsec">
            <div>
              {this.state.CouponDiscountType3 !== "PC"
                ? `Coupon Discount(${this.state.CouponDiscountType3})`
                : "Prepaid card deduction"}
            </div>
            <div>
              {"- " + this.props.search.currency}
              {parseInt(this.state.CouponDiscountAmt3, 10)}
            </div>
          </div>
        ) : (
          ""
        )}
        {this.state.bankChargesPer !== 0 ? this.bankChargesCalculation() : ""}
      </div>
    );
  };*/
  /*showReturnFareDetails = () => {
    return (
      <div
        className={`side-info fare ${this.state.showreturnsec ? "" : "hide"}`}
        key="faredetail"
      >
        {this.state.returnPickcharges + this.state.returnDropcharges !== 0 ? (
          <div className="side-det">
            <div style={{ width: "80%", display: "inline-block" }}>
              Link Ticket Service Charge&nbsp;
            </div>
            <div
              style={{
                width: "20%",
                display: "inline-block",
                textAlign: "right",
              }}
            >
              {this.props.search.currency}
              {this.state.returnPickcharges + this.state.returnDropcharges}
            </div>
          </div>
        ) : (
          ""
        )}
        {this.state.returnSc !== 0 ? (
          <div className="side-det">
            <div>Service Charge</div>
            <div>
              {this.props.search.currency}
              {this.state.returnSc}
            </div>
          </div>
        ) : null}
      </div>
    );
  };*/


  showPrepaidCardDiscount = () => {
    return (
      <React.Fragment>
        {
          this.state.CouponDiscountAmt > 0 && this.state.CouponDiscountType === "PC" ? (
            <div className="side-det discountsec">
              <div>Prepaid Card Discount</div>
              <div>
                {"- " + this.props.search.currency}
                {parseInt(this.state.CouponDiscountAmt, 10)}
              </div>
            </div>
          ) : (
            ""
          )
        }
        {
          this.state.CouponDiscountAmt2 > 0 && this.state.CouponDiscountType2 === "PC" ? (
            <div className="side-det discountsec">
              <div>Prepaid Card Discount</div>
              <div>
                {"- " + this.props.search.currency}
                {parseInt(this.state.CouponDiscountAmt2, 10)}
              </div>
            </div>
          ) : (
            ""
          )
        }
        {this.state.CouponDiscountAmt3 > 0 && this.state.CouponDiscountType3 === "PC" ? (
          <div className="side-det discountsec">
            <div>Prepaid Card Discount</div>
            <div>
              {"- " + this.props.search.currency}
              {parseInt(this.state.CouponDiscountAmt3, 10)}
            </div>
          </div>
        ) : (
          ""
        )}
      </React.Fragment>
    );
  }

  showLoyaltyWalletDiscount = () => {
    return (
      <React.Fragment>
        {this.state.CouponDiscountAmt > 0 && this.state.CouponDiscountType === "LW" ? (
          <div className="side-det discountsec">
            <div>Loyalty Wallet Discount</div>
            <div>
              {"- " + this.props.search.currency}
              {parseInt(this.state.CouponDiscountAmt, 10)}
            </div>
          </div>
        ) : (
          ""
        )}
        {this.state.CouponDiscountAmt2 > 0 && this.state.CouponDiscountType2 === "LW" ? (
          <div className="side-det discountsec">
            <div>Loyalty Wallet Discount</div>
            <div>
              {"- " + this.props.search.currency}
              {parseInt(this.state.CouponDiscountAmt2, 10)}
            </div>
          </div>
        ) : (
          ""
        )}
        {this.state.CouponDiscountAmt3 > 0 && this.state.CouponDiscountType3 === "LW" ? (
          <div className="side-det discountsec">
            <div>Loyalty Wallet Discount</div>
            <div>
              {"- " + this.props.search.currency}
              {parseInt(this.state.CouponDiscountAmt3, 10)}
            </div>
          </div>
        ) : (
          ""
        )}
      </React.Fragment>
    )
  }

  showLoyaltyDiscount = () => {
    return (
      <React.Fragment>
        {this.state.CouponDiscountAmt > 0 && this.state.CouponDiscountType === "LT" ? (
          <div className="side-det discountsec">
            <div>Loyalty Discount</div>
            <div>
              {"- " + this.props.search.currency}
              {parseInt(this.state.CouponDiscountAmt, 10)}
            </div>
          </div>
        ) : (
          ""
        )}
        {this.state.CouponDiscountAmt2 > 0 && this.state.CouponDiscountType2 === "LT" ? (
          <div className="side-det discountsec">
            <div>Loyalty Discount</div>
            <div>
              {"- " + this.props.search.currency}
              {parseInt(this.state.CouponDiscountAmt2, 10)}
            </div>
          </div>
        ) : (
          ""
        )}
        {this.state.CouponDiscountAmt3 > 0 && this.state.CouponDiscountType3 === "LT" ? (
          <div className="side-det discountsec">
            <div>Loyalty Discount</div>
            <div>
              {"- " + this.props.search.currency}
              {parseInt(this.state.CouponDiscountAmt3, 10)}
            </div>
          </div>
        ) : (
          ""
        )}
      </React.Fragment>
    )
  }

  showMarketingCoupon = () => {
    return (
      <React.Fragment>
        {this.state.CouponDiscountAmt > 0 && this.state.CouponDiscountType === "MC" ? (
          <div className="side-det discountsec">
            <div>Marketing Coupon</div>
            <div>
              {"- " + this.props.search.currency}
              {parseInt(this.state.CouponDiscountAmt, 10)}
            </div>
          </div>
        ) : (
          ""
        )}
        {this.state.CouponDiscountAmt2 > 0 && this.state.CouponDiscountType2 === "MC" ? (
          <div className="side-det discountsec">
            <div>Marketing Coupon</div>
            <div>
              {"- " + this.props.search.currency}
              {parseInt(this.state.CouponDiscountAmt2, 10)}
            </div>
          </div>
        ) : (
          ""
        )}
        {this.state.CouponDiscountAmt3 > 0 && this.state.CouponDiscountType3 === "MC" ? (
          <div className="side-det discountsec">
            <div>Marketing Coupon</div>
            <div>
              {"- " + this.props.search.currency}
              {parseInt(this.state.CouponDiscountAmt3, 10)}
            </div>
          </div>
        ) : (
          ""
        )}
      </React.Fragment>
    )
  }

  showOpenTicketCoupon = () => {

    let otDisAmt = 0;

    if (this.state.CouponDiscountAmt > 0 && this.state.CouponDiscountType === "OT") {
      otDisAmt = this.state.CouponDiscountAmt;
    }

    if (this.state.CouponDiscountAmt2 > 0 && this.state.CouponDiscountType2 === "OT") {
      otDisAmt = this.state.CouponDiscountAmt2;
    }

    if (this.state.CouponDiscountAmt3 > 0 && this.state.CouponDiscountType3 === "OT") {
      otDisAmt = this.state.CouponDiscountAmt3;
    }

    let onwardTripFare = this.state.updatedOnwardFare + this.state.onwardPickcharges + this.state.onwardDropcharges + this.state.onwardInsuranceAmt - this.state.discountAmt - this.state.onwardRoundTripDiscount;

    if (this.state.isRoundtrip && otDisAmt > onwardTripFare) {
      otDisAmt = onwardTripFare;
    }

    return (
      <React.Fragment>
        {otDisAmt > 0 ? (
          <div className="side-det discountsec">
            <div>Open Ticket Coupon</div>
            <div>
              {"- " + this.props.search.currency}
              {parseInt(otDisAmt, 10)}
            </div>
          </div>
        ) : (
          ""
        )}
      </React.Fragment>
    )
  }

  showReferralCoupon = () => {
    return (
      <React.Fragment>
        {this.state.CouponDiscountAmt > 0 && this.state.CouponDiscountType === "RC" ? (
          <div className="side-det discountsec">
            <div>Referral Coupon</div>
            <div>
              {"- " + this.props.search.currency}
              {parseInt(this.state.CouponDiscountAmt, 10)}
            </div>
          </div>
        ) : (
          ""
        )}
        {this.state.CouponDiscountAmt2 > 0 && this.state.CouponDiscountType2 === "RC" ? (
          <div className="side-det discountsec">
            <div>Referral Coupon</div>
            <div>
              {"- " + this.props.search.currency}
              {parseInt(this.state.CouponDiscountAmt2, 10)}
            </div>
          </div>
        ) : (
          ""
        )}
        {this.state.CouponDiscountAmt3 > 0 && this.state.CouponDiscountType3 === "RC" ? (
          <div className="side-det discountsec">
            <div>Referral Coupon</div>
            <div>
              {"- " + this.props.search.currency}
              {parseInt(this.state.CouponDiscountAmt3, 10)}
            </div>
          </div>
        ) : (
          ""
        )}

      </React.Fragment>
    )
  }

  showDiscountCoupon = () => {
    return (
      <React.Fragment>
        {this.state.CouponDiscountAmt > 0 && this.state.CouponDiscountType === "DC" ? (
          <div className="side-det discountsec">
            <div>Discount Coupon</div>
            <div>
              {"- " + this.props.search.currency}
              {parseInt(this.state.CouponDiscountAmt, 10)}
            </div>
          </div>
        ) : (
          ""
        )}
        {this.state.CouponDiscountAmt2 > 0 && this.state.CouponDiscountType2 === "DC" ? (
          <div className="side-det discountsec">
            <div>Discount Coupon</div>
            <div>
              {"- " + this.props.search.currency}
              {parseInt(this.state.CouponDiscountAmt2, 10)}
            </div>
          </div>
        ) : (
          ""
        )}
        {this.state.CouponDiscountAmt3 > 0 && this.state.CouponDiscountType3 === "DC" ? (
          <div className="side-det discountsec">
            <div>Discount Coupon</div>
            <div>
              {"- " + this.props.search.currency}
              {parseInt(this.state.CouponDiscountAmt3, 10)}
            </div>
          </div>
        ) : (
          ""
        )}
      </React.Fragment>
    )
  }

  showRoundTripCoupon = () => {
    return (
      <React.Fragment>
        {this.state.CouponDiscountAmt > 0 && this.state.CouponDiscountType === "RT" ? (
          <div className="side-det discountsec">
            <div>Round Trip Coupon</div>
            <div>
              {"- " + this.props.search.currency}
              {parseInt(this.state.CouponDiscountAmt, 10)}
            </div>
          </div>
        ) : (
          ""
        )}

        {this.state.CouponDiscountAmt2 > 0 && this.state.CouponDiscountType2 === "RT" ? (
          <div className="side-det discountsec">
            <div>Round Trip Coupon</div>
            <div>
              {"- " + this.props.search.currency}
              {parseInt(this.state.CouponDiscountAmt2, 10)}
            </div>
          </div>
        ) : (
          ""
        )}

        {this.state.CouponDiscountAmt3 > 0 && this.state.CouponDiscountType3 === "RT" ? (
          <div className="side-det discountsec">
            <div>Round Trip Coupon</div>
            <div>
              {"- " + this.props.search.currency}
              {parseInt(this.state.CouponDiscountAmt3, 10)}
            </div>
          </div>
        ) : (
          ""
        )}
      </React.Fragment>
    )
  }

  showVoucherType = () => {
    return (
      <React.Fragment>
        {this.state.CouponDiscountAmt > 0 && this.state.CouponDiscountType === "VT" ? (
          <div className="side-det discountsec">
            <div>Voucher Type</div>
            <div>
              {"- " + this.props.search.currency}
              {parseInt(this.state.CouponDiscountAmt, 10)}
            </div>
          </div>
        ) : (
          ""
        )}

        {this.state.CouponDiscountAmt2 > 0 && this.state.CouponDiscountType2 === "VT" ? (
          <div className="side-det discountsec">
            <div>Voucher Type</div>
            <div>
              {"- " + this.props.search.currency}
              {parseInt(this.state.CouponDiscountAmt2, 10)}
            </div>
          </div>
        ) : (
          ""
        )}

        {this.state.CouponDiscountAmt3 > 0 && this.state.CouponDiscountType3 === "VT" ? (
          <div className="side-det discountsec">
            <div>Voucher Type</div>
            <div>
              {"- " + this.props.search.currency}
              {parseInt(this.state.CouponDiscountAmt3, 10)}
            </div>
          </div>
        ) : (
          ""
        )}
      </React.Fragment>
    )
  }

  showPrepaidCardPass = () => {
    return (
      <React.Fragment>
        {
          this.state.CouponDiscountAmt > 0 && this.state.CouponDiscountType === "PCC" ? (
            <div className="side-det discountsec">
              <div>Prepaid Card Pass</div>
              <div>
                {"- " + this.props.search.currency}
                {parseInt(this.state.CouponDiscountAmt, 10)}
              </div>
            </div>
          ) : (
            ""
          )
        }

        {
          this.state.CouponDiscountAmt2 > 0 && this.state.CouponDiscountType2 === "PCC" ? (
            <div className="side-det discountsec">
              <div>Prepaid Card Pass</div>
              <div>
                {"- " + this.props.search.currency}
                {parseInt(this.state.CouponDiscountAmt2, 10)}
              </div>
            </div>
          ) : (
            ""
          )
        }

        {
          this.state.CouponDiscountAmt3 > 0 && this.state.CouponDiscountType3 === "PCC" ? (
            <div className="side-det discountsec">
              <div>Prepaid Card Pass</div>
              <div>
                {"- " + this.props.search.currency}
                {parseInt(this.state.CouponDiscountAmt3, 10)}
              </div>
            </div>
          ) : (
            ""
          )
        }
      </React.Fragment>
    )
  }

  showPass = () => {
    return (
      <React.Fragment>
        {
          this.state.CouponDiscountAmt > 0 && this.state.CouponDiscountType === "PAS" ? (
            <div className="side-det discountsec">
              <div>Pass</div>
              <div>
                {"- " + this.props.search.currency}
                {parseInt(this.state.CouponDiscountAmt, 10)}
              </div>
            </div>
          ) : (
            ""
          )
        }

        {
          this.state.CouponDiscountAmt2 > 0 && this.state.CouponDiscountType2 === "PAS" ? (
            <div className="side-det discountsec">
              <div>Pass</div>
              <div>
                {"- " + this.props.search.currency}
                {parseInt(this.state.CouponDiscountAmt2, 10)}
              </div>
            </div>
          ) : (
            ""
          )
        }

        {
          this.state.CouponDiscountAmt3 > 0 && this.state.CouponDiscountType3 === "PAS" ? (
            <div className="side-det discountsec">
              <div>Pass</div>
              <div>
                {"- " + this.props.search.currency}
                {parseInt(this.state.CouponDiscountAmt3, 10)}
              </div>
            </div>
          ) : (
            ""
          )
        }
      </React.Fragment>
    )
  }

  showCheckoutMarketingCoupon = () => {
    return (
      <React.Fragment>
        {
          this.state.CouponDiscountAmt > 0 && this.state.CouponDiscountType === "EMC" ? (
            <div className="side-det discountsec">
              <div>Checkout Marketing Coupon</div>
              <div>
                {"- " + this.props.search.currency}
                {parseInt(this.state.CouponDiscountAmt, 10)}
              </div>
            </div>
          ) : (
            ""
          )
        }

        {
          this.state.CouponDiscountAmt2 > 0 && this.state.CouponDiscountType2 === "EMC" ? (
            <div className="side-det discountsec">
              <div>Checkout Marketing Coupon</div>
              <div>
                {"- " + this.props.search.currency}
                {parseInt(this.state.CouponDiscountAmt2, 10)}
              </div>
            </div>
          ) : (
            ""
          )
        }

        {
          this.state.CouponDiscountAmt3 > 0 && this.state.CouponDiscountType3 === "EMC" ? (
            <div className="side-det discountsec">
              <div>Checkout Marketing Coupon</div>
              <div>
                {"- " + this.props.search.currency}
                {parseInt(this.state.CouponDiscountAmt3, 10)}
              </div>
            </div>
          ) : (
            ""
          )
        }
      </React.Fragment>
    )
  }

  showDevicePrepaidCard = () => {
    return (
      <React.Fragment>
        {
          this.state.CouponDiscountAmt > 0 && this.state.CouponDiscountType === "DPC" ? (
            <div className="side-det discountsec">
              <div>Device Prepaid Card
              </div>
              <div>
                {"- " + this.props.search.currency}
                {parseInt(this.state.CouponDiscountAmt, 10)}
              </div>
            </div>
          ) : (
            ""
          )
        }

        {
          this.state.CouponDiscountAmt2 > 0 && this.state.CouponDiscountType2 === "DPC" ? (
            <div className="side-det discountsec">
              <div>Device Prepaid Card
              </div>
              <div>
                {"- " + this.props.search.currency}
                {parseInt(this.state.CouponDiscountAmt2, 10)}
              </div>
            </div>
          ) : (
            ""
          )
        }

        {
          this.state.CouponDiscountAmt3 > 0 && this.state.CouponDiscountType3 === "DPC" ? (
            <div className="side-det discountsec">
              <div>Device Prepaid Card
              </div>
              <div>
                {"- " + this.props.search.currency}
                {parseInt(this.state.CouponDiscountAmt3, 10)}
              </div>
            </div>
          ) : (
            ""
          )
        }
      </React.Fragment>
    )
  }

  showDefaultDiscountCoupon = () => {
    return (
      <React.Fragment>
        {
          this.state.CouponDiscountAmt > 0 &&
            (
              this.state.CouponDiscountType != "PC" &&
              this.state.CouponDiscountType != "LW" &&
              this.state.CouponDiscountType != "LT" &&
              this.state.CouponDiscountType != "MC" &&
              this.state.CouponDiscountType != "OT" &&
              this.state.CouponDiscountType != "RC" &&
              this.state.CouponDiscountType != "DC" &&
              this.state.CouponDiscountType != "RT" &&
              this.state.CouponDiscountType != "VT" &&
              this.state.CouponDiscountType != "PCC" &&
              this.state.CouponDiscountType != "PAS" &&
              this.state.CouponDiscountType != "EMC" &&
              this.state.CouponDiscountType != "DPC"
            ) ? (
            <div className="side-det discountsec">
              <div>Discount Coupon
              </div>
              <div>
                {"- " + this.props.search.currency}
                {parseInt(this.state.CouponDiscountAmt, 10)}
              </div>
            </div>
          ) : (
            ""
          )
        }

        {
          this.state.CouponDiscountAmt2 > 0 &&
            (
              this.state.CouponDiscountType2 != "PC" &&
              this.state.CouponDiscountType2 != "LW" &&
              this.state.CouponDiscountType2 != "LT" &&
              this.state.CouponDiscountType2 != "MC" &&
              this.state.CouponDiscountType2 != "OT" &&
              this.state.CouponDiscountType2 != "RC" &&
              this.state.CouponDiscountType2 != "DC" &&
              this.state.CouponDiscountType2 != "RT" &&
              this.state.CouponDiscountType2 != "VT" &&
              this.state.CouponDiscountType2 != "PCC" &&
              this.state.CouponDiscountType2 != "PAS" &&
              this.state.CouponDiscountType2 != "EMC" &&
              this.state.CouponDiscountType2 != "DPC"
            ) ? (
            <div className="side-det discountsec">
              <div>Discount Coupon
              </div>
              <div>
                {"- " + this.props.search.currency}
                {parseInt(this.state.CouponDiscountAmt2, 10)}
              </div>
            </div>
          ) : (
            ""
          )
        }

        {
          this.state.CouponDiscountAmt3 > 0 &&
            (
              this.state.CouponDiscountType3 != "PC" &&
              this.state.CouponDiscountType3 != "LW" &&
              this.state.CouponDiscountType3 != "LT" &&
              this.state.CouponDiscountType3 != "MC" &&
              this.state.CouponDiscountType3 != "OT" &&
              this.state.CouponDiscountType3 != "RC" &&
              this.state.CouponDiscountType3 != "DC" &&
              this.state.CouponDiscountType3 != "RT" &&
              this.state.CouponDiscountType3 != "VT" &&
              this.state.CouponDiscountType3 != "PCC" &&
              this.state.CouponDiscountType3 != "PAS" &&
              this.state.CouponDiscountType3 != "EMC" &&
              this.state.CouponDiscountType3 != "DPC"
            ) ? (
            <div className="side-det discountsec">
              <div>Discount Coupon
              </div>
              <div>
                {"- " + this.props.search.currency}
                {parseInt(this.state.CouponDiscountAmt3, 10)}
              </div>
            </div>
          ) : (
            ""
          )
        }
      </React.Fragment>
    )
  }

  totalDiscountGiven = () => {

    let totDisGiven = this.state.CouponDiscountAmt + this.state.CouponDiscountAmt2 + this.state.CouponDiscountAmt3 + this.state.discount + this.state.roundTripdiscount + this.state.onwardTripSrtConcession + this.state.returnTripSrtConcession;

    if (this.state.isRoundtrip) {

      let otDisAmt = 0;

      if (this.state.CouponDiscountAmt > 0 && this.state.CouponDiscountType === "OT") {
        otDisAmt = this.state.CouponDiscountAmt;
      }

      if (this.state.CouponDiscountAmt2 > 0 && this.state.CouponDiscountType2 === "OT") {
        otDisAmt = this.state.CouponDiscountAmt2;
      }

      if (this.state.CouponDiscountAmt3 > 0 && this.state.CouponDiscountType3 === "OT") {
        otDisAmt = this.state.CouponDiscountAmt3;
      }

      let onwardTripFare = this.state.updatedOnwardFare + this.state.onwardPickcharges + this.state.onwardDropcharges + this.state.onwardInsuranceAmt - this.state.discountAmt - this.state.onwardRoundTripDiscount;

      if (otDisAmt > onwardTripFare) {
        //first remove open ticket discount amount from total discount given 
        totDisGiven = totDisGiven - otDisAmt;
        otDisAmt = onwardTripFare;
        //now add new open ticket discount amount in total discount given
        totDisGiven = totDisGiven + otDisAmt;
      }
    }
    return totDisGiven;
  }

  totalFare = () => {
    var totalFare = 0;
    totalFare =
      this.state.updatedOnwardFare +
      this.state.updatedReturnFare +
      this.state.onwardSc +
      this.state.returnSc +
      this.state.insuranceVal +
      this.state.onwardPickcharges +
      this.state.onwardDropcharges +
      this.state.returnPickcharges +
      this.state.returnDropcharges +
      this.state.onwardTripSrt +
      this.state.returnTripSrt;
    // console.log("totalFare", totalFare);
    return totalFare;
  };

  amountToPayBlock = () => {
    var amountToPay = 0;
    amountToPay =
      this.state.updatedOnwardFare +
      this.state.onwardLevyAmount +
      this.state.returnLevyAmount -
      this.state.onwardConAmt -
      this.state.returnConAmt +
      this.state.updatedReturnFare +
      this.state.onwardSc +
      this.state.returnSc +
      this.state.insuranceVal -
      this.state.roundTripdiscount +
      this.state.onwardPickcharges +
      this.state.onwardDropcharges +
      this.state.returnPickcharges +
      this.state.returnDropcharges +
      this.state.onwardTripSrt -
      this.state.onwardTripSrtConcession +
      this.state.returnTripSrt -
      this.state.returnTripSrtConcession
      - this.state.discount -
      parseInt(
        this.state.CouponDiscountAmt +
        this.state.CouponDiscountAmt2 +
        this.state.CouponDiscountAmt3,
        10
      );

    // console.log("amountToPay", amountToPay);
    // console.log("round", this.state.roundTripdiscount);
    //for roundtrip and discount coupon applied
    if (this.state.isRoundtrip) {

      let otDisAmt = 0;

      if (this.state.CouponDiscountAmt > 0 && this.state.CouponDiscountType === "OT") {
        otDisAmt = this.state.CouponDiscountAmt;
      }

      if (this.state.CouponDiscountAmt2 > 0 && this.state.CouponDiscountType2 === "OT") {
        otDisAmt = this.state.CouponDiscountAmt2;
      }

      if (this.state.CouponDiscountAmt3 > 0 && this.state.CouponDiscountType3 === "OT") {
        otDisAmt = this.state.CouponDiscountAmt3;
      }

      let onwardTripFare = this.state.updatedOnwardFare + this.state.onwardPickcharges + this.state.onwardDropcharges + this.state.onwardInsuranceAmt - this.state.discountAmt - this.state.onwardRoundTripDiscount;

      if (otDisAmt > onwardTripFare) {
        //first add open ticket discount amount in amount to pay
        amountToPay = amountToPay + otDisAmt;
        otDisAmt = onwardTripFare;
        //then remove new open ticket discount amount in amount to pay
        amountToPay = amountToPay - otDisAmt;
      }
    }

    return amountToPay;
  };

  bankChargesCalculationBlock = () => {
    var amountToPay = this.amountToPayBlock();
    var bankCharges = Math.round(
      (this.state.bankChargesPer * amountToPay) / 100
    );
    return bankCharges;
  };

  bankChargesCalculation = () => {
    var bankCharges = this.bankChargesCalculationBlock();
    return (
      <div className="side-det">
        <div>PG Charges</div>
        <div>
          {this.props.search.currency}
          {bankCharges}
        </div>
      </div>
    );
  };

  roundtripdiscount = () => {
    return (
      <div className="side-det">
        <div style={{ width: "80%", display: "inline-block" }}>
          Round Trip Discount&nbsp;
        </div>
        <div
          style={{ width: "20%", display: "inline-block", textAlign: "right" }}
        >
          {this.props.search.currency}
          {this.state.roundTripdiscount}
        </div>
      </div>
    );
  };
  showInsuranceHover = () => {
    return (
      <div className="ins-hover">
        <strong>Free Personal accident Insurance</strong> Coverage of
        Rs.1,00,000/- (Rupees One Lakh) for death or dismemberment during
        journey under Personal Accident Policy from{" "}
        <strong>Tata AIG General Insurance Company Ltd</strong>.
      </div>
    );
  };

  getCrsDateFormatted = (val) => {
    const split = val.split("-");
    return split[0] + " " + split[1] + ", " + split[2];
  };

  checkInsurance = (e, i) => {
    const count =
      this.props.search.order.onward.seats.length +
      (this.props.search.order.return && this.props.search.order.return.seats
        ? this.props.search.order.return.seats.length
        : 0);
    const insurance = this.state.insurance === "on" ? "off" : "on";
    const totalCouponDis = parseInt(
      this.state.CouponDiscountAmt +
      this.state.CouponDiscountAmt2 +
      this.state.CouponDiscountAmt3,
      10
    );

    const insuranceVal = this.state.insurance === "on" ? 0 : count * this.props.search.order.insuranceAmt;

    const onwardInsuranceAmt = this.state.insurance === "on" ? 0 : this.props.search.order.onward.seats.length * this.props.search.order.insuranceAmt;
    const returnInsuranceAmt = this.state.insurance === "on" ? 0 : (this.props.search.order.return && this.props.search.order.return.seats
      ? this.props.search.order.return.seats.length
      : 0) * this.props.search.order.insuranceAmt;

    if (totalCouponDis > 0) {
      this.setState({ loyaltyCoupon: '', prepaidcoupon: '', marketingCoupon: '', redeemCouponsList: '', CouponName: '' }, () => { this.sendOTP() })
    }

    let alertMsg = insurance == "off" ? "You shall not have insurance for your trip." : "";

    this.setState({ insurance, insuranceVal, onwardInsuranceAmt, returnInsuranceAmt, alerterror: alertMsg });

  };

  HandleContactCheck = (e, i) => {
    // console.log("compulsory block cant uncheck");
  };
  showBankChargesConfirmBox = () => {
    var amountToPay = this.amountToPayBlock();
    var bankCharges = this.bankChargesCalculationBlock();
    var totalFare = amountToPay + bankCharges;
    var bankChargeMsg = window.confirm(
      "The bank charges for the option selected is " +
      (this.props.search.currency + bankCharges) +
      ", Total payable amount is " +
      (this.props.search.currency + totalFare)
    );
    return bankChargeMsg;
  };

  savedPassData = () => {
    let that = this;
    const savedSeatDetails = { onward: {}, return: {}, email: '', mobile: '' };
    const savedData = {};
    if (that.state.alredaySelPg) {
      let savedData = that.getSavedData();
      savedSeatDetails.onward.seatDetails = savedData.onward.seatDetails;
    } else {
      savedSeatDetails.onward.seatDetails = that.props.search.order.onward.seatDetails;
    }
    if (that.props.search.order.return) {
      if (that.state.alredaySelPg) {
        let savedData = that.getSavedData();
        savedSeatDetails.return.seatDetails = savedData.return.seatDetails;
      } else {
        savedSeatDetails.return.seatDetails = that.props.search.order.return.seatDetails;
      }
    }
    savedSeatDetails.email = that.state.email;
    savedSeatDetails.mobile = that.state.mobile;
    savedData[that.props.match.params.token] = savedSeatDetails;
    window.localStorage.setItem("savedPassDet", JSON.stringify(savedData));
  }

  getSavedData = () => {
    let that = this;
    let savedPassData = JSON.parse(localStorage.getItem('savedPassDet'));
    savedPassData = savedPassData[that.props.match.params.token]
    return savedPassData;
  }

  checkPayment = () => {
    let that = this;
    let isActive = false;
    const ord =
      this.props.search.order.length !== 0 ? this.props.search.order : false;
    if (ord) {
      let temp = true;
      const onwards = ord.onward.seatDetails;
      Object.keys(onwards).forEach((el) => {
        if (!onwards[el].name || !onwards[el].age || !onwards[el].gender) {
          temp = false;
        }
      });
      if (ord.return && ord.return.seats) {
        const returns = ord.return.seatDetails;
        Object.keys(returns).forEach((el) => {
          if (!returns[el].name || !returns[el].age || !returns[el].gender) {
            temp = false;
          }
        });
      }

      let email = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
        this.state.email
      );
      let countryCode = /^[0-9\-\+]+$/.test(this.state.countryCode);
      let indianMobNo =
        (this.state.mobile + "").length === 10 &&
        /^[0]?[6789]\d{9}$/.test(this.state.mobile);
      let internationalNo =
        (this.state.mobile + "").length < 20 &&
        /^[0-9\-]+$/.test(this.state.mobile);
      let mobile =
        countryCode && this.state.countryCode === "+91"
          ? indianMobNo
          : internationalNo;

      if (temp === false) {
        this.setState({ alerterror: "Please enter passenger details" });
      } else if (!email) {
        this.setState({ alerterror: "Please enter valid email id" });
      } else if (!mobile) {
        this.setState({ alerterror: "Please enter valid mobile no" });
      } else if (!countryCode) {
        this.setState({ alerterror: "Please enter valid country code" });
      }

      if (
        temp &&
        email &&
        this.state.email.length > 0 &&
        mobile &&
        this.checkGst() &&
        countryCode
      ) {
        isActive = true;
        this.setState({ payBtnDisable: true });
      }
    }

    if (isActive) {
      that.setState({ showLoader: true });
      var confirmBox = this.state.bankChargesPer
        ? 'hidePopup'//this.showBankChargesConfirmBox()
        : true;
      if (!confirmBox) {
        this.setState({ payBtnDisable: false, showLoader: false });
        return false;
      }
      const isGenderCheck =
        window.location.search.split("p=").length > 1
          ? window.location.search.split("p=")[1].split("&")[0]
          : false;

      if (isGenderCheck === "1") {
        let counter = 1;
        const routeCode = this.props.search.order.onward.routeCode;
        const loop = this.props.search.order.onward.seatDetails;
        let url =
          window.url + apiUrl.genderValidate + "?RouteCode=" + routeCode;
        Object.keys(loop).forEach((el) => {
          url +=
            "&SeatLabel_" +
            counter +
            "=" +
            el +
            "&Gender_" +
            counter +
            "=" +
            ((loop[el].gender === "Male" || loop[el].gender === "M") ? "M" : (loop[el].gender === "Female" || loop[el].gender === "F") ? "F" : 'O');
          counter++;
        });
        fetchGet(url)
          .then(function (data) {
            const response = JSON.parse(data).APIBooking_GenderValidationResult;
            if (response.Status) {
              that.savedPassData();
              document.getElementById("checkoutForm").submit();
            } else {
              that.setState({
                showLoader: false,
                alerterror: response.ErrorMessage,
              });
              window.history.back();
            }
          })
          .catch(function (error) {
            that.setState({ showLoader: false, alerterror: error });
          });
      } else if (
        this.props.search.order.onward.seatDetails &&
        this.props.search.order.return &&
        this.props.search.order.return.seatDetails
      ) {
        let genderResponse = { onward: false, return: false };
        // let genderError = { onward: false, return: false };

        if (this.props.search.order.onward.seatDetails) {
          let counter = 1;
          const routeCode = this.props.search.order.onward.routeCode;
          const loop = this.props.search.order.onward.seatDetails;
          let url =
            window.url + apiUrl.genderValidate + "?RouteCode=" + routeCode;
          Object.keys(loop).forEach((el) => {
            url +=
              "&SeatLabel_" +
              counter +
              "=" +
              el +
              "&Gender_" +
              counter +
              "=" +
              ((loop[el].gender === "Male" || loop[el].gender === "M") ? "M" : (loop[el].gender === "Female" || loop[el].gender === "F") ? "F" : 'O');
            counter++;
          });
          fetchGet(url)
            .then(function (data) {
              const response = JSON.parse(data)
                .APIBooking_GenderValidationResult;
              if (response.Status) {
                genderResponse.onward = true;
              } else {
                that.setState({
                  showLoader: false,
                  alerterror:
                    "Onward Trip: Seat check validation error. Please change the seat selected and try again.",
                });
                return;
              }
            })
            .catch(function (error) {
              that.setState({ showLoader: false, alerterror: error });
            });
        }

        if (
          this.props.search.order.return &&
          this.props.search.order.return.seatDetails
        ) {
          let counter = 1;
          const routeCode = this.props.search.order.return.routeCode;
          const loop = this.props.search.order.return.seatDetails;
          let url =
            window.url + apiUrl.genderValidate + "?RouteCode=" + routeCode;
          Object.keys(loop).forEach((el) => {
            url +=
              "&SeatLabel_" +
              counter +
              "=" +
              el +
              "&Gender_" +
              counter +
              "=" +
              ((loop[el].gender === "Male" || loop[el].gender === "M") ? "M" : (loop[el].gender === "Female" || loop[el].gender === "F") ? "F" : 'O');
            counter++;
          });
          fetchGet(url)
            .then(function (data) {
              const response = JSON.parse(data)
                .APIBooking_GenderValidationResult;
              if (response.Status) {
                that.savedPassData();
                document.getElementById("checkoutForm").submit();
              } else {
                that.setState({
                  showLoader: false,
                  alerterror:
                    "Return Trip: Seat check validation error. Please change the seat selected and try again.",
                });
                return;
              }
            })
            .catch(function (error) {
              that.setState({ showLoader: false, alerterror: error });
            });
        }
      } else {
        let that = this;
        that.savedPassData();
        document.getElementById("checkoutForm").submit();
      }
    }
  };

  getMobile = () => {
    let mob = this.state.mobile.replace(/\-/g, "");
    const mobNo =
      this.state.countryCode === "+91" ? mob : this.state.countryCode + mob;
    return mobNo;
  };

  showOpDiscountConfirmBox = () => {
    if (this.state.showConfirm) {
      const r = window.confirm(
        "Operator discount has been changed, Do you want to continue with new discount?"
      );
      if (r !== true) {
        const url =
          window.url +
          apiUrl.orderDetails +
          "token=" +
          this.props.match.params.token;
        const that = this;
        fetchGet(url)
          .then(function (data) {
            var info;
            var mode = "";
            if (that.state.updatedReturnFare) {
              info = data.return;
              mode = "roundtrip";
            } else {
              info = data.onward;
              mode = "oneway";
            }
            var fromCityId = info.fromCityId,
              fromCity = info.fromCity,
              toCityId = info.toCityId,
              toCity = info.toCity,
              departDate = getDateForSrch(info.journeyDate),
              rsid = info.routeCode,
              cid = info.companyId;

            that.props.history.push(
              "/search?mode=" +
              mode +
              "&fromCity=" +
              fromCityId +
              "|" +
              fromCity +
              "&toCity=" +
              toCityId +
              "|" +
              toCity +
              "&departDate=" +
              departDate +
              "&returnDate=&" +
              "hop=direct&rsid=" +
              rsid +
              "&cid=" +
              cid +
              "&src=chkhld&e=-1&apiName=crs"
            );
          })
          .catch(function (error) {
            console.log(error);
          });
      }
      this.setState({ showConfirm: false });
    }
  };

  apiCouponListNew = () => {
    let that = this;
    let routeCode = that.props.search.order.onward.routeCode;
    let mobile =
      window.customerProfile && window.customerProfile.MobileNumber
        ? window.customerProfile.MobileNumber
        : that.state.mobile;
    let url =
      window.url +
      apiUrl.couponList +
      "?RouteCode=" +
      routeCode +
      "&MobileNumber=" +
      mobile +
      "&EmailID=&CouponName";
    that.setState({ showLoader: true });
    fetchGet(url)
      .then(function (data) {
        that.setState({ showLoader: false });
        store.dispatch(couponListDetails(data));
        that.setState({ getCouponsDetails: true });
      })
      .catch(function (error) {
        that.setState({ showLoader: false });
        console.log(error);
      });
  };

  loyaltyCouponShowFn = (couponDetails, loyaltyCoupon) => {
    let AllowLoyalty = couponDetails.AllowMultipleCoupon
      ? couponDetails.AllowLoyalty
        ? true
        : false
      : true;
    return (
      <div className="box-container">
        {window.customerProfile &&
          window.customerProfile.MobileNumber &&
          loyaltyCoupon.length !== 0 &&
          AllowLoyalty ? (
          <div>
            {loyaltyCoupon.map((el, index) => {
              let MaxDiscountAmount =
                el.MaxDiscountAmount !== 0
                  ? " upto  " +
                  this.props.search.currency +
                  el.MaxDiscountAmount
                  : "";
              let amtToShow = el.MaxDiscountAmount > 0 ? el.MaxDiscountAmount : el.Balance;
              return (
                <div key={{ index }} className="couponBox">
                  <div className="coupon-details flex-vc flexed-justify">
                    <span className="flex-vc">
                      <Radio
                        checked={
                          couponDetails.AllowMultipleCoupon
                            ? this.state.loyaltyCoupon === el.CouponName
                            : this.state.CouponName === el.CouponName
                        }
                        value={el.CouponName}
                        name={
                          couponDetails.AllowMultipleCoupon
                            ? "loyaltyCoupon"
                            : "coupon"
                        }
                        handleChange={(event) =>
                          this.setState({
                            loyaltyCoupon: event.target.value,
                            CouponName: event.target.value,
                            showCouponName: event.target.value,
                            prepaidcoupon: couponDetails.AllowMultipleCoupon ? this.state.prepaidcoupon : "",
                            marketingCoupon: couponDetails.AllowMultipleCoupon ? this.state.marketingCoupon : "",
                          })
                        }
                        labelStyle={{ height: "15px", width: "15px" }}
                      />
                      <span className="coupon-name flex-vc">
                        {el.CouponName}
                      </span>
                    </span>
                    <span className="coupon-balance">
                      {el.IsPercentage && el.DiscountPct ? el.DiscountPct + "% off" : this.props.search.currency + amtToShow + " off"}
                    </span>
                  </div>
                  <div className="couponType flexed-justify">
                    <span>{el.CouponType}</span>
                    <span
                      className="arrow-icon"
                      onClick={() => this.handleClick("loyaltytnc" + index)}
                    >
                      T&C
                      <span
                        className={
                          this.state.activeTnC === "loyaltytnc" + index
                            ? "arrow up"
                            : "arrow down"
                        }
                      ></span>
                    </span>
                  </div>
                  <div
                    className={
                      this.state.activeTnC === "loyaltytnc" + index
                        ? "show"
                        : "hide"
                    }
                  >
                    <ul>
                      <li>
                        {el.IsPercentage && el.DiscountPct !== 0
                          ? "Discount of " + el.DiscountPct + "%" + MaxDiscountAmount
                          : "Discount upto " + this.props.search.currency + amtToShow + " on ticket amount."}
                      </li>
                      <li>
                        Minimum booking amount:{" "}
                        {el.MinimumBkgAmount !== 0 ? el.MinimumBkgAmount : "NA"}
                      </li>
                      <li>Valid upto {el.EndDate ? el.EndDate : "NA"} </li>
                    </ul>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          "No loyalty coupon available on this mobile no"
        )}
      </div>
    );
  };

  prepaidCouponShowFn = (couponDetails, prepaidCard) => {
    let AllowPrepaidCard = couponDetails.AllowMultipleCoupon
      ? couponDetails.AllowPrepaidCard
        ? true
        : false
      : true;
    return (
      <div className="box-container">
        {prepaidCard.length !== 0 && AllowPrepaidCard ? (
          <div>
            {prepaidCard.map((el, index) => {
              let amtToShow = el.MaxDiscountAmount > 0 ? el.MaxDiscountAmount : el.Balance;
              return (
                <div key={el.CouponName} className="couponBox">
                  <div className="coupon-details flex-vc flexed-justify">
                    <span className="flex-vc">
                      <Radio
                        checked={
                          couponDetails.AllowMultipleCoupon
                            ? this.state.prepaidcoupon === el.CouponName
                            : this.state.CouponName === el.CouponName
                        }
                        value={el.CouponName}
                        name={
                          couponDetails.AllowMultipleCoupon
                            ? "prepaidcoupon"
                            : "coupon"
                        }
                        handleChange={(event) =>
                          this.setState({
                            prepaidcoupon: event.target.value,
                            CouponName: event.target.value,
                            showCouponName: event.target.value,
                            loyaltyCoupon: couponDetails.AllowMultipleCoupon ? this.state.loyaltyCoupon : "",
                            marketingCoupon: couponDetails.AllowMultipleCoupon ? this.state.marketingCoupon : "",
                          })
                        }
                        labelStyle={{ height: "15px", width: "15px" }}
                      />
                      <span className="coupon-name flex-vc">
                        {el.CouponName}
                      </span>
                    </span>
                    <span className="coupon-balance">
                      {el.IsPercentage && el.DiscountPct ? el.DiscountPct + "% off" : this.props.search.currency + amtToShow + " off"}
                    </span>
                  </div>
                  <div className="couponType flexed-justify">
                    <span>{el.CouponType}</span>
                    <span
                      className="arrow-icon"
                      onClick={() => this.handleClick("prepaidtnc" + index)}
                    >
                      T&C
                      <span
                        className={
                          this.state.activeTnC === "prepaidtnc" + index
                            ? "arrow up"
                            : "arrow down"
                        }
                      ></span>
                    </span>
                  </div>
                  <div
                    className={
                      this.state.activeTnC === "prepaidtnc" + index
                        ? "show"
                        : "hide"
                    }
                  >
                    <ul>
                      <li>
                        {el.IsPercentage && el.DiscountPct !== 0 ?
                          'Discount of ' + el.DiscountPct + '%' + (el.MaxDiscountAmount !== 0 ? ' upto ' + this.props.search.currency + el.MaxDiscountAmount : '') :
                          'Discount upto ' + this.props.search.currency + amtToShow + ' on ticket amount.'}
                      </li>
                      <li>
                        Minimum booking amount:{" "}
                        {el.MinimumBkgAmount !== 0 ? el.MinimumBkgAmount : "NA"}
                      </li>
                      <li>Valid upto {el.EndDate} </li>
                      <li>Prepaid card can be consumed partially.</li>
                      <li>Your prepaid card amount will be refunded in case of cancellation after deducting the cancellation amount.</li>
                    </ul>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          "No prepaid card available on this mobile no"
        )}
      </div>
    );
  };

  discountCouponShowFn = (couponDetails, marketingCoupon) => {
    let AllowAnyOtherCoupon = couponDetails.AllowMultipleCoupon
      ? couponDetails.AllowAnyOtherCoupon
        ? true
        : false
      : true;

    let bookingType = this.state.bookingType;

    return (
      <div className="box-container">
        {marketingCoupon.length !== 0 && AllowAnyOtherCoupon ? (
          <div>
            {marketingCoupon.map((el, index) => {
              let MaxDiscountAmount =
                el.MaxDiscountAmount !== 0
                  ? " upto  " +
                  this.props.search.currency +
                  el.MaxDiscountAmount
                  : "";

              let amtToShow = el.MaxDiscountAmount > 0 ? el.MaxDiscountAmount : el.Balance;

              let showCouponBox = true;
              if (el.CouponType === "Express Checkout Marketing Coupon" && bookingType !== "autoExpCo") {
                showCouponBox = false;
              }

              if (showCouponBox) {
                return (
                  <div key={{ index }} className="couponBox">
                    <div className="coupon-details flex-vc flexed-justify">
                      <span className="flex-vc">
                        <Radio
                          checked={
                            couponDetails.AllowMultipleCoupon
                              ? this.state.marketingCoupon === el.CouponName
                              : this.state.CouponName === el.CouponName
                          }
                          value={el.CouponName}
                          name={
                            couponDetails.AllowMultipleCoupon
                              ? "marketingCoupon"
                              : "coupon"
                          }
                          handleChange={(event) =>
                            this.setState({
                              marketingCoupon: event.target.value,
                              CouponName: event.target.value,
                              showCouponName: event.target.value,
                              loyaltyCoupon: couponDetails.AllowMultipleCoupon ? this.state.loyaltyCoupon : "",
                              prepaidcoupon: couponDetails.AllowMultipleCoupon ? this.state.prepaidcoupon : "",
                            })
                          }
                          labelStyle={{ height: "15px", width: "15px" }}
                        />
                        <span className="coupon-name flex-vc">
                          {el.CouponName}
                        </span>
                      </span>
                      <span className="coupon-balance">
                        {el.IsPercentage && el.DiscountPct
                          ? el.DiscountPct + "% off"
                          : this.props.search.currency + amtToShow + " off"}
                      </span>
                    </div>
                    <div className="couponType flexed-justify">
                      <span>{el.CouponType}</span>
                      <span
                        className="arrow-icon"
                        onClick={() => this.handleClick("marketingtnc" + index)}
                      >
                        T&C
                        <span
                          className={
                            this.state.activeTnC === "marketingtnc" + index
                              ? "arrow up"
                              : "arrow down"
                          }
                        ></span>
                      </span>
                    </div>
                    <div
                      className={
                        this.state.activeTnC === "marketingtnc" + index
                          ? "show"
                          : "hide"
                      }
                    >
                      <ul>
                        <li>
                          {el.IsPercentage && el.DiscountPct !== 0 ?
                            'Discount of ' + el.DiscountPct + '%' + (el.MaxDiscountAmount !== 0 ? ' upto ' + this.props.search.currency + el.MaxDiscountAmount : '') :
                            'Discount upto ' + this.props.search.currency + amtToShow + ' on ticket amount.'}
                        </li>
                        <li>
                          Minimum booking amount:{" "}
                          {el.MinimumBkgAmount !== 0 ? el.MinimumBkgAmount : "NA"}
                        </li>
                        <li>Valid upto {el.EndDate ? el.EndDate : "NA"} </li>
                        <li>Only one discount coupon can be used in one booking.</li>
                        <li>This is a one time use coupon.</li>
                        <li>No refund for the unused amount of the coupon will be given.</li>
                        <li>In case of round trips, discount coupon will only apply on onward journey.</li>
                      </ul>
                    </div>
                  </div>
                );
              } else {
                return ("");
              }
            })}
          </div>
        ) : (
          "No discount coupon available on this mobile no"
        )}
      </div>
    );
  };

  showCouponFn = () => {
    return (
      <div className="coupon-applied-wrapper">
        <div className="coupon-applied">Selected Coupon</div>
        <div className="coupon-div-wrapper">
          <div className="coupon-show-wrapper">
            {this.state.loyaltyCoupon ? (
              <div className="cpn-wrap">
                <span style={{ background: "#ddd" }}>
                  {this.state.loyaltyCoupon}
                </span>
                <span
                  className="crsrpointer"
                  style={{
                    background: color.primary,
                    color: "#fff",
                  }}
                  onClick={() => {
                    this.setState({ loyaltyCoupon: "", removeCoupon: true, removeCouponName: this.state.loyaltyCoupon }, () => {
                      this.sendOTP();
                    });
                  }}
                >
                  X
                </span>
              </div>
            ) : (
              ""
            )}
            {this.state.prepaidcoupon ? (
              <div className="cpn-wrap">
                <span style={{ background: "#ddd" }}>
                  {this.state.prepaidcoupon}
                </span>
                <span
                  className="crsrpointer"
                  style={{
                    background: color.primary,
                    color: "#fff",
                  }}
                  onClick={() => {
                    this.setState({ prepaidcoupon: "", removeCoupon: true, removeCouponName: this.state.prepaidcoupon }, () => {
                      this.sendOTP();
                    });
                  }}
                >
                  X
                </span>
              </div>
            ) : (
              ""
            )}
            {this.state.marketingCoupon ? (
              <div className="cpn-wrap">
                <span style={{ background: "#ddd" }}>
                  {this.state.marketingCoupon}
                </span>
                <span
                  style={{
                    background: color.primary,
                    color: "#fff",
                  }}
                  className="crsrpointer"
                  onClick={() => {
                    this.setState({ marketingCoupon: "", removeCoupon: true, removeCouponName: this.state.marketingCoupon }, () => {
                      this.sendOTP();
                    });
                  }}
                >
                  X
                </span>
              </div>
            ) : (
              ""
            )}
          </div>
          <div
            className="redeemCouponButton"
            onClick={() => {
              this.sendOTP();
              this.setState({
                couponDiscount: 0,
                CouponDiscountAmt: 0,
                CouponDiscountAmt2: 0,
                CouponDiscountAmt3: 0,
                CouponID: "",
                CouponID2: "",
                CouponID3: "",
                validCouponName: "",
              });
            }}
          >
            REDEEM
          </div>
        </div>
      </div>
    );
  };

  showCouponSection = () => {
    let that = this;
    const couponDetails = that.props.search.couponDetails;
    const loop = couponDetails.CouponsWithBalance;
    let prepaidCard = [];
    let loyaltyCoupon = [];
    let marketingCoupon = [];

    if (Object.keys(loop).length !== 0) {
      loop.map((el, index) => {
        if (el.CouponType === "Prepaid Card") {
          prepaidCard.push(el);
        } else if (
          el.CouponType === "Loyalty" ||
          el.CouponType === "Loyalty Wallet"
        ) {
          loyaltyCoupon.push(el);
        } else {
          marketingCoupon.push(el);
        }
      });
      return (
        <div className="flex">
          <div className="coupon-type-container">
            <div
              className={
                that.state.activeCouponType === "prepaid"
                  ? "active flex-vc"
                  : "coupon-type crsrpointer flex-vc"
              }
              onClick={() => {
                that.setState({
                  activeCouponType: "prepaid",
                  prepaidCouponShow: 1,
                  loyaltyCouponShow: 0,
                  discountCouponShow: 0,
                });
              }}
            >
              <Radio
                checked={that.state.activeCouponType === "prepaid"}
                labelMargin="0"
                readOnly={true}
                labelStyle={{ cursor: "pointer" }}
              />
              PREPAID CARD
            </div>

            <div
              className={
                that.state.activeCouponType === "loyalty"
                  ? "active flex-vc"
                  : "coupon-type crsrpointer flex-vc"
              }
              onClick={() => {
                that.setState({
                  activeCouponType: "loyalty",
                  loyaltyCouponShow: 1,
                  prepaidCouponShow: 0,
                  discountCouponShow: 0,
                });
              }}
            >
              <Radio
                checked={that.state.activeCouponType === "loyalty"}
                labelMargin="0"
                readOnly={true}
                labelStyle={{ cursor: "pointer" }}
              />
              LOYALTY WALLET
            </div>
            <div
              className={
                that.state.activeCouponType === "marketing"
                  ? "active flex-vc"
                  : "coupon-type crsrpointer flex-vc"
              }
              onClick={() => {
                that.setState({
                  activeCouponType: "marketing",
                  discountCouponShow: 1,
                  loyaltyCouponShow: 0,
                  prepaidCouponShow: 0,
                });
              }}
            >
              <Radio
                checked={that.state.activeCouponType === "marketing"}
                labelMargin="0"
                readOnly={true}
                labelStyle={{ cursor: "pointer" }}
              />
              DISCOUNT COUPON
            </div>
          </div>
          <div className="coupon-div-container">
            {that.state.loyaltyCoupon ||
              that.state.prepaidcoupon ||
              that.state.marketingCoupon
              ? that.showCouponFn()
              : ""}
            {that.state.loyaltyCouponShow
              ? that.loyaltyCouponShowFn(couponDetails, loyaltyCoupon)
              : ""}
            {that.state.prepaidCouponShow
              ? that.prepaidCouponShowFn(couponDetails, prepaidCard)
              : ""}
            {that.state.discountCouponShow
              ? that.discountCouponShowFn(couponDetails, marketingCoupon)
              : ""}
          </div>
        </div>
      );
    } else {
      return (
        <div className="card">
          Sorry! No Coupons available on this mobile no
        </div>
      );
    }
  };
  showLoginButton = () => {
    return (
      <div className="login-text flex-all-c">
        {renderImg('GiftIcon')}
        Login / Signup to view coupons
      </div>
    );
  };
  showCouponBlock = () => {
    return (
      <div
        className="showcoupon flex-all-c crsrpointer"
        onClick={() => {
          this.setState({ showCouponBlock: true, showPayeeBlock: false });
        }}
      >
        Show coupons
      </div>
    );
  };
  showaertdialogue = () => {
    setTimeout(() => {
      this.setState({ alerterror: "" });
    }, 5000);
    return (
      <div
        className="blacklayer"
        onClick={() => {
          this.setState({ alerterror: "" });
        }}
      >
        <div className="popupbox">
          {/* <div className="circle pixedpos logo-box">
            <GsbLogoBold />
          </div> */}
          <div className="alertmsg">{this.state.alerterror}</div>
          <button
            className="alertbuttonok crsrpointer"
            onClick={() => {
              this.setState({ alerterror: "" });
            }}
          >
            OK{" "}
          </button>
        </div>
      </div>
    );
  };
  showKsrtcFarelabel = () => {
    const returnTrip = this.props.search.order.length !== 0 && this.props.search.order.return &&
      this.props.search.order.return.seats;
    const urlParams = new URLSearchParams(window.location.search);
    const linkfromstoptocity = urlParams.get("linkfromstoptocity");
    return (
      <React.Fragment>
        <div
          className="side-info fare">
          <div className="side-det">
            <div style={{ width: "80%", display: "inline-block" }}>
              {`${linkfromstoptocity ? 'Start' : 'Onward'}`} Trip SRT Value&nbsp;
            </div>
            <div
              style={{
                width: "20%",
                display: "inline-block",
                textAlign: "right",
              }}
            >
              {this.props.search.currency}
              {this.state.onwardTripSrt}
            </div>
          </div>
        </div>

        {this.state.onwardTripSrtConcession > 0 && <div
          className="side-info fare" style={{ backgroundColor: '#E8F7ED' }}>
          <div className="side-det">
            <div style={{ width: "80%", display: "inline-block" }}>
              {`${linkfromstoptocity ? 'Start' : 'Onward'}`} Trip Concession Amount&nbsp;
            </div>
            <div
              style={{
                width: "20%",
                display: "inline-block",
                textAlign: "right",
              }}
            >
              {"-"}{this.props.search.currency}
              {this.state.onwardTripSrtConcession}
            </div>
          </div>
        </div>
        }

        {returnTrip &&
          <div
            className="side-info fare">
            <div className="side-det">
              <div style={{ width: "80%", display: "inline-block" }}>
                {`${linkfromstoptocity ? 'Connect' : 'Return'}`} Trip SRT Value&nbsp;
              </div>
              <div
                style={{
                  width: "20%",
                  display: "inline-block",
                  textAlign: "right",
                }}
              >
                {this.props.search.currency}
                {this.state.returnTripSrt}
              </div>
            </div>
          </div>
        }
        {
          returnTrip && this.state.returnTripSrtConcession > 0 &&
          <div
            className="side-info fare" style={{ backgroundColor: '#E8F7ED' }}>
            <div className="side-det">
              <div style={{ width: "80%", display: "inline-block" }}>
                {`${linkfromstoptocity ? 'Connect' : 'Return'}`} Trip Concession Amount&nbsp;
              </div>
              <div
                style={{
                  width: "20%",
                  display: "inline-block",
                  textAlign: "right",
                }}
              >
                {"-"}{this.props.search.currency}
                {this.state.returnTripSrtConcession}
              </div>
            </div>
          </div>
        }
        {/* <div
          className="side-info fare">
          <div className="side-det">
            <div style={{ width: "80%", display: "inline-block" }}>
              Total Ticket Amount&nbsp;
            </div>
            <div
              style={{
                width: "20%",
                display: "inline-block",
                textAlign: "right",
              }}
            >
              <span>{this.amountToPayBlock() !== this.totalFare() && <strike>{this.props.search.currency}{this.totalFare()}</strike>}</span>
              {this.props.search.currency}{this.amountToPayBlock()}
            </div>
          </div>
        </div> */}
        {/* <div
          className="side-info fare">
          <div className="side-det">
            <div style={{ width: "80%", display: "inline-block" }}>
              Payment Gateway Charges&nbsp;
            </div>
            <div
              style={{
                width: "20%",
                display: "inline-block",
                textAlign: "right",
              }}
            >
              {this.props.search.currency}{0}
            </div>
          </div>
        </div> */}
      </React.Fragment>
    )
  }
  HandleTandCCheck = () => {
    let checkTandC = this.state.checkTandC;
    this.setState({ checkTandC: !checkTandC, payopt: '', bankChargesPer: 0 })
  }

  updateUrl = (page) => {
    const pathname = window.location.pathname;
    const queryParam = window.location.search;
    let url = pathname + queryParam;
    if (page === 'payment') {
      url = pathname + queryParam.split('&')[0] + '&page=payment';
    } else {
      url = pathname + queryParam.split('&')[0];
    }
    this.props.history.push(url);
  }

  handlePayee = () => {

    this.validatePayeeDetail() && [
      // this.updateUrl("payment"),
      this.setState({
        activeNavTab: "passengerlist",
        payeedetail: true,
      })
    ]
  }

  render() {
    // console.log("order", this.props.search.order)
    // console.log("onwardConcessionUsed", this.state.onwardConcessionUsed);
    // console.log("onwardLevyConcDetails", this.props.search.levyandConcData);
    // console.log("updatedOnwardFare", this.state.updatedOnwardFare);
    // console.log("updatedRetrunFare", this.state.updatedReturnFare);

    let that = this;
    that.showOpDiscountConfirmBox();
    let amountToPay = 0;
    amountToPay =
      that.state.updatedOnwardFare +
      that.state.updatedReturnFare +
      that.state.onwardSc +
      that.state.returnSc +
      that.state.onwardGst +
      that.state.returnGst +
      this.state.onwardPickcharges +
      this.state.onwardDropcharges +
      this.state.returnPickcharges +
      this.state.returnDropcharges -
      this.state.roundTripdiscount +
      that.state.insuranceVal -
      that.state.discount -
      parseInt(
        that.state.CouponDiscountAmt +
        that.state.CouponDiscountAmt2 +
        that.state.CouponDiscountAmt3,
        10
      );
    var bankCharges = Math.ceil(
      (that.state.bankChargesPer * amountToPay) / 100
    );

    return (
      <div key="checkoutpage">
        {/* {window.msurl === 'shrinath.biz' ? <HeaderSTA /> : <Header />} */}
        <HeaderNew />
        {that.state.alerterror !== "" ? that.showaertdialogue() : ""}
        <section className="checkout-wrapper" key="checkout-wrapper">
          <div className="left-div" key="3ss">
            <form
              key="dssfd"
              id="checkoutForm"
              method="POST"
              action={window.url + "/co/confirm"}
            >
              <input type="hidden" name="query" value={that.state.queryData} />
              <input
                type="hidden"
                name="o"
                id="o"
                value={that.props.match.params.token}
              />
              <input type="hidden" name="owo" value="0" />
              <input type="hidden" name="method" id="method" value="1" />
              <input type="hidden" name="provider" id="provider" value="1" />
              <input
                type="hidden"
                name="hd_charges"
                id="hd_charges"
                value="0"
              />
              <input
                type="hidden"
                name="coupon"
                id="coupon"
                value={this.state.validCouponName}
              />
              <input
                type="hidden"
                name="mobile"
                id="mobile"
                value={that.getMobile()}
              />
              <input
                type="hidden"
                name="couponID"
                id="couponID"
                value={that.state.CouponID}
              />
              <input
                type="hidden"
                name="couponID2"
                id="couponID2"
                value={that.state.CouponID2}
              />
              <input
                type="hidden"
                name="couponID3"
                id="couponID3"
                value={that.state.CouponID3}
              />
              <input
                type="hidden"
                name="couponAmount"
                id="couponAmount"
                value={that.state.CouponDiscountAmt}
              />
              <input
                type="hidden"
                name="couponAmount2"
                id="couponAmount2"
                value={that.state.CouponDiscountAmt2}
              />
              <input
                type="hidden"
                name="couponAmount3"
                id="couponAmount3"
                value={that.state.CouponDiscountAmt3}
              />
              {that.props.search.order.showInsurance && (
                <input
                  type="hidden"
                  name="insurance"
                  value={that.state.insurance}
                />
              )}
              <input type="hidden" name="PGType" value={this.state.payopt} />
              <div className="tdnav flex">

                <div
                  className={`tdnav-item crsrpointer flex-all-c border-lr ${this.state.activeNavTab === "userdetail" ? "activenav" : ""
                    } ${this.state.payeedetail ? "donesec" : ""}`}
                  onClick={() => {
                    // this.state.travellerlist && [
                    // this.updateUrl('userdetail'),
                    this.setState({ activeNavTab: "userdetail" })
                    // ]
                  }}
                >
                  {this.state.payeedetail && (
                    <span className="greentickmark"></span>
                  )}
                  1. Customer Details
                </div>

                <div
                  className={`tdnav-item crsrpointer flex-all-c ${this.state.activeNavTab === "passengerlist" ||
                    this.state.activeNavTab === ""
                    ? "activenav"
                    : ""
                    } ${this.state.travellerlist ? "donesec" : ""}`}
                  onClick={() => {

                    this.state.travellerlist && [
                      // this.updateUrl('userdetail'),
                      this.setState({ activeNavTab: "passengerlist" })]

                  }}
                >
                  {this.state.travellerlist && (
                    <span className="greentickmark"></span>
                  )}
                  2. Passenger Detail
                </div>
                <div
                  className={`tdnav-item crsrpointer flex-all-c ${this.state.activeNavTab === "payment" ? "activenav" : ""
                    }`}
                  onClick={() => {
                    this.state.payeedetail && this.state.travellerlist && [
                      // this.updateUrl('payment'),
                      this.setState({ activeNavTab: "payment" })]
                  }}
                >
                  3. Payment Gateway
                </div>
              </div>

              <div key="334sa43">
                <div
                  className={
                    this.state.activeNavTab === "userdetail"
                      ? "block"
                      : "inactive"
                  }
                >
                  {that.enterContactDetails()}
                  {that.state.isMobile === 1 ? that.showCoupon() : ""}
                  {that.state.redeemCoupon === true && !window.customerProfile
                    ? that.showOTP()
                    : ""}
                  <div
                    className="navswitchbtn flex-all-c"
                    onClick={this.handlePayee}
                  >
                    {/* PROCEED TO PAYMENT OPTIONS */}
                    PROCEED TO passenger detail as guest user
                  </div>
                </div>
                <div
                  key="was43"
                  className={
                    this.state.activeNavTab === "" ||
                      this.state.activeNavTab === "passengerlist"
                      ? "block"
                      : "inactive"
                  }
                >
                  <div className="card" key="passngerdeatils">
                    {that.enterPassDetailsOnwards()}
                    {that.props.search.order.length !== 0 &&
                      that.props.search.order.return &&
                      that.props.search.order.return.seats
                      ? that.enterPassDetailsReturn()
                      : ""}
                  </div>

                  <div
                    className={`navswitchbtn flex-all-c`}
                    onClick={() => {
                      this.validatepassngerlist(true) && [
                        this.storeInLocal(),
                        this.loggedinCouponDetails(),
                        // this.updateUrl("userdetail"),
                        this.setState({
                          activeNavTab: "payment",
                          travellerlist: true,
                        }),
                      ];
                    }}
                  >
                    PROCEED TO payment options
                    {/* {!this.state.getCouponsDetails ? 'PROCEED TO PAYEE DETAILS' : 'PROCEED TO PAYEE & DISCOUNT DETAILS'} */}
                  </div>
                </div>
                <div
                  className={
                    this.state.activeNavTab === "payment" ? "block" : "inactive"
                  }
                >
                  {that.selPaymentOption()}
                </div>
              </div>
            </form>
          </div>
          <div className="right-div">
            <div className="tdnav flex">
              <div
                className={`rt-item flex-all-c ${this.state.activeRtTab === "farebreakup" ? "activenav" : ""
                  }`}
                onClick={() => {
                  this.setState({ activeRtTab: "farebreakup" });
                }}
              >
                Fare Breakup
              </div>
              <div
                className={`rt-item flex-all-c ${this.state.activeRtTab === "bookingdetail" ? "activenav" : ""
                  }`}
                onClick={() => {
                  this.setState({ activeRtTab: "bookingdetail" });
                }}
              >
                Booking Details
              </div>
            </div>
            <div>
              <div
                className={
                  this.state.activeRtTab === "" ||
                    this.state.activeRtTab === "farebreakup"
                    ? "block"
                    : "inactive"
                }
              >
                <div className="card">
                  <div className="onwarddata">
                    {/* <div className="fare-header flex-vc flexed-justify">
                      <div className="item-desc">Item desc</div>
                      <div className="basefare">Base Fare</div>
                      <div className="gst">GST</div>
                      <div className="total">Total</div>
                    </div> */}
                    {/* {that.showOnwardPassDetails()} */}
                    {/* {that.showKsrtcOnwardPassDetails()} */}
                    {that.showKASRTConwardFaredetails(that.props.search.order)}
                    {/*that.showOnwardFareDetails()*/}
                  </div>
                  <div className="returndata">
                    {that.props.search.order.length !== 0 &&
                      that.props.search.order.return &&
                      that.props.search.order.return.seats
                      ? [that.showKASRTCreturnFaredetails(that.props.search.order)]
                      : ""}
                  </div>
                  {/* {that.showKsrtcFarelabel()} */}
                  {this.state.onwardPickcharges + this.state.onwardDropcharges + this.state.returnPickcharges + this.state.returnDropcharges !== 0 ? (
                    <div
                      className="side-info fare">
                      <div className="side-det">
                        <div style={{ width: "80%", display: "inline-block" }}>
                          Pickup / Drop Charges&nbsp;
                        </div>
                        <div
                          style={{
                            width: "20%",
                            display: "inline-block",
                            textAlign: "right",
                          }}
                        >
                          {this.props.search.currency}
                          {this.state.onwardPickcharges + this.state.onwardDropcharges + this.state.returnPickcharges + this.state.returnDropcharges}
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

                  {this.state.showServiceCharge && (this.state.onwardSc + this.state.returnSc) > 0 ? (
                    <div
                      className="side-info fare">
                      <div className="side-det">
                        <div style={{ width: "80%", display: "inline-block" }}>
                          Service Charge&nbsp;
                        </div>
                        <div
                          style={{
                            width: "20%",
                            display: "inline-block",
                            textAlign: "right",
                          }}
                        >
                          {this.props.search.currency}
                          {this.state.onwardSc + this.state.returnSc}
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

                  {this.state.onwardConvenienceCharge + this.state.returnConvenienceCharge !== 0 ? (
                    <div
                      className="side-info fare">
                      <div className="side-det">
                        <div style={{ width: "80%", display: "inline-block" }}>
                          Convenience Charge&nbsp;
                        </div>
                        <div
                          style={{
                            width: "20%",
                            display: "inline-block",
                            textAlign: "right",
                          }}
                        >
                          {this.props.search.currency}
                          {this.state.onwardConvenienceCharge + this.state.returnConvenienceCharge}
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

                  {this.props.search.order.showInsurance ? (
                    <div
                      className="side-info fare">
                      <div className="side-det">
                        <div>Travel Insurance</div>
                        <div>
                          {this.props.search.currency}
                          {this.state.insuranceVal}
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

                  {this.totalDiscountGiven() > 0 ? (
                    <div className="side-info fare" style={{ borderTop: "solid 1px #ddd" }}></div>
                  ) : (
                    ""
                  )}

                  {that.showPrepaidCardDiscount()}
                  {that.showLoyaltyWalletDiscount()}
                  {that.showLoyaltyDiscount()}
                  {that.showMarketingCoupon()}
                  {that.showOpenTicketCoupon()}
                  {that.showReferralCoupon()}
                  {that.showDiscountCoupon()}
                  {that.showRoundTripCoupon()}
                  {that.showVoucherType()}
                  {that.showPrepaidCardPass()}
                  {that.showPass()}
                  {that.showCheckoutMarketingCoupon()}
                  {that.showDevicePrepaidCard()}
                  {that.showDefaultDiscountCoupon()}
                  {/* 
                  {this.state.discount > 0 ? (
                    <div
                      className="side-info fare">
                      <div className="side-det">
                        <div>Trip Discount</div>
                        <div>
                          {"- " + this.props.search.currency}
                          {this.state.discount}
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )} */}

                  {/* {this.state.onwardRoundTripDiscount > 0 ? (
                    <div
                      className="side-info fare">
                      <div className="side-det">
                        <div>Round Trip Discount - Onward</div>
                        <div>
                          {"- " + this.props.search.currency}
                          {this.state.onwardRoundTripDiscount}
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )} */}

                  {/* {this.state.returnRoundTripDiscount > 0 ? (
                    <div
                      className="side-info fare">
                      <div className="side-det">
                        <div>Round Trip Discount - Return</div>
                        <div>
                          {"- " + this.props.search.currency}
                          {this.state.returnRoundTripDiscount}
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )} */}

                  {/* {this.totalDiscountGiven() > 0 ? (
                    <div
                      className="side-info fare totdis">
                      <div className="side-det">
                        <div>Total Discount Given</div>
                        <div>
                          {"- " + this.props.search.currency}
                          {this.totalDiscountGiven()}
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )} */}
                  {/* {
                    this.state.payopt && <div className="side-info fare">
                      {this.bankChargesCalculation()}
                    </div>
                  } */}
                  {/* <div className="total-fare">
                    <div>Total Amount To Be Paid</div>
                    <div>
                      <span style={{ fontWeight: '500', marginRight: '10px' }}>
                        {this.amountToPayBlock() !== this.totalFare() && <strike>{that.props.search.currency}{this.totalFare() + this.bankChargesCalculationBlock()}</strike>}
                      </span>
                      {that.props.search.currency}{this.amountToPayBlock() + this.bankChargesCalculationBlock()}
                    </div>
                  </div> */}

                </div>
                <div className="final--amount--paid"
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    background: '#fff',
                    height: '70px',
                    fontWeight: '600',
                    borderRadius: ' 0 0 6px 6px',
                    color: '#FF7100',
                    padding: '0 25px',
                    alignItems: 'center',
                    borderTop: '1px solid rgba(0,0,0,0.2)'
                  }}>
                  <div>ಪಾವತಿಸಬೇಕಾದ ಮೊತ್ತ / Amount to be Paid</div>
                  <div>{that.props.search.currency}{this.amountToPayBlock() + this.bankChargesCalculationBlock()}</div>
                </div>
              </div>
              <div
                className={
                  this.state.activeRtTab === "bookingdetail"
                    ? "block"
                    : "inactive"
                }
              >
                <div className="card">
                  {that.showOnwardTripDetails()}
                  {that.props.search.order.length !== 0 &&
                    that.props.search.order.return &&
                    that.props.search.order.return.seats
                    ? that.showReturnTripDetails()
                    : ""}
                </div>
                {/* <div className="infoswitchbtn flex-vc">
                  <div className="flex-vc" style={{ filter: "grayscale(1)" }}>
                    <Check
                      value={this.state.insurance}
                      checked={true}
                      handleChange={this.HandleContactCheck}
                      style={{ padding: "1px 5px" }}
                    />
                    *Payee agree to be contacted on mobile ( even if its DND) and email for
                    all types of messages and calls
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </section>
        {window.msurl === 'shrinath.biz' ? <FooterSTA /> : <Footer />}
        {that.state.showLoader ? (
          <div className="show-load">
            <div className="loading">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}

const mapStateToProps = function (store) {
  return store;
};

export default connect(mapStateToProps)(Checkout);
